
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("a5txT", function(module, exports) {

var $7xVCs = parcelRequire("7xVCs");

const $82982cff56793d8b$var$standalonePageTreeStateUpdater = new (0, $7xVCs.PageTreeStateUpdater)();
const $82982cff56793d8b$export$19e3952b1a66ecb = ()=>$82982cff56793d8b$var$standalonePageTreeStateUpdater;
module.exports["getStandalonePageTreeStateUpdater"] = $82982cff56793d8b$export$19e3952b1a66ecb;

});

parcelRegister("7xVCs", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $T1bCI = parcelRequire("T1bCI");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $T1bCI.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("30qWc", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $308Wd = parcelRequire("308Wd");

const $9acca7871dfd8a5c$export$a59d7e865b63a081 = (0, $3u0dr.isReactCompilerActiveV2)() ? function MutationInterop(t0) {
    const $ = (0, $frIzR.c)(8);
    let children;
    let mutation;
    let props;
    if ($[0] !== t0) {
        ({ children: children, mutation: mutation, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = mutation;
        $[3] = props;
    } else {
        children = $[1];
        mutation = $[2];
        props = $[3];
    }
    const [mutate, result] = (0, $308Wd.useMutationInterop)(mutation, props);
    let t1;
    if ($[4] !== children || $[5] !== mutate || $[6] !== result) {
        t1 = children(mutate, result);
        $[4] = children;
        $[5] = mutate;
        $[6] = result;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
} : function MutationInterop({ children: children, mutation: mutation, ...props }) {
    const [mutate, result] = (0, $308Wd.useMutationInterop)(mutation, props);
    return children(mutate, result);
};
module.exports["MutationInterop"] = $9acca7871dfd8a5c$export$a59d7e865b63a081;

});

parcelRegister("b1HmN", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $80716d6d5be0d4f0$export$fff6e0d8ba6c4cc6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ishvT",
    name: "LoadableChangeEditionNotificationDialog",
    loader: async ()=>(await (parcelRequire("kHp2S"))).ChangeEditionNotificationDialog
});
module.exports["LoadableChangeEditionNotificationDialog"] = $80716d6d5be0d4f0$export$fff6e0d8ba6c4cc6;

});

parcelRegister("kHp2S", function(module, exports) {

let $f11b404c5fa8cafa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f11b404c5fa8cafa$var$load("hhss7"),
    $f11b404c5fa8cafa$var$load("kSVGa")
]).then(()=>parcelRequire('5BDEU'));

});

parcelRegister("hDG7z", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gz8ZY = parcelRequire("gz8ZY");


var $cgEsw = parcelRequire("cgEsw");


var $jbuqY = parcelRequire("jbuqY");

const $c8aadc7c03a52230$export$6d1402fb58384e4f = (props)=>{
    const $ = (0, $frIzR.c)(3);
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    let t0;
    if ($[0] !== isNav4Enabled || $[1] !== props) {
        t0 = isNav4Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cgEsw.Nav4Layout), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jbuqY.Nav3Layout), props);
        $[0] = isNav4Enabled;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
module.exports["PageLayout"] = $c8aadc7c03a52230$export$6d1402fb58384e4f;

});

parcelRegister("gz8ZY", function(module, exports) {
/**----------------!!!!!!!!!!!!!!!!!!!!!!----------------------------
*   When Changing this file ensure you keep the pure function version
*              getIsNav4Enabled.ts in sync as well!
 -----------------!!!!!!!!!!!!!!!!!!!!!!!--------------------------*/ // eslint-disable-next-line confluence-feature-gating/inline-usage
const $90a9f787a509158d$export$22793b194a2253b9 = ()=>{
    return true;
};
module.exports["useIsNav4Enabled"] = $90a9f787a509158d$export$22793b194a2253b9;

});

parcelRegister("cgEsw", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $acf3be568142fa4d$export$25b68ac96f2af713 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Y6119",
    name: "Nav4Layout",
    loader: async ()=>(await (parcelRequire("404LQ"))).PageLayout
});
module.exports["Nav4Layout"] = $acf3be568142fa4d$export$25b68ac96f2af713;

});

parcelRegister("404LQ", function(module, exports) {

let $2e9adce4ca1ed62c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2e9adce4ca1ed62c$var$load("lu4e5"),
    $2e9adce4ca1ed62c$var$load("keCTf"),
    $2e9adce4ca1ed62c$var$load("av6T2"),
    $2e9adce4ca1ed62c$var$load("d5xSh"),
    $2e9adce4ca1ed62c$var$load("kzLFa"),
    $2e9adce4ca1ed62c$var$load("fuKGN"),
    $2e9adce4ca1ed62c$var$load("4IYLb"),
    $2e9adce4ca1ed62c$var$load("2eTjQ"),
    $2e9adce4ca1ed62c$var$load("xlj4N"),
    $2e9adce4ca1ed62c$var$load("kWL2K"),
    $2e9adce4ca1ed62c$var$load("3Kg3S"),
    $2e9adce4ca1ed62c$var$load("gPjUw"),
    $2e9adce4ca1ed62c$var$load("4wwg7"),
    $2e9adce4ca1ed62c$var$load("dvZ6G"),
    $2e9adce4ca1ed62c$var$load("bzLZJ"),
    $2e9adce4ca1ed62c$var$load("9GMEV"),
    $2e9adce4ca1ed62c$var$load("g8jRY"),
    $2e9adce4ca1ed62c$var$load("84LYM"),
    $2e9adce4ca1ed62c$var$load("1aPQ5"),
    $2e9adce4ca1ed62c$var$load("4YwES"),
    $2e9adce4ca1ed62c$var$load("2Xd3I"),
    $2e9adce4ca1ed62c$var$load("5MlWi"),
    $2e9adce4ca1ed62c$var$load("6tsCm"),
    $2e9adce4ca1ed62c$var$load("49e27"),
    $2e9adce4ca1ed62c$var$load("7EJ3Q"),
    $2e9adce4ca1ed62c$var$load("7BqcA"),
    $2e9adce4ca1ed62c$var$load("gvrSR"),
    $2e9adce4ca1ed62c$var$load("gLGsg"),
    $2e9adce4ca1ed62c$var$load("jvHRs"),
    $2e9adce4ca1ed62c$var$load("6jIfS"),
    $2e9adce4ca1ed62c$var$load("g7ggm"),
    $2e9adce4ca1ed62c$var$load("dChec"),
    $2e9adce4ca1ed62c$var$load("9S9Mz"),
    $2e9adce4ca1ed62c$var$load("3w411"),
    $2e9adce4ca1ed62c$var$load("fSobj"),
    $2e9adce4ca1ed62c$var$load("74u2y"),
    $2e9adce4ca1ed62c$var$load("6wr18"),
    $2e9adce4ca1ed62c$var$load("kjZZD"),
    $2e9adce4ca1ed62c$var$load("Wowvf"),
    $2e9adce4ca1ed62c$var$load("1qlDN"),
    $2e9adce4ca1ed62c$var$load("1yVM6"),
    $2e9adce4ca1ed62c$var$load("dRpV3"),
    $2e9adce4ca1ed62c$var$load("ffEVr"),
    $2e9adce4ca1ed62c$var$load("itWY8"),
    $2e9adce4ca1ed62c$var$load("fZt2F"),
    $2e9adce4ca1ed62c$var$load("gEFqn"),
    $2e9adce4ca1ed62c$var$load("1r59t"),
    $2e9adce4ca1ed62c$var$load("6u1hm"),
    $2e9adce4ca1ed62c$var$load("4xmPF"),
    $2e9adce4ca1ed62c$var$load("hHy5c"),
    $2e9adce4ca1ed62c$var$load("er7wn"),
    $2e9adce4ca1ed62c$var$load("iqKwT"),
    $2e9adce4ca1ed62c$var$load("h305A"),
    $2e9adce4ca1ed62c$var$load("beE2d"),
    $2e9adce4ca1ed62c$var$load("hhss7"),
    $2e9adce4ca1ed62c$var$load("7EorR"),
    $2e9adce4ca1ed62c$var$load("gmHzx")
]).then(()=>parcelRequire('48Eol'));

});

parcelRegister("jbuqY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f6f90fb0ae36f35f$export$7faac1b59c375dfa = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "oUMKP",
    name: "Nav3Layout",
    loader: async ()=>(await (parcelRequire("hy4IN"))).PageLayout
});
module.exports["Nav3Layout"] = $f6f90fb0ae36f35f$export$7faac1b59c375dfa;

});

parcelRegister("hy4IN", function(module, exports) {

let $cc69463e27f6e872$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cc69463e27f6e872$var$load("kzLFa"),
    $cc69463e27f6e872$var$load("6wr18"),
    $cc69463e27f6e872$var$load("aWd5V"),
    $cc69463e27f6e872$var$load("6tsCm"),
    $cc69463e27f6e872$var$load("49e27"),
    $cc69463e27f6e872$var$load("7BqcA"),
    $cc69463e27f6e872$var$load("2F69B"),
    $cc69463e27f6e872$var$load("1yMtA"),
    $cc69463e27f6e872$var$load("6jIfS"),
    $cc69463e27f6e872$var$load("ffEVr"),
    $cc69463e27f6e872$var$load("fZt2F"),
    $cc69463e27f6e872$var$load("hHy5c"),
    $cc69463e27f6e872$var$load("er7wn"),
    $cc69463e27f6e872$var$load("beE2d"),
    $cc69463e27f6e872$var$load("hhss7"),
    $cc69463e27f6e872$var$load("7EorR"),
    $cc69463e27f6e872$var$load("a6eof")
]).then(()=>parcelRequire('2xpE0'));

});

parcelRegister("eWwvy", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $49b80c0b2fd2c306$export$9c32b7bc3af8de64 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "5liJC",
    name: "EditSpaceLogo",
    loader: async ()=>(await (parcelRequire("fIdAJ"))).EditSpaceLogo
});
module.exports["EditSpaceLogo"] = $49b80c0b2fd2c306$export$9c32b7bc3af8de64;

});

parcelRegister("fIdAJ", function(module, exports) {

let $b7058211b83db610$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b7058211b83db610$var$load("kyxdN").then(()=>parcelRequire('asonV'));

});

parcelRegister("ezLwY", function(module, exports) {
parcelRequire("cEgln");
var $3IK76 = parcelRequire("3IK76");


var $cpjd2 = parcelRequire("cpjd2");

const $a9c9343047c8f651$var$contexts = {};
const $a9c9343047c8f651$var$runSafely = (fn)=>{
    try {
        fn();
    } catch (e) {
        // TODO: find a real fix for this issue HOT-82965 | CONFCLOUD-58951
        console.error(e);
    }
};
const $a9c9343047c8f651$export$2cd8252107eb640b = ()=>{
    (0, $cpjd2.requireLegacyWRM)([
        'wrc!confluence-keyboard-shortcuts-batch'
    ], ()=>{
        $a9c9343047c8f651$var$runSafely(()=>{
            (0, $3IK76.bind)('register-contexts.keyboardshortcuts', (e, data)=>{
                const { enableContext: enableContext } = data.shortcutRegistry;
                Object.entries($a9c9343047c8f651$var$contexts).forEach(([context, enabled])=>{
                    if (enabled) enableContext(context);
                });
            });
            (0, $3IK76.trigger)('initialize.keyboardshortcuts');
        });
    }, ()=>{});
};
const $a9c9343047c8f651$export$e758fd0259c79269 = ()=>{
    // We need to disable all shortcuts and enable again
    // the ones still available as the currrent library doesn't expose a
    // method for removing just one context and we want to keep previous
    // added contexts alive
    $a9c9343047c8f651$var$runSafely(()=>{
        (0, $3IK76.trigger)('remove-bindings.keyboardshortcuts');
        (0, $3IK76.trigger)('initialize.keyboardshortcuts');
    });
};
const $a9c9343047c8f651$var$makeSetContext = (enable)=>(newContexts)=>{
        if (!Array.isArray(newContexts)) newContexts = [
            newContexts
        ];
        newContexts.forEach((context)=>{
            if ($a9c9343047c8f651$var$contexts[context] !== enable) {
                $a9c9343047c8f651$var$contexts[context] = enable;
                $a9c9343047c8f651$export$e758fd0259c79269();
            }
        });
    };
const $a9c9343047c8f651$export$2ca78a0e32b5ba4e = $a9c9343047c8f651$var$makeSetContext(true);
const $a9c9343047c8f651$export$48a00fd3a2cf40e0 = $a9c9343047c8f651$var$makeSetContext(false);
const $a9c9343047c8f651$export$4794d9b1949031cf = ()=>{
    $a9c9343047c8f651$var$runSafely(()=>{
        (0, $3IK76.trigger)('remove-bindings.keyboardshortcuts');
    });
};
module.exports["init"] = $a9c9343047c8f651$export$2cd8252107eb640b;
module.exports["enableContext"] = $a9c9343047c8f651$export$2ca78a0e32b5ba4e;
module.exports["disableContext"] = $a9c9343047c8f651$export$48a00fd3a2cf40e0;
module.exports["teardown"] = $a9c9343047c8f651$export$4794d9b1949031cf;

});

parcelRegister("cEgln", function(module, exports) {
$parcel$export(module.exports, "trigger", () => (parcelRequire("3IK76")).trigger);
$parcel$export(module.exports, "bind", () => (parcelRequire("3IK76")).bind);
$parcel$export(module.exports, "unbind", () => (parcelRequire("3IK76")).unbind);

var $3IK76 = parcelRequire("3IK76");


});

parcelRegister("3IK76", function(module, exports) {

var $6g1oe = parcelRequire("6g1oe");


var $jnN7b = parcelRequire("jnN7b");

function $2b59405ae3db7385$export$2385a24977818dd0(eventType, eventData, handler) {
    if (typeof handler === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).bind(eventType, eventData, handler);
    else return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).bind(eventType, eventData);
}
function $2b59405ae3db7385$export$433e98592e7124fd(eventType, handler) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).unbind(eventType, handler);
}
function $2b59405ae3db7385$export$e614dc9140f7ae71(eventType, extraParameters) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).trigger(eventType, extraParameters);
}
module.exports["bind"] = $2b59405ae3db7385$export$2385a24977818dd0;
module.exports["unbind"] = $2b59405ae3db7385$export$433e98592e7124fd;
module.exports["trigger"] = $2b59405ae3db7385$export$e614dc9140f7ae71;

});

parcelRegister("jnN7b", function(module, exports) {
module.exports = jQuery;

});

parcelRegister("fmuCC", function(module, exports) {

let $b2f0a9f0e00b7e22$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b2f0a9f0e00b7e22$var$load("lgm1i").then(()=>parcelRequire('04Nru'));

});

parcelRegister("jzEl8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $9HkI0 = parcelRequire("9HkI0");

const $6cbcb1ce2cb81a03$var$REPLACED_MARKER = 'data-replaced';
const $6cbcb1ce2cb81a03$var$CLONE_MARKER = 'data-clone';
class $6cbcb1ce2cb81a03$export$a1d3010d20ec2131 extends (0, $42omo.PureComponent) {
    getLegacyElements() {
        const { rootNode: rootNode = window.document, selectors: selectors = [] } = this.props;
        if (!rootNode) return [];
        return Array.from(rootNode.querySelectorAll(selectors.join(',')));
    }
    getDomElementAttrsMap(domElement) {
        if (!domElement.hasAttributes()) return {};
        return Object.values(domElement.attributes).reduce((acc, attr)=>{
            acc[attr.name] = attr.value;
            return acc;
        }, {});
    }
    replaceDOMElementsWithPortal() {
        const { deleteExistingContent: deleteExistingContent, replacePlaceholderWith: replacePlaceholderWith, portalNode: portalNode } = this.props;
        this.workerInProgress = true;
        this.getLegacyElements().forEach((node)=>{
            const currentNodeAttrs = this.getDomElementAttrsMap(node);
            if (currentNodeAttrs[$6cbcb1ce2cb81a03$var$REPLACED_MARKER] || currentNodeAttrs[$6cbcb1ce2cb81a03$var$CLONE_MARKER]) return; // do not clone clones or already cloned nodes
            // @ts-expect-error FIXME: `true` here probably needs to be replaced with `"true"`
            node.setAttribute($6cbcb1ce2cb81a03$var$REPLACED_MARKER, true);
            // @ts-expect-error FIXME: `true` here probably needs to be replaced with `"true"`
            currentNodeAttrs[$6cbcb1ce2cb81a03$var$CLONE_MARKER] = true;
            currentNodeAttrs['key'] = currentNodeAttrs.id || (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
            let targetNode = node;
            if (replacePlaceholderWith) {
                targetNode = window.document.createElement(replacePlaceholderWith.elementName);
                const attributes = replacePlaceholderWith.attributes || {};
                for(const attr in attributes)targetNode.setAttribute(attr, attributes[attr]);
                node.parentNode.replaceChild(targetNode, node);
            }
            if (deleteExistingContent) while(targetNode.firstChild)targetNode.removeChild(targetNode.firstChild);
            if (portalNode) {
                const reactEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(portalNode, currentNodeAttrs);
                this.portals.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(reactEl, targetNode));
            }
        });
        const attemptsLeft = this.state.attemptsLeft - 1;
        this.setState({
            attemptsLeft: attemptsLeft
        });
        if (attemptsLeft > 0) window.setTimeout(()=>{
            this.replaceDOMElementsWithPortal();
        }, this.props.retryDelay);
        else this.workerInProgress = false;
    }
    render() {
        if (this.state.attemptsLeft > 0 && !this.workerInProgress) setTimeout(()=>{
            this.replaceDOMElementsWithPortal();
        }, 0);
        return this.portals.map((item)=>item);
    }
    constructor(...args){
        super(...args);
        this.state = {
            attemptsLeft: this.props.attempts ?? 0
        };
        this.workerInProgress = false;
        this.portals = [];
    }
}
$6cbcb1ce2cb81a03$export$a1d3010d20ec2131.defaultProps = {
    attempts: 1,
    retryDelay: 50,
    deleteExistingContent: true
};
module.exports["LegacyDOMBridge"] = $6cbcb1ce2cb81a03$export$a1d3010d20ec2131;

});

parcelRegister("5qwh1", function(module, exports) {

let $3f386a518f113b7b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3f386a518f113b7b$var$load("6wr18"),
    $3f386a518f113b7b$var$load("j06N4"),
    $3f386a518f113b7b$var$load("ffEVr"),
    $3f386a518f113b7b$var$load("Wowvf"),
    $3f386a518f113b7b$var$load("hhss7"),
    $3f386a518f113b7b$var$load("lwfE5")
]).then(()=>parcelRequire('MkVVm'));

});

parcelRegister("2NJWg", function(module, exports) {

let $20a3cae097b49b58$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $20a3cae097b49b58$var$load("6wr18"),
    $20a3cae097b49b58$var$load("ffEVr"),
    $20a3cae097b49b58$var$load("Wowvf"),
    $20a3cae097b49b58$var$load("hhss7"),
    $20a3cae097b49b58$var$load("d7sp9")
]).then(()=>parcelRequire('4Au5p'));

});

parcelRegister("cq0jI", function(module, exports) {

let $90a828add24c033b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $90a828add24c033b$var$load("hhss7"),
    $90a828add24c033b$var$load("ei0Jg")
]).then(()=>parcelRequire('esrJ1'));

});

parcelRegister("7nmkU", function(module, exports) {

let $55ec01e1fb53735b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $55ec01e1fb53735b$var$load("hhf8b").then(()=>parcelRequire('cDa2P'));

});

parcelRegister("ax8Zf", function(module, exports) {

let $7ab3f50d85b48d99$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7ab3f50d85b48d99$var$load("82QsP"),
    $7ab3f50d85b48d99$var$load("an2zh")
]).then(()=>parcelRequire('3Fqft'));

});

parcelRegister("d1Pi6", function(module, exports) {

let $97c327a8a6cb8f32$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $97c327a8a6cb8f32$var$load("82QsP"),
    $97c327a8a6cb8f32$var$load("gJRFC")
]).then(()=>parcelRequire('bQl5d'));

});

parcelRegister("14QAi", function(module, exports) {

var $hBkCm = parcelRequire("hBkCm");

var $flE5X = parcelRequire("flE5X");


var $lzcvT = parcelRequire("lzcvT");

const $1ce5a19013c572e5$export$529433b0a9e66822 = (url, isFedrampEnv)=>{
    const isFedrampEnvironment = isFedrampEnv ?? (0, $lzcvT.isFedRamp)();
    if (isFedrampEnvironment) {
        // Transform help-aggregator paths for FedRAMP environment
        // /gateway/api/help-content/v2/* -> /gateway/api/ha/v2/*
        // Stargate handles routing, so return relative path without domain
        if (url.startsWith('/gateway/api/help-content/v2/')) {
            const pathAfterV2 = url.replace('/gateway/api/help-content/v2', '');
            return `/gateway/api/ha/v2${pathAfterV2}`;
        }
        // For non-help-aggregator paths in FedRAMP, return as-is (relative)
        return url;
    }
    // For non-FedRAMP environments, use relative URLs (current behavior)
    return url;
};
// ANALYTICS PROPERTIES
const $1ce5a19013c572e5$var$SPACE_OVERVIEW = 'spaceSettings/overview';
const $1ce5a19013c572e5$var$SPACE_PERMISSIONS = 'spaceSettings/permissions';
const $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS = 'spaceSettings/contentTools';
const $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL = 'spaceSettings/lookAndFeel';
const $1ce5a19013c572e5$var$SPACE_INTEGRATIONS = 'spaceSettings/Integrations';
// ROUTE GROUPS
const $1ce5a19013c572e5$var$SPACE_SETTINGS = 'space-settings';
const $1ce5a19013c572e5$export$244e5242c65921be = 'https://hello.atlassian.net/wiki/spaces/PMP/pages/139161942/Standard+-+Global+Workplace+Privacy+Notice#13.-Additional-Disclosures-for-California-Residents';
const $1ce5a19013c572e5$export$ab8f8977c5e363cb = 'https://www.atlassian.com/legal/privacy-policy#additional-disclosures-for-ca-residents';
const $1ce5a19013c572e5$export$86f8e0fbd7845b32 = 'https://hello.atlassian.net/wiki/spaces/PMP/pages/139161942/Standard+-+Global+Workplace+Privacy+Notice';
const $1ce5a19013c572e5$export$87259143062a27ea = 'https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers';
const $1ce5a19013c572e5$export$108231643dc5e01e = [
    'Online Help',
    'Get the mobile app',
    'Feed Builder',
    'Keyboard Shortcuts',
    'Site Status',
    "What\u2019s new",
    'About Confluence'
];
const $1ce5a19013c572e5$export$40e045b7d0d057fd = (route)=>{
    // get what route we're on by switching based on
    // the regex evaluating to true
    switch(true){
        /**
		 * SPACE SETTINGS - OVERVIEW
		 */ case /viewspacesummary/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-details',
                articleId: '2ngx6W7OSkTdvFP6m1jdYC',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'spaceDetailsScreen'
            };
        case /archivespace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'archive-space',
                articleId: '18AcZoC9QhZZ0lzuMBaZQD',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'archiveSpaceScreen'
            };
        case /archiveSpace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'archive-space',
                articleId: '18AcZoC9QhZZ0lzuMBaZQD',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'archiveSpaceScreen'
            };
        case /editFeatures/.test(route):
            return {
                routeName: 'edit-sidebar',
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                articleId: '6ivofSJlfSXa9IASo00kvA',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'sidebarConfigurationScreen'
            };
        case /removespace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'delete-space',
                articleId: '7edCGN0nkqsvUd9s3AzEq8',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'deleteSpaceScreen'
            };
        /**
		 * SPACE SETTINGS - PERMISSIONS
		 */ case /spaces\/.*\/settings\/permissions\/\d*/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-permissions',
                articleId: '6fQGHt1G8f5KUxXTinTVvW',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'permissionsScreen'
            };
        case /spacepermissions/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-permissions',
                articleId: '6fQGHt1G8f5KUxXTinTVvW',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'permissionsScreen'
            };
        case /addonpermissions/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'analytics-permissions',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'addOnScreen'
            };
        case /listpermissionpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'page-restrictions',
                articleId: '7f9j14trnF75aeuihHAoLp',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'restrictedPagesScreen'
            };
        case /reorderpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'reorder-pages',
                articleId: '5faOvjH2hAw2CpZY3tC3ej',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'reorderPagesScreen'
            };
        case /listorphanedpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'orphaned-pages',
                articleId: '1mxG2f1dvIifiDqKrkvy98',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'orphanedPagesScreen'
            };
        case /listundefinedpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined-pages',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'undefinedPagesScreen'
            };
        case /listattachmentsforspace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'attachments',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'attachmentsScreen'
            };
        case /viewtrash/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'trash',
                articleId: '6NL5cRC6aV7k9ucd2yEZzZ',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'trashScreen'
            };
        case /exportspacewelcome/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'export-space',
                articleId: '6RcXthpHKQasH09gERDkE8',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'exportScreen'
            };
        case /listrssfeeds/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'rss-feed',
                articleId: '6TyTkhaowcNTwvq9V0rt10',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'rssFeedsScreen'
            };
        /**
		 * SPACE SETTINGS - LOOK AND FEEL
		 */ case /spaces\/choosetheme/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'themes',
                articleId: '3Owkyfl2mshKQQ2mECCV8q',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'themesScreen'
            };
        case /custompagecontent/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'header-and-footer',
                articleId: '2i2NAHbTjkWeoprrdWlNX',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'headerAndFooterScreen'
            };
        case /viewpdfconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfConfigScreen'
            };
        case /viewpdflayoutconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfLayoutScreen'
            };
        case /viewpdfstyleconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfStylesheetScreen'
            };
        /**
		 * SPACE SETTINGS - INTEGRATIONS
		 */ case /listentitylinks/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_INTEGRATIONS,
                screen: 'applicationLinksScreen'
            };
        /**
		 * CONNECT ADDONS
		 */ case /analytics\/permissions/.test(route):
            return {
                routeGroup: 'site-settings',
                routeName: 'analytics-permissions',
                articleId: '6yKVtN1tSSrOHTp4TpXtkg',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /atlassian-connect\/space-tools-tab.action/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'analytics-permissions',
                articleId: '6yKVtN1tSSrOHTp4TpXtkg',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'analyticsPermissionsScreen'
            };
        /**
		 * CONTENT TYPE VIEW PAGES
		 */ case /spaces\/.*\/pages\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-page',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/whiteboard\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-whiteboard',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/database\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-database',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/embed\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-embed',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/calendars/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-calendars',
                articleId: '85KAXe75f9VdMibJa5FHz',
                section: 'notTracked',
                screen: 'notTracked'
            };
        /**
		 * EVERYTHING ELSE
		 */ default:
            return {
                routeGroup: 'undefined',
                articleId: '',
                section: 'notTracked',
                routeName: 'undefined',
                screen: 'notTracked'
            };
    }
};
const $1ce5a19013c572e5$export$c28bcc688252a1b6 = (error)=>{
    return [
        'algolia',
        'unreachable hosts'
    ].some((err)=>error.message.toLowerCase().includes(err)) || error instanceof (0, $flE5X.NoNetworkError) || error instanceof (0, $hBkCm.BadStatusError) && error.response.status >= 500;
};
module.exports["getFedSupportGatewayURL"] = $1ce5a19013c572e5$export$529433b0a9e66822;
module.exports["INTERNAL_NOTICE_AT_COLLECTION_LINK"] = $1ce5a19013c572e5$export$244e5242c65921be;
module.exports["EXTERNAL_NOTICE_AT_COLLECTION_LINK"] = $1ce5a19013c572e5$export$ab8f8977c5e363cb;
module.exports["INTERNAL_PRIVACY_POLICY_LINK"] = $1ce5a19013c572e5$export$86f8e0fbd7845b32;
module.exports["EXTERNAL_PRIVACY_POLICY_LINK"] = $1ce5a19013c572e5$export$87259143062a27ea;
module.exports["FILTERED_MENU_ITEMS"] = $1ce5a19013c572e5$export$108231643dc5e01e;
module.exports["getRouteData"] = $1ce5a19013c572e5$export$40e045b7d0d057fd;
module.exports["isSearchProviderUnreachableError"] = $1ce5a19013c572e5$export$c28bcc688252a1b6;

});

$parcel$global.rwr("3pblT", () => { var $6cfdb977dfd7a57b$exports = {};

(parcelRequire("02nRr")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"3pblT\",\"standalone-navigation-jquery3.6b09e814.js\",\"kSVGa\",\"ChangeEditionNotificationDialog.bde70d07.js\",\"hhss7\",\"vendors~editor_atlaskit_lg.54d44642.js\",\"gmHzx\",\"PageLayout.f42ccc5e.js\",\"i5eMd\",\"cs.8dcd13ce.js\",\"4UPfH\",\"da.07be2730.js\",\"gd4qs\",\"de.7c364a51.js\",\"fviv5\",\"en-GB.a9fc51cd.js\",\"hEkXc\",\"en-US.c2f93eaf.js\",\"6oOC9\",\"en-XA.b789199b.js\",\"le1sE\",\"en-XB.56b2f58f.js\",\"eBoC7\",\"en-ZZ.f2953af7.js\",\"bNv64\",\"es.f9a1e371.js\",\"bAoKR\",\"et.b46b672c.js\",\"4Afgd\",\"fi.2a85f317.js\",\"cMubu\",\"fr.bc1afdd0.js\",\"oUCro\",\"hr.665c3168.js\",\"3fLE9\",\"hu.46cbe0e2.js\",\"8hOn0\",\"it.2eb0d428.js\",\"h4OCL\",\"ja.d8fc84a3.js\",\"bcQs2\",\"ko.8a9af514.js\",\"aBa7j\",\"nb.3b8a134b.js\",\"b544F\",\"nl.0103c5a3.js\",\"K6fhx\",\"pl.a2290f90.js\",\"gZU54\",\"pt-BR.3f51cb32.js\",\"hlJc4\",\"ro.968019e9.js\",\"4Wdqb\",\"ru.cdfd20b1.js\",\"bJMZS\",\"sl.36363fa9.js\",\"exiT6\",\"sr-RS.3450f456.js\",\"jLkRH\",\"sr-YR.99ef1f81.js\",\"dmrYq\",\"sr.7f38330b.js\",\"k10Cs\",\"sv.b339f67a.js\",\"g5LV7\",\"th.0f9e7384.js\",\"1n8w9\",\"tr.f0e83874.js\",\"2QtDQ\",\"uk.d30eb92e.js\",\"i2vEA\",\"vi.a56f926d.js\",\"f1B4n\",\"zh-CN.7b758142.js\",\"l079e\",\"zh-TW.9357491a.js\",\"bv8GZ\",\"cs.b8d1c1b1.js\",\"cdeuH\",\"da.42823f82.js\",\"7gF8f\",\"de.8842c040.js\",\"djb49\",\"en-GB.8e93f926.js\",\"koawN\",\"en-US.8577a1a6.js\",\"6htQT\",\"en-XA.66b7e053.js\",\"fi75i\",\"en-XB.9d74a127.js\",\"ksTQ6\",\"en-ZZ.94ab1be8.js\",\"5CGnz\",\"es.98f8e90e.js\",\"X0Jic\",\"et.155c1ee0.js\",\"9Oxgj\",\"fi.f2f3389c.js\",\"kAg8V\",\"fr.368a32d8.js\",\"36XYg\",\"hr.ea791c71.js\",\"fM2oh\",\"hu.f2f9ae82.js\",\"xnqy2\",\"it.351ab003.js\",\"awkVi\",\"ja.99d2f833.js\",\"11DLa\",\"ko.8aeaf96b.js\",\"barSq\",\"nb.4503e9a5.js\",\"a8heY\",\"nl.6070b16e.js\",\"6hlNE\",\"pl.9a5b0b0f.js\",\"2bqSD\",\"pt-BR.10f91e79.js\",\"j6IGj\",\"ro.b5d74be6.js\",\"bJykp\",\"ru.2a448b30.js\",\"7Rbde\",\"sl.9bd17812.js\",\"l8auu\",\"sr-RS.de35f66e.js\",\"3ColL\",\"sr-YR.6d75fa4f.js\",\"2VSOH\",\"sr.cbf031a6.js\",\"dh2Er\",\"sv.e6031ecb.js\",\"kyBJI\",\"th.ea68a7ea.js\",\"eBLgB\",\"tr.a4d35ce1.js\",\"ahhGv\",\"uk.13d42b80.js\",\"1Zesg\",\"vi.e3d9da82.js\",\"eLlpV\",\"zh-CN.914fb213.js\",\"bV8sS\",\"zh-TW.90b55434.js\",\"1jsQH\",\"cs.688247af.js\",\"deyvi\",\"da.ce01a3f4.js\",\"6dERU\",\"de.196d0286.js\",\"kTurq\",\"en-GB.082421f0.js\",\"fbIIm\",\"en-US.0fcdf1ae.js\",\"7l3it\",\"en-XA.8e12231a.js\",\"i64HJ\",\"en-XB.2518e3d2.js\",\"j0PWv\",\"en-ZZ.c31c7b45.js\",\"dlmud\",\"es.a37dad44.js\",\"7snhF\",\"et.20d4d799.js\",\"cbkj0\",\"fi.c129a5d2.js\",\"17m16\",\"fr.d48d2214.js\",\"eQZk8\",\"hr.e3f3497b.js\",\"b4NO6\",\"hu.d63219d9.js\",\"1K1Fj\",\"it.68b18a63.js\",\"38sfA\",\"ja.05e83d89.js\",\"bjmre\",\"ko.5d08c8ec.js\",\"asvK9\",\"nb.b60c8cb7.js\",\"7v6wU\",\"nl.d417f24d.js\",\"aEpRh\",\"pl.26cf010d.js\",\"3fuR9\",\"pt-BR.b55187ea.js\",\"bSjyK\",\"ro.8940bbdc.js\",\"fMrUo\",\"ru.f0bbf79a.js\",\"glLvq\",\"sl.93d481e6.js\",\"fFGjZ\",\"sr-RS.ddc08819.js\",\"fEAqG\",\"sr-YR.289dc38a.js\",\"e9tHh\",\"sr.14f31eee.js\",\"9eNkX\",\"sv.12cce2b0.js\",\"fTPgj\",\"th.4d360fb6.js\",\"h0uBE\",\"tr.a1624066.js\",\"lKa7i\",\"uk.38ddf7bc.js\",\"9aufD\",\"vi.4cc44e33.js\",\"gDiIK\",\"zh-CN.268ccaa6.js\",\"j9OUx\",\"zh-TW.9fda702e.js\",\"kpHRm\",\"GeneralShortcutListener.8e29901c.js\",\"fZt2F\",\"GeneralShortcutListener.106c80fd.js\",\"82QsP\",\"InProductHelpButton.c7845771.js\",\"6KGrg\",\"EmojiComponent.e9f603af.js\",\"4izLy\",\"NativeCollabComponent.b43bfa9b.js\",\"9V45O\",\"CommentsPanelFilterMenu.eb1c79bb.js\",\"ffEVr\",\"vendors~editor_icon.e0fbd6cd.js\",\"kjZZD\",\"vendors~editor_icon-object.52136ea2.js\",\"ffEVr\",\"vendors~editor_icon.e0fbd6cd.js\",\"6wr18\",\"vendors~editor_icon.8d004ef7.js\",\"ajMch\",\"16.0a8aa9c5.js\",\"6wr18\",\"vendors~editor_icon.8d004ef7.js\",\"kzLFa\",\"component-lazy.6ac4bd54.js\",\"d5xSh\",\"simpleHasher.505e00e0.js\",\"av6T2\",\"simpleHasher.runtime.a8deffef.js\",\"av6T2\",\"simpleHasher.runtime.a8deffef.js\",\"hwiu3\",\"NavigationLockout.8586f374.js\",\"5rgzC\",\"drag-handle.73ab909e.js\",\"fYNhh\",\"DevToolsDialog.8b3773ee.js\",\"hqXh1\",\"OnboardingStateEditor.c8c41dc8.js\",\"Wowvf\",\"vendors~editor_atlaskit_sm.631a829e.js\",\"331QJ\",\"statsigIcon.d38e3090.png\",\"dKuGS\",\"switcherooIcon.4d3f783a.png\",\"fxolc\",\"MigrationsToolingTab.18a5d3f5.js\",\"h305A\",\"manual-triggers-modal.0572d33a.js\",\"7EorR\",\"vendors~editor_atlaskit_md.d3cb435c.js\",\"kHOMt\",\"manual-triggers-modal.63f58b3c.js\",\"53pgU\",\"GoalPanel.1409484c.js\",\"heWL2\",\"body.81929ef6.js\",\"8makw\",\"datasourceTableView.1c05017f.js\",\"lUQAm\",\"datasourceTableView.0b2d0eb1.js\",\"dRpV3\",\"inlineCard.1f477ed1.js\",\"lkOIY\",\"CommentsPanelFilterMenu.7d501390.js\",\"C72jX\",\"DevToolsBanner.5fdb1ba3.js\",\"jZwEH\",\"ExitBranchDeploy.c9c9c03d.js\",\"3aT4s\",\"FeedbackCollectorButton.fdbf5d96.js\",\"dGk3x\",\"GlobalFeedbackCollector.3d326504.js\",\"cyGuT\",\"feedback-collector.fab7db45.js\",\"avZlC\",\"BannerContainer.10c9935f.js\",\"9mi9f\",\"BannerSpacer.2023a048.js\",\"kiqoj\",\"SuperAdminBanner.1913bb80.js\",\"jE5XU\",\"SatisfactionSurveyFlag.aaeec784.js\",\"f8xBv\",\"SatisfactionSurveyComponent.8f485896.js\",\"4csuu\",\"terrible.43df9387.svg\",\"ezTnP\",\"bad.1f02aedc.svg\",\"lKYkZ\",\"okay.fd894a28.svg\",\"eOIaN\",\"great.e17ca230.svg\",\"c1rvV\",\"amazing.0fceeb3a.svg\",\"hUS1e\",\"AdminAnnouncementBannerInner.16cdf505.js\",\"kC80R\",\"esm.7399a977.js\",\"h3ABO\",\"esm.dc8ab43b.js\",\"iqKwT\",\"main.6a38f15e.js\",\"ik1cX\",\"FullPageEditorComponent.7f3a21ca.js\",\"5Zg4L\",\"FullPageEditorComponent.runtime.69c1858d.js\",\"jXx9i\",\"NativeCollabComponent.5e274adb.js\",\"2PeJK\",\"AdminAnnouncementBannerInner.dd85919d.js\",\"1fem1\",\"panel.7dcf6bd8.js\",\"9u7sS\",\"panel.runtime.91b63b5f.js\",\"9u7sS\",\"panel.runtime.91b63b5f.js\",\"5Zg4L\",\"FullPageEditorComponent.runtime.69c1858d.js\",\"cjDIz\",\"GracePeriodBanner.bc89c340.js\",\"5a167\",\"scheduler-polyfill.ca4ea44c.js\",\"6u1hm\",\"CommentsPanelFilterMenu.6004beb7.js\",\"kWL2K\",\"UpFlowCommerceRouter.50bafddc.js\",\"lXBLC\",\"GracePeriodBanner.acafa4fd.js\",\"4zlcK\",\"avoid-deactivation-data-modal.abb62a5a.js\",\"bpZy3\",\"user-brand-dark.2dd77a4f.svg\",\"4B6ye\",\"user-brand-light.f1d0cd78.svg\",\"g2AXX\",\"user-gray-dark.8d7964d6.svg\",\"30svi\",\"user-gray-light.4df874b4.svg\",\"dTsOE\",\"modal.1f14079f.js\",\"jfplD\",\"GracePeriodBanner.66791589.js\",\"4uVag\",\"StorageEnforcementBanner.cd3e7767.js\",\"cGZdO\",\"PlanConsentDeepLink.330201e7.js\",\"hmjlF\",\"ConsentBannerWrapper.c821fa89.js\",\"9FU4d\",\"browser-storage-controls.128d7a35.js\",\"gCbq8\",\"cs.a209aa14.js\",\"TR24h\",\"da.52144f35.js\",\"NfUyB\",\"de.189b802b.js\",\"4v21d\",\"en_GB.58bcc852.js\",\"4D2WV\",\"en_ZZ.07b6b0f2.js\",\"gSwbJ\",\"es.27061460.js\",\"chaHI\",\"fi.f05d4dc5.js\",\"kBpIt\",\"fr.d4774d68.js\",\"dPeMl\",\"hu.9a5436ee.js\",\"4PHEa\",\"it.8260474e.js\",\"CGYMd\",\"ja.514cf297.js\",\"fGpBg\",\"ko.09d46e0e.js\",\"cgWNw\",\"nb.593f98f0.js\",\"aUP3I\",\"nl.9e24e59e.js\",\"bs4gz\",\"pl.e0577981.js\",\"gSXrz\",\"pt_BR.1efcd373.js\",\"aJd4I\",\"ru.b8c2b1b7.js\",\"gR7fm\",\"sv.07219ae9.js\",\"xDkFq\",\"th.be4d9bd0.js\",\"cV2OA\",\"tr.7e1ff419.js\",\"ehLR6\",\"uk.86f0ff8b.js\",\"lXmbw\",\"vi.43447bab.js\",\"jwfyA\",\"zh_TW.fa40865e.js\",\"6zOB9\",\"zh.d323a517.js\",\"7ETma\",\"BannerContainer.6775102c.js\",\"jryQt\",\"GlobalComponents.0c245cb4.js\",\"lnKog\",\"main.2489be37.js\",\"hJpvQ\",\"main.4d914ba7.js\",\"3WaAl\",\"FloatingAudioContent.8eae92dc.js\",\"aLGWB\",\"WaveformAnimation.27743507.js\",\"kiGNy\",\"render.a1c97fc3.js\",\"ivNGg\",\"GeneratingAnimation.1e1e5744.js\",\"hVPSr\",\"AudioBriefingSonicMark.b774c076.mp3\",\"b8QJ8\",\"UpdateComposer.ff434620.js\",\"hogcU\",\"component-lazy.89af9f9b.js\",\"6WFSC\",\"FullPageEditorComponent.cdce30f7.js\",\"lPZrS\",\"FullPageEditorComponent.runtime.5746cc02.js\",\"2La6i\",\"RelatedLinksModal.969a33d6.js\",\"ibQzt\",\"RelatedLinksModal.runtime.978202d6.js\",\"kNV5Y\",\"blog.3e99625c.js\",\"dYtBN\",\"page-live-doc.23a58848.js\",\"dek7I\",\"page-live-doc.4dfdcb4e.js\",\"hv4mn\",\"modal.860760a9.js\",\"fisfU\",\"video-play-overlay.0278a0bb.js\",\"8YSo7\",\"CommentsPanelFilterMenu.bf0ef3c6.js\",\"jbxHq\",\"CommentsPanelFilterMenu.bc16756d.js\",\"7kkP6\",\"playlist-add.9dfed2d4.js\",\"k2R9e\",\"playlist-remove.1cea3c51.js\",\"lLK0D\",\"video-pause-overlay.bf3f58b5.js\",\"3R2Cd\",\"EndOfPageRecommendation.b36e4f01.js\",\"8gJl0\",\"video-previous-overlay.a5089076.js\",\"lVBal\",\"video-skip-backward-fifteen.7d60ceff.js\",\"7t5Ax\",\"video-skip-forward-fifteen.8c41b0f7.js\",\"keCTf\",\"CommentsPanelFilterMenu.a1d636df.js\",\"1yMtA\",\"CommentsPanelFilterMenu.d708dce2.js\",\"2wk8c\",\"ConfigPanelFieldsLoader.a051a365.js\",\"ibQzt\",\"RelatedLinksModal.runtime.978202d6.js\",\"lPZrS\",\"FullPageEditorComponent.runtime.5746cc02.js\",\"atyNV\",\"CreateSpaceDrawer.5a8d0ada.js\",\"cPGpO\",\"premiumLozenge.aa9b0435.svg\",\"eMbU0\",\"SpaceSelector.1d1cf67b.js\",\"3wN5D\",\"ExternalSpaceLozenge.de41bba8.js\",\"er7wn\",\"emoji.b652bdbe.js\",\"hHy5c\",\"emoji.runtime.c7d08c1f.js\",\"6nxM7\",\"DetailsPanelHeaderIcon.3c6e551a.js\",\"5ntWz\",\"DetailsPanelHeaderIcon.39f0803f.js\",\"hHy5c\",\"emoji.runtime.c7d08c1f.js\",\"dJhDI\",\"Upload.41b8806c.svg\",\"4fscz\",\"skyBackground.807308bc.svg\",\"1yVM6\",\"UpgradeEditionButton.e2d791e7.js\",\"1qlDN\",\"UpgradeEditionButton.runtime.223a98ff.js\",\"fxC6e\",\"24.abc70e31.js\",\"6vhrJ\",\"24.b27b3b60.js\",\"5pvpJ\",\"datasourceTableView.686437f9.js\",\"fsikk\",\"cardWithMediaClient.3feeedb7.js\",\"6XCf4\",\"LearnMoreButton.39bca696.js\",\"cEqm7\",\"ShareButton.a26b557b.js\",\"hOaAV\",\"ContextualCreateContentPopoverMenu.6a9e6b02.js\",\"a3Uq6\",\"esm.fbb2f874.js\",\"19uFC\",\"pages.d69df670.js\",\"yRK4S\",\"CopySpacePermissionsForLegacyNewSpace.cdf37cab.js\",\"4o7bO\",\"CreateSpaceDrawer.0eea2c77.js\",\"huUvS\",\"16.95572e52.js\",\"1oiJ6\",\"16.f20e72ef.js\",\"lxiFd\",\"16.6f66d48d.js\",\"eDqo1\",\"16.775f562b.js\",\"6HBYC\",\"16.e6a8a945.js\",\"bYxCZ\",\"16.1d6e89c2.js\",\"eTBsW\",\"16.a21a1ba3.js\",\"020xd\",\"16.4d1d2449.js\",\"ls0Um\",\"16.cbe8174e.js\",\"eVYW1\",\"16.71a0c4aa.js\",\"f35QR\",\"16.4bd4939d.js\",\"8j9XC\",\"cardWithMediaClient.abcd9c4b.js\",\"b8BDn\",\"js.24b546d4.js\",\"dLFEp\",\"png-chunks-extract.6eed11e8.js\",\"1qlDN\",\"UpgradeEditionButton.runtime.223a98ff.js\",\"9JWXo\",\"ImportContentDrawer.420bcdae.js\",\"6aruy\",\"media-client-react.47553567.js\",\"9baqg\",\"cardWithMediaClient.c83a028f.js\",\"cCWZm\",\"dropzone.b0db837a.js\",\"dT77m\",\"media-viewer-error-boundary.d132842e.js\",\"lE3cg\",\"media-picker-analytics-error-boundary.5159dd30.js\",\"hqblC\",\"browser.9a2c48ae.js\",\"5eYbH\",\"fileIconLight.abb757fe.png\",\"f27VQ\",\"fileIconDark.2e9120d4.png\",\"eQRZh\",\"alexander.61c8c5b8.png\",\"k3UTH\",\"milo.2bdab175.png\",\"bpNrn\",\"vania.0f716e7d.png\",\"1SbNU\",\"newUsersIcon.57d15f82.png\",\"4pzfE\",\"entireWorkspaceGraphic.ec7c84e3.png\",\"9EbOe\",\"entireWorkspaceGraphicDark.a2cf125d.png\",\"5v8ge\",\"pageWithSubpagesGraphic.bc63f39a.png\",\"l5ApQ\",\"pageWithSubpagesGraphicDark.048b0716.png\",\"e233E\",\"NotionFileIcon.bf57d29e.png\",\"2HswK\",\"NotionFileIconDark.1bce2172.png\",\"iHoZ2\",\"mapNotionMembersIcon.f5fa6c65.png\",\"mKUlU\",\"mapNotionMembersIconDark.78a4caee.png\",\"lve0S\",\"dontMapNotionMembersIcon.d4b46256.png\",\"fHhNe\",\"dontMapNotionMembersIconDark.8a5a6302.png\",\"idIGV\",\"addRemainingMembersIcon.ed292f87.png\",\"eFqPt\",\"addRemainingMembersIconDark.fcaa97df.png\",\"ahBHt\",\"dontAddRemainingMembersIcon.c16498ed.png\",\"bJ6Qx\",\"dontAddRemainingMembersIconDark.2a9fa7cf.png\",\"jO0Zn\",\"copyPagePermissionsIcon.893f44bc.png\",\"koH91\",\"dontCopyPagePermissionsIcon.57c83ce6.png\",\"4qS5d\",\"createNewSpaceIcon.43619a57.png\",\"7HrUn\",\"createNewSpaceIconDark.1df6e816.png\",\"rGPsx\",\"dontCreateNewSpaceIcon.b35b2829.png\",\"5a1S5\",\"dontCreateNewSpaceIconDark.706b6cfd.png\",\"8R1Rz\",\"spaceTransferLight.b2e70613.png\",\"1e1ep\",\"spaceTransferDark.856b3d0e.png\",\"jGDZO\",\"zipFileIconLight.abb757fe.png\",\"4pvad\",\"zipFileIconDark.2e9120d4.png\",\"4xmnl\",\"spaceTransferIconLight.5eeae605.png\",\"aBnpB\",\"spaceTransferIconDark.9c0b5b2f.png\",\"aRCSw\",\"miroBulkImportIconLight.f695f170.png\",\"dur8E\",\"miroBulkImportIconDark.3dc15c83.png\",\"eGDQk\",\"Miro_Connie_Light.97ddc4df.png\",\"5IkEQ\",\"Miro_Connie_Dark.588133c4.png\",\"d4y04\",\"muralSpacesIllustrationLight.297ed65c.png\",\"hgEBB\",\"muralSpacesIllustrationDark.a5d03bf9.png\",\"4YW3x\",\"inviteMembersIconLight.1a833efb.png\",\"jw4LE\",\"inviteMembersIconDark.1179e32a.png\",\"hoRD8\",\"newSpaceIconLight.9405f85d.png\",\"5ILSM\",\"newSpaceIconDark.9c0b5b2f.png\",\"2Q5QN\",\"muralIcon.75d8302a.png\",\"fK2sh\",\"muralSpacesIllustrationDisconnectedLight.4bd334a6.png\",\"3aNue\",\"muralSpacesIllustrationDisconnectedDark.a6cca434.png\",\"7MlKm\",\"archive.dc010ead.js\",\"5uN9h\",\"arrow-up-right.b9da73d9.js\",\"7WcBh\",\"MovePageDialog.ce6f2892.js\",\"hX5aL\",\"ImportContentModal.8e08fa90.js\",\"dIKKx\",\"StorageEnforcementFlags.81b3d74b.js\",\"52dqm\",\"GracePeriodModal.8617854a.js\",\"6sJUU\",\"GracePeriodModalComponent.23e9b453.js\",\"gKiqN\",\"gracePeriodIllustrationDark.e34dd459.svg\",\"02fAA\",\"gracePeriodIllustrationLight.04bd67a4.svg\",\"gIOIL\",\"BlockCreateModal.2fc74ca7.js\",\"fDkpP\",\"blockCreateIllustrationLight.10953577.svg\",\"36KWd\",\"blockCreateIllustrationDark.e6b33366.svg\",\"ehu5c\",\"EndOfTrialModalContainer.b769e0b2.js\",\"fkozR\",\"background-dark.46d9946a.svg\",\"3FECQ\",\"background-light.c76a8e81.svg\",\"doIPU\",\"gestural-line-dark.9e5d1ce8.svg\",\"dT0Nh\",\"gestural-line.93eaf758.svg\",\"cOOgy\",\"strike-through.539e2da9.svg\",\"8UKe0\",\"chart-trend-up.daa97715.js\",\"fjOTL\",\"person-add.2ade7731.js\",\"878st\",\"base-component.33fb4b7a.js\",\"iAqyW\",\"ai-generative-text.a87325fb.js\",\"jle6Z\",\"premium.3f265b33.js\",\"lAzPQ\",\"base-component.75c2b739.js\",\"jJOfU\",\"ConfluenceStandardOfferAIModalRightSide.7551cf90.svg\",\"e1pCZ\",\"ConfluenceStandardOfferAIModalRightSideDark.4c810671.svg\",\"6xJuR\",\"base-component.bd1b7ac4.js\",\"aIwO0\",\"cs.b9edd2fb.js\",\"iwseV\",\"da.fc4e18d3.js\",\"eh9w8\",\"de.78dfeaf5.js\",\"3eWGu\",\"en_GB.bbd3f137.js\",\"8jVst\",\"en_ZZ.c8959eb2.js\",\"hNk7k\",\"es.eac6a84e.js\",\"arXo9\",\"fi.6157ea05.js\",\"yuLnu\",\"fr.c027e6b8.js\",\"2pQv8\",\"hu.d1cf9d34.js\",\"jGBo1\",\"it.7d2e1c00.js\",\"eUrwV\",\"ja.b326a052.js\",\"2zgDh\",\"ko.c57bedaf.js\",\"bETPT\",\"nb.779151e4.js\",\"ceBZg\",\"nl.b0aa70bf.js\",\"5STWe\",\"pl.ab437593.js\",\"EfE3i\",\"pt_BR.13398930.js\",\"hFqXA\",\"ru.d44900c6.js\",\"4ArgV\",\"sv.fde05c73.js\",\"28EDH\",\"tr.a742d791.js\",\"k3mTs\",\"th.98c92a14.js\",\"jJdZ4\",\"uk.2cdd9c4b.js\",\"eZRzs\",\"vi.e0e19052.js\",\"bLQZ9\",\"zh_TW.152ba9f0.js\",\"e0E8p\",\"zh.0de3e729.js\",\"4DYJ5\",\"cs.ae29805e.js\",\"hfFxJ\",\"da.4bac143d.js\",\"gofGr\",\"de.d8e61a4d.js\",\"aSjrK\",\"en_GB.a65deae7.js\",\"7NpX8\",\"en_ZZ.56f4bbe2.js\",\"bFU3Y\",\"es.e423bf3a.js\",\"exaJ2\",\"fi.33989446.js\",\"hcCcg\",\"fr.a66523c8.js\",\"j9KTb\",\"hu.fa3f1171.js\",\"3hjAq\",\"it.620f63c1.js\",\"2bCHJ\",\"ja.d410f0e4.js\",\"fdXnq\",\"ko.377862ae.js\",\"cItJR\",\"nb.dbba57d8.js\",\"SctKm\",\"nl.d90fd1de.js\",\"1fJz1\",\"pl.7999c76d.js\",\"9yA8o\",\"pt_BR.e534d362.js\",\"448N7\",\"ru.1fe1deae.js\",\"gBDdh\",\"sv.bc06c239.js\",\"epkdv\",\"tr.f7701f9c.js\",\"fdczG\",\"th.85d0593d.js\",\"3MGOs\",\"uk.f1a414df.js\",\"innCz\",\"vi.d3e97b33.js\",\"ebljE\",\"zh_TW.cf04c7f7.js\",\"j4dSZ\",\"zh.fb33a2b6.js\",\"b2zon\",\"loom-cross-join-nudge.36c35ead.js\",\"4P2wv\",\"LoomAiMeetingNotesPostProvisionFlag.560d199f.js\",\"gmwfN\",\"ModernizeChangeboarding.e354d18c.js\",\"iZkNL\",\"Modal.552beb50.js\",\"4jvyy\",\"play-button.f16ed914.png\",\"bSWox\",\"thumbnail-light.cbc485ab.png\",\"espuV\",\"thumbnail-dark.4c2a9461.png\",\"7VEEc\",\"whiteboards.5bac062b.svg\",\"1S5Y4\",\"rovo-ai.1a901dc7.svg\",\"dZyP8\",\"reactions-and-stickers.1f3b4ebe.svg\",\"8VWrF\",\"jira-work-items.11443501.svg\",\"55agv\",\"loom-videos.37a4452c.svg\",\"jGjVz\",\"whiteboards-dark.5a9dae19.svg\",\"j77CV\",\"rovo-ai-dark.ac54f515.svg\",\"33gHJ\",\"reactions-and-stickers-dark.fd611bb0.svg\",\"eRF5i\",\"jira-work-items-dark.f74ce1c2.svg\",\"crbaY\",\"loom-videos-dark.1afab585.svg\",\"31kOm\",\"nav4GlobalSpotlightImage.b0eee534.svg\",\"dW3gq\",\"nav4GlobalSpotlightImageDark.46829a6e.svg\",\"1aHOD\",\"nav4SpaceSpotlightImage.8dc1626b.svg\",\"huVSt\",\"nav4SpaceSpotlightImageDark.eeaa5b5d.svg\",\"iXULO\",\"LiveDocModalGif-light.2404511f.gif\",\"ff6Qm\",\"LiveDocModalGif-dark.64c94d68.gif\",\"3nVFr\",\"PreviewPageComponent.1df4230c.js\",\"9OSao\",\"WatchDialogContent.79de35e4.js\",\"8hbZ5\",\"WatchDialogShortcut.3d98b3d0.js\",\"iJwzY\",\"ManageWatcherDialog.adf9c1be.js\",\"74u2y\",\"datasourceTableView.887b77a4.js\",\"fSobj\",\"datasourceTableView.runtime.9c3299e8.js\",\"h4Nf7\",\"ExternalUserLozenge.6c39b83e.js\",\"c831e\",\"Controller.7eb38b9e.js\",\"fSobj\",\"datasourceTableView.runtime.9c3299e8.js\",\"cPaXL\",\"ArchiveUpsellDialog.a64f25eb.js\",\"3uux1\",\"ArchivePagesLoader.47c3516c.js\",\"8qpSy\",\"ErrorSectionMessage.4b35930e.js\",\"i5EJc\",\"ErrorComponent.27194104.js\",\"2wJza\",\"ErrorGraphic.784b3ce3.svg\",\"9ftJe\",\"UpdateComposer.65192a63.js\",\"iQ0Jm\",\"SmartButtonConfigPanel.dbef5f09.js\",\"kH8lz\",\"BulkArchivePagesLoader.f78d7226.js\",\"6sAbi\",\"ArchivePageAutomationDiscovery.bbf713dc.js\",\"DtgOI\",\"ShareButton.f4dfa662.js\",\"1u9sS\",\"ArchivePagesLoader.201e83ec.js\",\"in6Mc\",\"NoChildrenBullet.407634ad.js\",\"9QyoN\",\"PageQuickActionAutomationMenu.9dc729ec.js\",\"7f9Fz\",\"root-component.2ecfdf2b.js\",\"4xZ5N\",\"PageQuickActionAutomationMenu.3d2b3d50.js\",\"aOpoD\",\"empty-automation-list.9c7d0496.png\",\"awXdT\",\"error.b6351f9e.svg\",\"f0paE\",\"PageQuickActionAutomationMenu.f433251d.js\",\"cDlXo\",\"cs.bb7b2398.js\",\"aGqxI\",\"da.2f2eb656.js\",\"8DMgV\",\"de.d2d66f21.js\",\"3lwWF\",\"en_GB.ef04196d.js\",\"6n44e\",\"en_ZZ.0706863b.js\",\"i2lSs\",\"es.cfb981b6.js\",\"cddHY\",\"fi.b34be9f5.js\",\"2nFnK\",\"fr.9414a49e.js\",\"iMEy4\",\"hu.19dd1006.js\",\"79NWg\",\"it.5b76b6c9.js\",\"dn37Z\",\"ja.198e5ad1.js\",\"2y34H\",\"ko.a4730b26.js\",\"g8Vga\",\"nb.256e2e51.js\",\"fw5Rx\",\"nl.7df68bde.js\",\"cqxYX\",\"pl.48257922.js\",\"3Wq1f\",\"pt_BR.b0cab9c2.js\",\"ePmaE\",\"ru.f24df80d.js\",\"2PbJR\",\"sv.9362d1ff.js\",\"04oVB\",\"tr.2426a00f.js\",\"7lf25\",\"zh_TW.3e778977.js\",\"csVFP\",\"zh.453474a1.js\",\"9YGIy\",\"DeleteNestedPagesAction.5ecd572c.js\",\"4JUnA\",\"BulkDeletePagesAction.40b14439.js\",\"73HOd\",\"BulkDeletePagesAction.dec29c2e.js\",\"anGwD\",\"BulkArchivePagesLoader.0687b3e6.js\",\"iomzR\",\"DeletePageDialog.5d913a27.js\",\"p4ay7\",\"CopyPageTreeContainer.305e25da.js\",\"l5XQ1\",\"ViewSpaceExternalCollaboratorsDialog.9b40fba5.js\",\"hA2SB\",\"GroupAndUserItem.dea87472.js\",\"iHlO3\",\"empty-filter.16dda5ac.svg\",\"4IYLb\",\"mention.d8e32027.js\",\"fuKGN\",\"mention.runtime.46f2ed7d.js\",\"lu4e5\",\"ShareButton.6e958c5b.js\",\"g7ggm\",\"ShareButton.d63a7dc9.js\",\"iK31U\",\"GroupAndUserItem.653bdf8f.js\",\"fuKGN\",\"mention.runtime.46f2ed7d.js\",\"lookM\",\"user-header-for-space-with-guests-Light.1b10bf7d.svg\",\"2GHvs\",\"user-header-for-space-with-guests-Dark.3d8c1f10.svg\",\"5ppK3\",\"MovePageDialog.8d56d0fe.js\",\"aiU5r\",\"CopyPageDialogContainer.42cdfa6e.js\",\"dxDVc\",\"UnarchivePagesLoader.80a92f3e.js\",\"8S7hU\",\"ContentWrapperSpotlightGIF-dark.bbe9839d.gif\",\"7P169\",\"ContentWrapperSpotlightGIF-light.9900190e.gif\",\"bP6pn\",\"NthUserOrientationInner.362622a8.js\",\"3Ap7H\",\"RovoAnnouncementSplashModal.47cee64d.js\",\"jhQhN\",\"RovoAnnouncementSplashContainer.1a23a27a.js\",\"br6Aw\",\"LightModeFrame1.88b5dbfe.gif\",\"1CT3s\",\"DarkModeFrame1.6ac03536.gif\",\"cTRon\",\"LightModeFrame2.b826bbb1.gif\",\"2zDRq\",\"DarkModeFrame2.efe28578.gif\",\"7W5z9\",\"LightModeFrame3.dbfb7a04.gif\",\"47RWT\",\"DarkModeFrame3.d087cb13.gif\",\"5CaYW\",\"video-play.924440ef.js\",\"6aY84\",\"video-pause.9effbaae.js\",\"aPSID\",\"smartCreationModal.ab58c8f5.js\",\"gs8si\",\"ConfluenceSmartCreationModalManager.4e116473.js\",\"fQKYr\",\"ConfluenceSmartCreationModal.a74f1ca3.js\",\"k7MRD\",\"showFeedbackFlag.d567da2b.js\",\"jbBJF\",\"CommentEditor.09246f87.js\",\"frhR0\",\"main.3cc72814.js\",\"LQeCh\",\"Rovo-loadingV2.b5f1b3c5.gif\",\"9gDvs\",\"accessibility.5564f20e.svg\",\"f4pjt\",\"award.214f8776.svg\",\"1A7In\",\"calendar.b3d986a4.svg\",\"hbmJV\",\"checklist.73c2b414.svg\",\"dfz72\",\"community.e0696574.svg\",\"8iDBX\",\"customer.b92e93e7.svg\",\"g9qwo\",\"develop.57b4f578.svg\",\"5MnfW\",\"flowchart.a71ff7c1.svg\",\"92hcC\",\"guidelines.997e35c4.svg\",\"YpFw7\",\"hire-writer.de7ada5b.svg\",\"hPfyy\",\"icons-gears.bfd13e5a.svg\",\"4d6gC\",\"icons-people.f158a567.svg\",\"ckHEC\",\"illustrations.98e8bf43.svg\",\"iXa6x\",\"lightbulb.e4ffc69c.svg\",\"lA2m1\",\"marketing.2c92f054.svg\",\"9DSi1\",\"onboarding.43d000af.svg\",\"69pz5\",\"project-management.8376933a.svg\",\"bFaEu\",\"release-phases.4229641f.svg\",\"4HRl6\",\"resilience.4a0de1ce.svg\",\"kyaih\",\"system-of-work.579d0af3.svg\",\"avXjM\",\"tips.695c0031.svg\",\"g7RCN\",\"trust.ae24e421.svg\",\"klZVQ\",\"user-testing.1d397bb2.svg\",\"aSfft\",\"vision-values.6d647ce6.svg\",\"bDavb\",\"volunteering.f0465fb3.svg\",\"7iOBS\",\"ConfluenceCreateIllustrationLight.e6af8be5.svg\",\"gNGuh\",\"ConfluenceCreateIllustrationDark.6237fca1.svg\",\"bgHzk\",\"ConversationAssistant.29028abc.js\",\"7Vmxp\",\"table.21c55c6c.js\",\"koKgZ\",\"datasourceRenderFailedAnalyticsWrapper.bcb2ce11.js\",\"7ixUU\",\"datasourceTableView.ab332101.js\",\"6cVEd\",\"fire-event.25b14310.js\",\"eXGjr\",\"datasourceTableView.edb7dc71.js\",\"7fMGd\",\"dark.16cc06e7.svg\",\"8OP1c\",\"light.e350f7db.svg\",\"gywm1\",\"dark.981334ac.svg\",\"29by2\",\"light.d61b1f64.svg\",\"XXMwE\",\"dark.90199792.svg\",\"cqbvn\",\"light.5ffcf568.svg\",\"bEo2Z\",\"standard.6c3cc6ed.svg\",\"hoPZ9\",\"cs.632c818e.js\",\"gyXEE\",\"cs.54a9e612.js\",\"4Mixi\",\"cs.cbb5fe34.js\",\"2Fu3d\",\"da.7fdeb622.js\",\"1Mp9N\",\"da.d49841ed.js\",\"cjveN\",\"da.835212d1.js\",\"eJgH8\",\"de.43404096.js\",\"dBb6q\",\"de.999b5c94.js\",\"8XGJb\",\"de.a2ec1619.js\",\"2YffH\",\"en.46c7251b.js\",\"7Lkvk\",\"en_GB.89ef6f5e.js\",\"2RQvP\",\"en_GB.4a59edc0.js\",\"hdvZr\",\"en_GB.702092de.js\",\"5FaEJ\",\"en_ZZ.80116467.js\",\"cukQS\",\"en_ZZ.f589829f.js\",\"4ViGN\",\"en_ZZ.bb1eba3d.js\",\"9yemY\",\"es.c70d5778.js\",\"3CucM\",\"es.b941d673.js\",\"32vlK\",\"es.ac31b31a.js\",\"5IaSN\",\"et.ec3e52ec.js\",\"l2LZP\",\"fi.03851af7.js\",\"lp8Wm\",\"fi.7854ba62.js\",\"bjoGV\",\"fi.1e513850.js\",\"35Ssm\",\"fr.1a7ce908.js\",\"cHWSM\",\"fr.456a53ca.js\",\"8oiz7\",\"fr.6f53d7a9.js\",\"ik6u5\",\"hu.536d4aa4.js\",\"b37xN\",\"hu.cffd8ff3.js\",\"hFxmj\",\"hu.cd9b6b61.js\",\"fModo\",\"is.f1385f26.js\",\"Vt6S9\",\"it.fdedf4fa.js\",\"7PjNK\",\"it.ce73937a.js\",\"BXOZB\",\"it.99220f36.js\",\"9GZ76\",\"ja.b1e14937.js\",\"ktSfi\",\"ja.cd9869f4.js\",\"9Xiuh\",\"ja.82009b49.js\",\"4sOIV\",\"ko.3be7f286.js\",\"iouLY\",\"ko.77a2b852.js\",\"7Odo3\",\"ko.f8696b38.js\",\"QTjdE\",\"nb.5931d350.js\",\"hPZE5\",\"nb.bc3bab80.js\",\"4VkvT\",\"nb.7fc4a303.js\",\"hrf1M\",\"nl.2d3dcbec.js\",\"dzIm8\",\"nl.736c884e.js\",\"g5qJV\",\"nl.27391c7e.js\",\"lsloj\",\"pl.0cd9d811.js\",\"jqwnR\",\"pl.aa78124e.js\",\"dPa6p\",\"pl.39ca0fea.js\",\"iRKhU\",\"pt_BR.2ff80609.js\",\"bGhLc\",\"pt_BR.69377af0.js\",\"iG4uh\",\"pt_BR.b57aad22.js\",\"aGECO\",\"pt_PT.791ee0ca.js\",\"aOdaf\",\"ro.389f5bb6.js\",\"aEAsN\",\"ru.77d02867.js\",\"9v6ER\",\"ru.ad0811e9.js\",\"9tVE8\",\"ru.65c56da2.js\",\"5WkxF\",\"sk.627f667c.js\",\"l6YHr\",\"sv.f1d55f3a.js\",\"8Mz40\",\"sv.e48df96b.js\",\"6UAlo\",\"sv.575cc5b8.js\",\"l7PQP\",\"th.93fb5ab5.js\",\"77dzh\",\"tr.1d094af9.js\",\"6NHX3\",\"tr.509cc515.js\",\"9Yw4z\",\"tr.fb23115c.js\",\"fLjHM\",\"uk.7a8159bb.js\",\"3YGga\",\"vi.a291c6ef.js\",\"afU9w\",\"zh_TW.64528ba5.js\",\"hF4v3\",\"zh_TW.2ab7e2a2.js\",\"ia9y3\",\"zh_TW.6efc768f.js\",\"7iCpI\",\"zh.004c8f6a.js\",\"1Tuyb\",\"zh.1e8977fa.js\",\"15ncj\",\"zh.f634978a.js\",\"2lsX7\",\"main.33e42dd9.js\",\"jYGxH\",\"th.979bffc6.js\",\"czAFw\",\"tr.681a53e9.js\",\"c0Efy\",\"uk.94c09e9c.js\",\"dKBuH\",\"vi.58f3aadb.js\",\"cU3hB\",\"smart-creation-wrapper.8646d81e.js\",\"iuu5K\",\"ConfluenceSmartCreationModal.fb492801.js\",\"lPsQk\",\"error-smart-create-icon.94df62fb.svg\",\"hFXeG\",\"main.0462ba49.js\",\"jn9xB\",\"Create-with-Rovo-Loading-Dark-Mode.07403868.gif\",\"81ouS\",\"Create-with-Rovo-Loading-Light-Mode.41a65ca6.gif\",\"lbiHc\",\"database-drafts-icon.3feeafba.png\",\"kroVc\",\"docs-drafts-icon.89c35078.png\",\"jG9WP\",\"whiteboard-drafts-icon.1347e699.png\",\"ayspZ\",\"ui.1b8aed52.js\",\"aWHeV\",\"rovo-mobile-app-onelink.4e56e554.svg\",\"5m8Kg\",\"analyze-icon.5c4c7ecb.svg\",\"b2eNj\",\"brainstorm-icon.f24d96f2.svg\",\"4ofWJ\",\"create-icon.59c93a6c.svg\",\"jdeyK\",\"execute-icon.d7c359b6.svg\",\"5faYL\",\"find-icon.63225fe6.svg\",\"80D6g\",\"general-prompt-icon.5618909f.svg\",\"lPxCc\",\"learn-icon.7e0ca0d6.svg\",\"aDBGk\",\"review-icon.7da7ded4.svg\",\"grAf6\",\"summarize-icon.5a91c5af.svg\",\"8HdRH\",\"build-icon-no-prompts.73453fad.svg\",\"5UFNX\",\"favorites-empty.0cc258ba.svg\",\"9wrpL\",\"no-results.db2e9229.svg\",\"iraZ1\",\"react-markdown.d0df5225.js\",\"3GB1F\",\"conversation-assistant-viz.aceb41ac.js\",\"slRZz\",\"charts.c0053bef.js\",\"JEQyV\",\"GoalPanel.46dcf33c.js\",\"vP4QH\",\"GoalPanel.32140771.js\",\"5TD4G\",\"charts.bded86ac.js\",\"7sx4A\",\"charts.e7f5dedd.js\",\"1iNFh\",\"charts.6c9687c6.js\",\"9LUXP\",\"schema.f8c599e4.js\",\"jfCh6\",\"rovo.b06223c6.png\",\"7rHnm\",\"rovo-chat-bubbles.ad8ad13a.svg\",\"2SwYm\",\"deep-research-icon-dark-mode.184ef24b.svg\",\"aSjVK\",\"deep-research-icon-light-mode.626661c3.svg\",\"bHRnB\",\"deep-research-icon.837407f5.svg\",\"ixTAZ\",\"text-field.3fa52048.js\",\"bvkpZ\",\"text-area.732a8a35.js\",\"e3d45\",\"date-time-picker.0ac3a6a9.js\",\"d34hg\",\"gic-anywhere.b46e9f5a.js\",\"2O2Xv\",\"gic-anywhere.c731b3df.js\",\"anP9P\",\"error.5fbc7fe9.png\",\"SOdyt\",\"CommentEditor.69ba6462.js\",\"2MGzj\",\"RovoLoadingGif.5cc45056.js\",\"ha91h\",\"Rovo-loadingV2.b5f1b3c5.gif\",\"gvJDI\",\"generic-issue-type-icon.b13acfc5.svg\",\"i7J2B\",\"avatar-with-arrow-darkmode.d9464bf1.svg\",\"2FbWf\",\"avatar-with-arrow.71e68580.svg\",\"3Xxws\",\"avatar-with-lock-darkmode.39948dbb.svg\",\"85zTu\",\"avatar-with-lock.b0750eee.svg\",\"girkx\",\"pencilled-field-with-arrow-darkmode.9a09e770.svg\",\"dCfoG\",\"pencilled-field-with-arrow.6615a67d.svg\",\"dG1sE\",\"text-field-with-lock-darkmode.6b00710c.svg\",\"jQD4g\",\"text-field-with-lock.548927e7.svg\",\"hZ3Uy\",\"text-field-with-tick-darkmode.49503976.svg\",\"h1tvj\",\"text-field-with-tick.9650a889.svg\",\"8jz4U\",\"mcp-server-tools.b598a546.js\",\"jALB7\",\"database-icon.af3511fd.svg\",\"aLbrw\",\"live-docs-icon.5595b5be.svg\",\"fe7gr\",\"page-icon.4dd78b86.svg\",\"cknJE\",\"preview-card-database-header.8549ac7f.svg\",\"gMvyv\",\"preview-card-page-header.8639e9c6.svg\",\"6p1RF\",\"preview-card-whiteboard-header.a8b554de.svg\",\"fuzt0\",\"whiteboard-icon.552d11f4.svg\",\"5Vin3\",\"gic-modal.91ee5cde.js\",\"5Y2To\",\"GoalPanel.c4852ac9.js\",\"3knTu\",\"light-version.6420440b.js\",\"drlw9\",\"Rovo-Growth.a6bc0c17.gif\",\"8h7WZ\",\"dark-version.767ba474.js\",\"9eO7r\",\"Rovo-Growth-Dark-Mode.b8619563.gif\",\"jQ7iC\",\"break-down-complex-issues-icon-dark-mode.3637919d.svg\",\"dluAX\",\"break-down-complex-issues-icon-light-mode.e8413fb5.svg\",\"6eL5q\",\"catchup-after-time-away-icon-dark-mode.f2e7a9cc.svg\",\"px5Rh\",\"catchup-after-time-away-icon-light-mode.b504f053.svg\",\"lTTCt\",\"create-issue-icon-dark-mode.75867f58.svg\",\"f4RDh\",\"create-issue-icon-light-mode.69e10720.svg\",\"6f9GG\",\"draft-helpful-comments-or-updates-icon-dark-mode.5795c228.svg\",\"cYCEg\",\"draft-helpful-comments-or-updates-icon-light-mode.3c50255e.svg\",\"5uq7r\",\"make-my-issues-clearer-icon-dark-mode.9e7e9a04.svg\",\"jXQMa\",\"make-my-issues-clearer-icon-light-mode.34de1b99.svg\",\"6OJV3\",\"share-my-work-with-stakeholders-icon-dark-mode.d3e80c8a.svg\",\"hRPth\",\"share-my-work-with-stakeholders-icon-light-mode.5035c548.svg\",\"lXkAL\",\"InformationModal.6b9a61c8.js\",\"2xz6W\",\"feedback-flag.66cb31f5.js\",\"lc53W\",\"local-frontend-components.8921bf36.js\",\"3Bbwl\",\"filter.6126c2d3.js\",\"ivmlR\",\"memory-disabled-illustration-dark.3a822b8c.svg\",\"7eY0a\",\"memory-disabled-illustration.ef65f216.svg\",\"6WXM9\",\"memory-empty-illustration-dark.a8b58040.svg\",\"2vldX\",\"memory-empty-illustration.1df2a423.svg\",\"9xFsB\",\"memory-list-error.d375feb8.svg\",\"c0JsV\",\"link-picker.2cb15caa.js\",\"9S9Mz\",\"render.c86884e8.js\",\"h05Zl\",\"ufo.1597da7c.js\",\"8MfZE\",\"component-lazy.fcceae54.js\",\"855o0\",\"component-lazy.runtime.223cc788.js\",\"xlj4N\",\"component-lazy.30ec3c7c.js\",\"2eTjQ\",\"component-lazy.runtime.327e698f.js\",\"ls88c\",\"component-lazy.5c8125b1.js\",\"crh7e\",\"component-lazy.runtime.3b767eda.js\",\"3w411\",\"modal.28db2871.js\",\"e4wOQ\",\"modal.7456f2d5.js\",\"b2FtX\",\"browse-agents.d0694ffe.js\",\"fjxeQ\",\"browse-agents.dd896ee2.js\",\"3EXzu\",\"render.f93c3381.js\",\"dUz9k\",\"FullPageEditorComponent.a19d0add.js\",\"eBY1U\",\"FullPageEditorComponent.runtime.5f488a09.js\",\"gVbhn\",\"FullPageEditorComponent.1d97ece0.js\",\"7czq2\",\"FullPageEditorComponent.af229984.js\",\"70l64\",\"FullPageEditorComponent.runtime.bc454458.js\",\"5BEZW\",\"FullPageEditorComponent.260f7f76.js\",\"49cor\",\"agent-section.36267737.js\",\"7E8Pd\",\"mention.04e82ce2.js\",\"3fdRd\",\"recommended-agents-preloader.4d3df9f2.js\",\"1yrlK\",\"assets.a36da6b7.js\",\"czqcb\",\"chart-bar-line.30aba5fa.js\",\"8vVzT\",\"chart-pie.1284a097.js\",\"hpUn4\",\"plan.accf305e.js\",\"l4YAS\",\"project-status.e6d456e7.js\",\"6HxBR\",\"merge-success.ee5b4447.js\",\"4rKYa\",\"person-added.bc078926.js\",\"iMSgb\",\"log-in.9b553c7d.js\",\"8Qv5g\",\"transition.dc10ff19.js\",\"48rvp\",\"app-switcher.41220b81.js\",\"1okAQ\",\"ai-generative-chapters.ac931bcf.js\",\"eF7Ol\",\"talent.3167265e.js\",\"3TFqP\",\"form.ca6bb7f6.js\",\"334w0\",\"ticket.4ed0e792.js\",\"2ABJz\",\"alert.59831ff5.js\",\"cSj9q\",\"pulse.e6f59a11.js\",\"9f5Sw\",\"text-lengthen.75abb5d6.js\",\"euJgP\",\"preview-bg.12045916.svg\",\"2fk6g\",\"16.54cd560a.js\",\"72780\",\"24.6148855e.js\",\"3M4Om\",\"24.8ce41ca4.js\",\"3QZdB\",\"24.ff51bea3.js\",\"hszIA\",\"24.2e0800d1.js\",\"4jPsO\",\"24.49c3df9a.js\",\"jDjSj\",\"16.e2828260.js\",\"kknf5\",\"16.0e4763bf.js\",\"8059b\",\"16.7a072357.js\",\"3wmvj\",\"16.3a0a4f53.js\",\"6BeQr\",\"16.1ca294db.js\",\"hPalR\",\"16.3dfc4282.js\",\"ijPJo\",\"spreadsheet.8bd9df3a.js\",\"d4u0p\",\"CommentEditor.8b140bb3.js\",\"1GvGi\",\"CommentEditor.runtime.d62dd9d4.js\",\"fJtJG\",\"CommentsPanelFilterMenu.41a48eb2.js\",\"1P7J4\",\"FullPageEditorComponent.4b3a4f87.js\",\"588p0\",\"FullPageEditorComponent.ea491647.js\",\"cnV3p\",\"ConversationAssistant.f330a918.js\",\"bWQZc\",\"3p-product-configs.614eec6c.js\",\"6XaQi\",\"post-office-placement-remote.1459f113.js\",\"1r59t\",\"Controller.597a915c.js\",\"gEFqn\",\"Controller.runtime.ad2d63ed.js\",\"itWY8\",\"post-office-placement-remote.111203b2.js\",\"gEFqn\",\"Controller.runtime.ad2d63ed.js\",\"397zr\",\"conversation-assistant-auto-suggest.77572f6e.js\",\"ca4xD\",\"ConversationAssistant.4c873a5f.js\",\"6SM2I\",\"cs.fced59d2.js\",\"ivb6v\",\"da.efd8e956.js\",\"7LTI5\",\"de.92bf7124.js\",\"hgUao\",\"en_GB.ccd34138.js\",\"j787T\",\"en_ZZ.d113c972.js\",\"aEmWg\",\"es.6dbeaf2e.js\",\"eR8Wp\",\"fi.75babc08.js\",\"72xPj\",\"fr.46a790f6.js\",\"1OOEW\",\"hr.11a83462.js\",\"jPs8I\",\"hu.065572e0.js\",\"8dbN2\",\"it.66391f2b.js\",\"i9Imr\",\"ja.b6e444b2.js\",\"kYLWR\",\"ko.ccd74e63.js\",\"lC975\",\"nb.92290c76.js\",\"jyEOm\",\"nl.1cfc5dc4.js\",\"agZBy\",\"pl.aa296ade.js\",\"i0zKK\",\"pt_BR.9268b557.js\",\"2zDhc\",\"ru.f0101ff1.js\",\"4eO7d\",\"sl.1b3b6bcd.js\",\"1Tr0G\",\"sr_RS.2f9f0304.js\",\"fGDED\",\"sr_YR.f4aec80b.js\",\"2l8tR\",\"sv.f8d2cb8e.js\",\"4JJfl\",\"th.dff0bbe3.js\",\"hYpqC\",\"tr.25362355.js\",\"cjEKg\",\"uk.49c97ab6.js\",\"faxoo\",\"vi.0294c992.js\",\"a2X8X\",\"zh_TW.0a2a8960.js\",\"4arx8\",\"zh.03e89d1a.js\",\"jTExV\",\"object-list-flyout-content.4ae57080.js\",\"je720\",\"no-results-dark.90199792.svg\",\"5CyuG\",\"no-results-light.5ffcf568.svg\",\"cGPv6\",\"empty.72f8b026.svg\",\"9Y153\",\"starred-empty.227ae17e.svg\",\"1B7k9\",\"error-state-dark.fd22b26d.svg\",\"9Ftrm\",\"error-state-light.f4c1cfc8.svg\",\"b9XqL\",\"no-results-dark.90199792.svg\",\"d019N\",\"no-results-light.5ffcf568.svg\",\"igAEH\",\"filters-dropdown.86c29e9c.js\",\"5jNvH\",\"object-list-flyout-content.c8dc55dd.js\",\"eC0VO\",\"content.177103b7.js\",\"pHE7k\",\"customization-modal.ea737634.js\",\"gbrgG\",\"customization-modal.00490445.js\",\"fcgjS\",\"ConversationAssistant.6be5f620.js\",\"kSezy\",\"ConversationAssistant.b95cc8d4.js\",\"d4ByE\",\"cs.4747be9f.js\",\"5hSoy\",\"da.c28f2096.js\",\"7VsjH\",\"de.12b0866f.js\",\"a268B\",\"en_GB.b8092c16.js\",\"lhSi1\",\"en_ZZ.b69df8a1.js\",\"ft9Ll\",\"es.d684b29d.js\",\"jTa87\",\"fi.0e346fb1.js\",\"aNiGa\",\"fr.744480ea.js\",\"4r8Lc\",\"hr.143bed07.js\",\"hgY73\",\"hu.93fdcc96.js\",\"dlCkw\",\"it.15982c3d.js\",\"l9GjK\",\"ja.bde875c6.js\",\"fz30M\",\"ko.fb33a670.js\",\"kALI0\",\"nb.8e7470f4.js\",\"JRBbC\",\"pl.cc5df515.js\",\"9eERo\",\"pt_BR.4e2e0d40.js\",\"9kBhC\",\"ru.235eb619.js\",\"bzIZv\",\"sl.0b5a0129.js\",\"ab9gs\",\"sr_RS.7487407b.js\",\"awEHL\",\"sr_YR.54bb4a07.js\",\"d0TBI\",\"sv.d37eccea.js\",\"44Tsr\",\"th.4d8475b2.js\",\"52Fkw\",\"tr.4ea1bdea.js\",\"15Ksq\",\"uk.bc3bafc9.js\",\"7uvuw\",\"vi.d249824b.js\",\"8j70M\",\"zh_TW.f52624f5.js\",\"7d6QX\",\"zh.92124f88.js\",\"03aeW\",\"en_GB.0ccf7aa9.js\",\"6nK39\",\"th.e2448a24.js\",\"hWNfo\",\"tr.5e69c2fc.js\",\"8UuQQ\",\"uk.11b615ac.js\",\"6BkMx\",\"vi.352470f3.js\",\"iqTGf\",\"GoalPanel.e1a6e8a4.js\",\"1it7j\",\"definition-popup-content.b897519a.js\",\"c4B8Z\",\"ai-feedback-flags.137115f6.js\",\"lb9xb\",\"smart-card.25cfa09c.js\",\"fPDs0\",\"Rovo.e24f6f93.svg\",\"EfTik\",\"hoverCard.cc67c640.js\",\"crh7e\",\"component-lazy.runtime.3b767eda.js\",\"6PtxN\",\"cs.4af6da41.js\",\"8RKtn\",\"da.00cc494f.js\",\"fCIoO\",\"de.feb55cf0.js\",\"1geBW\",\"es.2b9a509c.js\",\"5WU5D\",\"et.c12c2abb.js\",\"i1Uow\",\"fi.577f953a.js\",\"3ZuKT\",\"fr.6da7024a.js\",\"5nJlY\",\"hu.3d953190.js\",\"Uq5C2\",\"it.d747a7e7.js\",\"9TzAL\",\"ja.6cac578c.js\",\"oPAjm\",\"ko.e5176471.js\",\"3fvcK\",\"nb.cf4f3e33.js\",\"iMYDs\",\"nl.0646b6ed.js\",\"jPHqC\",\"pl.7e10aa61.js\",\"3saM6\",\"pt_BR.2e845e69.js\",\"4hCdo\",\"pt_PT.3585f16f.js\",\"78gs3\",\"ru.6f4b63fe.js\",\"2XhMA\",\"sk.9b031399.js\",\"f7Egw\",\"sv.567af81d.js\",\"aiZUj\",\"tr.5656666a.js\",\"6rH3p\",\"th.f0261be3.js\",\"lS1VG\",\"uk.fe1da325.js\",\"fFbe4\",\"vi.32dd8df9.js\",\"7JTjB\",\"zh_TW.3a48b1fe.js\",\"dMjyc\",\"zh.37507780.js\",\"cPSQq\",\"renderer.b33be1bd.js\",\"9wbwa\",\"calendar-dark.a0ed3c18.svg\",\"edV1v\",\"calendar-light.caa4677f.svg\",\"5P10P\",\"location-dark.395fc7dc.svg\",\"1jWRt\",\"location-light.9d9cfd0a.svg\",\"bGCo4\",\"definition-popup-content.d54cfabb.js\",\"fw9bs\",\"error-state-image.823f6961.png\",\"855o0\",\"component-lazy.runtime.223cc788.js\",\"2eTjQ\",\"component-lazy.runtime.327e698f.js\",\"70l64\",\"FullPageEditorComponent.runtime.bc454458.js\",\"eBY1U\",\"FullPageEditorComponent.runtime.5f488a09.js\",\"1GvGi\",\"CommentEditor.runtime.d62dd9d4.js\",\"dj3mE\",\"ExperimentPlanSelectionModal.50c4df87.js\",\"3AFNb\",\"illustrationStandard.3fd561a4.svg\",\"c7qkT\",\"illustrationBestValue.d42ec92a.svg\",\"cYTMv\",\"illustrationBestValueDarkMode.4db8a5eb.svg\",\"eRZ4m\",\"illustrationStandardDarkMode.d9f68860.svg\",\"ktyyJ\",\"TrialFlags.802e2359.js\",\"8QqMt\",\"GlobalComponents.7b1a0be0.js\",\"lz2pE\",\"EditionAwarenessUpsell.2f241139.js\",\"eWCiQ\",\"standard-to-premium-modal.343f57dc.js\",\"lRtGG\",\"dashboard.839aaa25.js\",\"becB8\",\"on-call.39b97377.js\",\"adH3p\",\"roadmap.beb86071.js\",\"gjVBG\",\"devices.13a157d4.js\",\"hUapU\",\"StandardToPremiumModal.8e6b03f7.js\",\"dNed9\",\"standard-to-premium-modal.17aa0de7.js\",\"gobtw\",\"cs.f2325b58.js\",\"4XclW\",\"da.8823548e.js\",\"5FpC5\",\"de.9f8c75dc.js\",\"Z7F9W\",\"en_GB.88145e4b.js\",\"5vJlz\",\"en_ZZ.6e66d65b.js\",\"kqbLA\",\"es.ebafda9e.js\",\"2xTUv\",\"fi.e29037f1.js\",\"ke5Ak\",\"fr.c635078e.js\",\"78Xv1\",\"hu.36e2e3d5.js\",\"9WYDz\",\"it.b621bab0.js\",\"14Xp5\",\"ja.00759942.js\",\"5YZ43\",\"ko.cb3af28f.js\",\"hcAAz\",\"nb.cd8afc0a.js\",\"a3CGb\",\"nl.7356521a.js\",\"3jRvQ\",\"pl.7af8622a.js\",\"3eKFX\",\"pt_BR.24688c8c.js\",\"2cWJ7\",\"ru.b416633d.js\",\"7io6v\",\"sv.370b80d6.js\",\"bcDrQ\",\"th.aaf28806.js\",\"23xaC\",\"tr.5a5f7532.js\",\"dBkXE\",\"uk.f9026017.js\",\"fQKkM\",\"vi.09fcf459.js\",\"cXjwK\",\"zh_TW.2cb7259f.js\",\"fCfjN\",\"zh.9966cb4b.js\",\"eeaKR\",\"credit-card.39a2b6fa.js\",\"eufZR\",\"LoomCrossFlowPopupComponent.524e99ee.js\",\"3FT39\",\"cs.b4709f80.js\",\"7QoTg\",\"da.e788fd22.js\",\"d1Lrf\",\"de.2dd434ed.js\",\"kM5GB\",\"en_GB.82797faf.js\",\"5506N\",\"en_ZZ.a7c6e9ad.js\",\"7ioy0\",\"es.a4af58eb.js\",\"kZ6zs\",\"fi.aaa32cea.js\",\"phbpE\",\"fr.0e55ec47.js\",\"6pKhl\",\"hu.8153cc96.js\",\"hzLOt\",\"it.75418871.js\",\"1M8mW\",\"ja.6ef7e39a.js\",\"eHQAY\",\"ko.36b5b8ee.js\",\"8exPB\",\"nb.9e9e6a03.js\",\"knfAP\",\"nl.dbd0c739.js\",\"ljRXP\",\"pl.7932a8db.js\",\"bEb8c\",\"pt_BR.e2f7c972.js\",\"c7JYF\",\"ru.a2b7a11a.js\",\"ari8V\",\"sv.1d81f4cf.js\",\"kfrHX\",\"th.0d215dce.js\",\"aWToy\",\"tr.9415008a.js\",\"4ns5x\",\"uk.baa17c6e.js\",\"7bfAn\",\"vi.26b5754b.js\",\"gftgT\",\"zh_TW.b791e5b1.js\",\"6YVlG\",\"zh.ccb62d88.js\",\"kFEyO\",\"top-nav-items.e51ea6e5.js\",\"lxvzP\",\"EditionAwarenessUpsell.4623662a.js\",\"9CRBg\",\"StandardToPremiumModal.33667c3d.js\",\"4dNRa\",\"EndOfPageRecommendation.20b7fb1e.js\",\"2F69B\",\"vendors~small-pkgs.8e554367.js\",\"66kde\",\"ContentTreeOnboarding.e10be916.js\",\"DerzA\",\"EditPageContainer.ca617e26.js\",\"fno6o\",\"RestrictionsDialogMountPoint.e9e2790d.js\",\"inQqk\",\"RestrictionsDialog.f3fd2148.js\",\"9NxYX\",\"no-restriction-illustration-Light.a376c323.svg\",\"lpZU0\",\"no-restriction-illustration-Dark.8da66227.svg\",\"kgrX3\",\"no-restriction-illustration-pencil-Light.bcc52320.svg\",\"bRk6k\",\"no-restriction-illustration-pencil-Dark.5e6368e9.svg\",\"1DRtS\",\"no-restrictions-illustration-external-share-Light.85b8ab71.svg\",\"hhpRR\",\"no-restrictions-illustration-external-share-Dark.dff9aa3b.svg\",\"69XGw\",\"InspectPermissionsEntryPoint.d1e4dfb0.js\",\"4yUSc\",\"PremiumLozenge.3830a299.js\",\"ePA5l\",\"Lozenge.8ff6ea35.js\",\"Cp4j9\",\"Controller.638dcef3.js\",\"iO9O1\",\"personal_space.c63f5733.png\",\"a8Jk0\",\"Controller.511da62f.js\",\"13QWg\",\"in-trial-feature-gates-banner.150d1aa7.js\",\"hdHXt\",\"NativeCollabComponent.d0ec9b75.js\",\"85liN\",\"InspectPermissionsDialog.1e3f48d0.js\",\"aX0L0\",\"InspectPermissionsDialog.28456d38.js\",\"lk4cE\",\"RequestAccessPopup.a9811ec1.js\",\"4mWJk\",\"GrantAccessFlag.854c75c4.js\",\"1sXQt\",\"FavouriteButton.29992fbd.js\",\"23MlT\",\"RevertEditorDialog.3d9f878a.js\",\"RU02s\",\"ConvertToLivePageDialog.3baf3de9.js\",\"aS96v\",\"ResolvedInlineCommentsCounter.df965929.js\",\"4hZJd\",\"EmojiTitleSelection.f64124db.js\",\"XgRtr\",\"EmojiPicker.a53de5b4.js\",\"hUvv7\",\"LiveDocsDefaultIcon.97211d26.js\",\"dlm6q\",\"InlineRename.b91d09b9.js\",\"2VACG\",\"RestrictionsUpsellDialog.140d63fa.js\",\"1zoBu\",\"ChangeEditionInlineDialog.80335961.js\",\"bfhXH\",\"RestrictionsButton.0f6ca912.js\",\"gvrSR\",\"Controller.913ee093.js\",\"5iVCs\",\"cs.6a4c25c7.js\",\"k7RZQ\",\"da.9877c37f.js\",\"9CFJc\",\"de.bb97d0fd.js\",\"3fPuK\",\"en_GB.9561a37b.js\",\"dUyEb\",\"en_ZZ.c7ec2c16.js\",\"PAD2J\",\"es.8b476d00.js\",\"GNuQo\",\"fi.625ea11d.js\",\"fvsAU\",\"fr.3c57c9b9.js\",\"h7dGJ\",\"hu.a577b1ea.js\",\"kg6sH\",\"it.bd75db28.js\",\"fqF5W\",\"ja.edd3a363.js\",\"1WNp5\",\"ko.b85ae1d4.js\",\"iHPxa\",\"nb.20c3bd75.js\",\"Qf3VH\",\"nl.573e6cdf.js\",\"79OEV\",\"pl.98acd127.js\",\"27dMt\",\"pt_BR.405f85d7.js\",\"bkVVv\",\"ru.c004cf49.js\",\"MLhYA\",\"sv.aaf78479.js\",\"ap7kW\",\"th.a4a6fd4b.js\",\"45YAR\",\"tr.b2cb22e6.js\",\"kqhVG\",\"uk.47e01bb2.js\",\"1susf\",\"vi.1184af6c.js\",\"dl3k2\",\"zh_TW.6e51a40f.js\",\"aquXY\",\"zh.f784abff.js\",\"gY1B8\",\"async.35d8df09.js\",\"35VU5\",\"cs.d801dcbc.js\",\"6W6gh\",\"da.bac7ddcf.js\",\"bfTAm\",\"de.c95398fc.js\",\"fP9up\",\"en_GB.9979f0fa.js\",\"hc0i6\",\"en.8c08f35e.js\",\"15E48\",\"en_ZZ.0cfe40bf.js\",\"jLWG0\",\"es.7e41636e.js\",\"9J49E\",\"fi.89090e5d.js\",\"br9SP\",\"fr.2a048ea9.js\",\"5h4sF\",\"hu.c2dc4635.js\",\"1MV5Z\",\"it.05b27b71.js\",\"iV5Fv\",\"ja.7b259d22.js\",\"7R5mJ\",\"ko.203f86ca.js\",\"5XMUp\",\"nb.e44f5efd.js\",\"jaDFz\",\"nl.405ee529.js\",\"LOg5S\",\"pl.23c5179b.js\",\"lnJdQ\",\"pt_BR.805e95d7.js\",\"hqsLl\",\"ru.c980f637.js\",\"j0btO\",\"sv.9635f53d.js\",\"2YEqr\",\"tr.ddf2ab95.js\",\"7zFV7\",\"th.3ecc11fa.js\",\"fZ22O\",\"uk.04a59e12.js\",\"4tleS\",\"vi.cca22a6d.js\",\"bE6tX\",\"zh_TW.af40ed8f.js\",\"esYD7\",\"zh.8eeac7b4.js\",\"3WvvM\",\"CoreInvites.68ff867c.js\",\"7oczk\",\"cs.8ce677a9.js\",\"e2gl6\",\"da.144bf782.js\",\"9oo3s\",\"de.8b728a39.js\",\"1ZyUV\",\"es.6e5d4e2c.js\",\"6tijD\",\"et.a748dc81.js\",\"6fkVy\",\"fi.770eedc0.js\",\"5nw5x\",\"fr.c78dff1c.js\",\"jK12s\",\"hu.6cd67457.js\",\"6lWvL\",\"is.e7fee0c5.js\",\"kk9To\",\"it.11c8df23.js\",\"lyt83\",\"ja.1c0a9469.js\",\"2uvfp\",\"ko.0993836f.js\",\"4Wx8B\",\"nb.7422f506.js\",\"huTg5\",\"nl.d63f3676.js\",\"fPfEd\",\"pl.60f64046.js\",\"fTYhL\",\"pt_BR.f1b5821f.js\",\"dVHhf\",\"pt_PT.137566ba.js\",\"2SsCI\",\"ro.a2a72a07.js\",\"kVi5E\",\"ru.e13f4e36.js\",\"6HoYh\",\"sk.63554299.js\",\"kOAvl\",\"sv.0c110c42.js\",\"5ErHy\",\"tr.eb8f4d08.js\",\"jJzpI\",\"th.40dad87b.js\",\"2PvRH\",\"uk.418bc1c8.js\",\"eUGjU\",\"vi.b62f5e14.js\",\"drbCf\",\"zh_TW.61263813.js\",\"5dk6T\",\"zh.b7192b9d.js\",\"7pAFt\",\"WarningIllustration.6f86942e.js\",\"2CfIU\",\"WarningIllustration.ec26752f.png\",\"1TOYq\",\"CoreInvites.6f54db57.js\",\"geh8r\",\"AdminNavigation.c0197d92.js\",\"kBLei\",\"PersistentCollapsibleSection.8bd2674b.js\",\"dviIw\",\"CollapsibleSection.c762c0bf.js\",\"5E6oP\",\"AutomationOnBoarding.e83dc203.js\",\"1TfYn\",\"AutomationLight.3a471294.png\",\"5ZTDJ\",\"AutomationDark.427f07ad.png\",\"8s35j\",\"SpaceRolesLozenge.309a7f7d.js\",\"gRwQ3\",\"cash.f61073db.js\",\"830Zv\",\"HubSettingsNavigation.32b43774.js\",\"cD5e0\",\"GlobalNavigationComponent.a0ad1efc.js\",\"k7TXX\",\"people-teams.312747f4.js\",\"c6USO\",\"TeamProfileCardEntryPoint.28c80f5c.js\",\"48eS0\",\"cs.473760f2.js\",\"lak6L\",\"da.2148425a.js\",\"inCHL\",\"de.54943eb3.js\",\"lLx4a\",\"en.3be1be31.js\",\"auTAr\",\"en_GB.a2dc38b7.js\",\"9pxVf\",\"en_ZZ.2b03ebf2.js\",\"4cEzx\",\"es.89bc2922.js\",\"iUIL3\",\"et.8f07e723.js\",\"lADZV\",\"fi.322d3cd4.js\",\"1QHKh\",\"fr.b4f35314.js\",\"2Tjcq\",\"hu.9ecb9575.js\",\"4WVVc\",\"is.aa3b7b54.js\",\"1QNch\",\"it.e25db4e4.js\",\"jQCyA\",\"ja.0ddab2f2.js\",\"aQwae\",\"ko.e4e697cd.js\",\"cS1j1\",\"nb.753a83ee.js\",\"48pzM\",\"nl.2a2ad011.js\",\"c4a0F\",\"pl.173f9fb9.js\",\"cBmO4\",\"pt_PT.fb87e247.js\",\"9e3Ob\",\"pt_BR.5d0f712d.js\",\"7Hoje\",\"ro.6553ad3e.js\",\"4dj0m\",\"ru.14ff62d0.js\",\"j5HYK\",\"sk.89deb301.js\",\"1VsiM\",\"sv.dd2618b6.js\",\"8CqFM\",\"tr.d8a87762.js\",\"5bAmA\",\"th.0f648ee2.js\",\"i0Evx\",\"uk.9ffebeba.js\",\"j8OKz\",\"vi.77783e57.js\",\"2s1Lz\",\"zh.c8085958.js\",\"iI3rq\",\"zh_TW.94720f2d.js\",\"7MCI9\",\"people-teams.61db6eab.js\",\"2ZKtw\",\"main.66b028b8.js\",\"dFhUX\",\"invited-app-popup.4c209f23.js\",\"h2810\",\"PersistentInvitePeopleButton.e75148d9.js\",\"aGsq7\",\"companyHubItemCallback.2425f414.js\",\"SepNY\",\"analyticsCallbacks.738ed835.js\",\"03cvv\",\"errorWarning.3a015e54.svg\",\"dvjk6\",\"noResultsDark.90199792.svg\",\"57B0v\",\"noResultsLight.5ffcf568.svg\",\"2yM8Y\",\"RecentContentMenu.1d305d7b.js\",\"b3B6t\",\"coffeeChat.72f8b026.svg\",\"dbIft\",\"emptyStarBox.3b01bf42.svg\",\"7JfxY\",\"SpacesDropdown.34ac533b.js\",\"7QQL7\",\"GlobalCreateContentPopoverMenu.90ff3396.js\",\"kiDFE\",\"CreateSpaceMenuItem.efc8e4e6.js\",\"lWi9V\",\"CreateSpaceMenuItemNav3.dd78c5c3.js\",\"3tVyh\",\"CreateSpacePlusButton.4e520adb.js\",\"9jGiN\",\"DiscoverSection.2678701d.js\",\"brnyq\",\"miro.cb595030.png\",\"1IPtO\",\"slack.ba8f92ff.png\",\"gSraM\",\"invision.8f2e37e4.png\",\"8b1I3\",\"google-drive.d0028a0e.png\",\"6bVkQ\",\"lucidchart.8807407a.png\",\"FBIp4\",\"TeamsAppShortcutItem.2aca9a19.js\",\"borwc\",\"CustomizationModal.f5775e06.js\",\"9a2oY\",\"home.c75a599b.js\",\"1epse\",\"GuestRequestToUpgradeLearnMoreModal.26b9590e.js\",\"8Txex\",\"Guest-Avatar.ebdf69f1.svg\",\"2wyTK\",\"Team-Avatars.4f1b07ad.svg\",\"hyzoX\",\"ProjectPanel.e43ff56f.js\",\"6S3Gy\",\"marketplace.8761e365.js\",\"81eQE\",\"hashtag.01b327f2.js\",\"dZJOw\",\"GlobalNavigationComponent.dc2115a4.js\",\"69GDg\",\"Home.eb3dbfc7.gif\",\"bxhxc\",\"Home-dark.b4541437.gif\",\"216TD\",\"Home-placeholder.72eb75ff.png\",\"7Bv6F\",\"Home-placeholder-dark.86521bfc.png\",\"8C3iq\",\"GlobalNavigationComponent.748795e9.js\",\"a1VZ3\",\"GlobalNavigationComponent.1e51c183.js\",\"hmXd6\",\"fileCabinet.17ae0554.svg\",\"17BHA\",\"noResultsDark.90199792.svg\",\"7S3sF\",\"noResultsLight.5ffcf568.svg\",\"aYgZt\",\"SpaceNavigation.2caaf25c.js\",\"TkY5q\",\"RtPaidFeatureEducationSpotlight.22e671b4.js\",\"cJHFd\",\"Nav3SpaceNavigationContent.6d72836b.js\",\"ltXeo\",\"PageTree.3ee94d45.js\",\"gODOu\",\"RtPaidFeatureEducationSpotlightTarget.ba19a426.js\",\"dkv9z\",\"PageTreeAfterIcon.63a6310e.js\",\"9F7vX\",\"CreateContentPopover.afd9b933.js\",\"dnVDi\",\"top-nav-items.49e708ed.js\",\"hLjS5\",\"notification.af51f62d.js\",\"dwffN\",\"GlobalCreateContentPopoverMenu.de67c59b.js\",\"beE2d\",\"NativeCollabComponent.c388307d.js\",\"1I3mw\",\"ContextualCreateContentPopoverMenu.a5dd5eff.js\",\"np2ZB\",\"NonMasteredUserModal.dbeb8427.js\",\"j2eUy\",\"nonMasteredUserModalSplashImage.90ba8397.svg\",\"hq1Iv\",\"masteringFlowSplashImage.1f9bd0cc.svg\",\"4byV5\",\"is-supported.2259c710.js\",\"lwKXH\",\"is-supported.1cce24bb.js\",\"btYwu\",\"esm.0f4fc4bc.js\",\"28l1x\",\"esm.add861d6.js\",\"wIOhQ\",\"esm.778966b6.js\",\"9LQGG\",\"close.f1edfb26.js\",\"4drdS\",\"paint-palette.c083dcd8.js\",\"xvDzM\",\"success.1bcc5fc4.js\",\"lnk1B\",\"ContextualCreateContentPopoverMenu.e93d9d93.js\",\"daoWf\",\"LoomCrossSellPopupCardImage.6e60c328.png\",\"hU8F9\",\"LoomCrossSellPopupCardImageNewVisual_Light.55587eef.png\",\"fTxJf\",\"LoomCrossSellPopupCardImageNewVisual_Dark.c1c1769c.png\",\"aDPqY\",\"ContextualCreateContentPopoverMenu.4087a3bd.js\",\"BgBDS\",\"Racecar.f378b1ee.svg\",\"2xzYJ\",\"ContextualCreateContentPopoverMenu.95a30129.js\",\"h4qu8\",\"LiveDocsIntroGif.d2fc0787.gif\",\"j7hKO\",\"LiveDocIntroGADark.45e6357d.svg\",\"7yu5V\",\"LiveDocIntroGALight.8a32f41a.svg\",\"iUB8p\",\"WhiteboardsPaywall.cf2c63af.svg\",\"1TlSS\",\"WhiteboardsPaywallDark.0948bce6.svg\",\"eJgN2\",\"WhiteboardsPaywallV2.5dd554e3.svg\",\"dk0NC\",\"WhiteboardsPaywallDarkV2.e9c25635.svg\",\"ipnbL\",\"createSpotlightImage.f64dc988.png\",\"brItY\",\"CreateWithRovoSpotlightAnimationDark.886221cf.gif\",\"jb5iT\",\"CreateWithRovoSpotlightAnimationLight.1a1df728.gif\",\"c0kqt\",\"TreeBottomCreateButton.c546aa52.js\",\"4Dabn\",\"ContextualCreateContentPopoverMenu.ae767f20.js\",\"4l6Se\",\"ContextualCreateContentPopoverMenu.88572c84.js\",\"clpSH\",\"PageTreeQuickActions.4354b962.js\",\"13PnU\",\"QuickActionsContent.fbcc8224.js\",\"bunf9\",\"Controller.de6cea91.js\",\"k0hwN\",\"ShareToSlack.43900b26.js\",\"lVO4z\",\"cs.66d17b1d.js\",\"2FVbf\",\"da.45f5bf76.js\",\"ljo6M\",\"de.87ff8d2a.js\",\"8d6ia\",\"es.44f7b6ae.js\",\"jh8UJ\",\"fi.bd46bce1.js\",\"bYwCr\",\"fr.854524fc.js\",\"11NiT\",\"hu.21eb6dc5.js\",\"le8VA\",\"it.111da4a0.js\",\"1beJ2\",\"ja.25f13916.js\",\"1tXCh\",\"ko.c7b3c730.js\",\"jzP8g\",\"nb.6ab8a8d0.js\",\"dJY66\",\"nl.b11fd7f9.js\",\"4foYW\",\"pl.200ddf23.js\",\"j0yc3\",\"pt_BR.3fad7d31.js\",\"RfEmw\",\"ru.64b44490.js\",\"5DOlG\",\"sv.812498a9.js\",\"6rD7n\",\"tr.6280d059.js\",\"1e62a\",\"th.646e04f8.js\",\"eLsCU\",\"uk.87a103d8.js\",\"g9qHs\",\"vi.352e605d.js\",\"2ri5s\",\"zh_TW.40e2425f.js\",\"3k60n\",\"zh.af15c051.js\",\"hxIYN\",\"integration-primer.cead19d9.svg\",\"5oKDR\",\"disabled-alert.0ba0a4e5.svg\",\"8Yk54\",\"DarkEmptyState.b237e8cb.png\",\"dEQI1\",\"LightEmptyState.1b72e55d.png\",\"2i7Iv\",\"DarkError.d13c9c5b.png\",\"17ygR\",\"LightError.5b516166.png\",\"c4Kdp\",\"GeneralAccessLevelSelector.8678d70e.js\",\"3l6zb\",\"ProjectPanel.6b3aa05a.js\",\"7BRMY\",\"TeamProfileCardEntryPoint.9b7d01ec.js\",\"7NSxP\",\"TeamProfileCardEntryPoint.703a31cc.js\",\"1gGaH\",\"EntryPointComponent.66deb66c.js\",\"7jsQp\",\"EntryPointComponent.14ab7195.js\",\"9evbL\",\"TeamAppTile.265b8d3b.svg\",\"lDkw4\",\"TeamProfileCardEntryPoint.12c3682b.js\",\"9yT7Z\",\"ConfluenceIcon.3b027e05.svg\",\"8UdN7\",\"JiraIcon.a06d5f95.svg\",\"2Wuv3\",\"JiraProjectDiscovery.556db745.svg\",\"Q5mZp\",\"JiraServiceManagement.0b0134a3.svg\",\"32rDq\",\"LoomIcon.8c0f7a38.svg\",\"hfT7k\",\"disconnect-dialog.b492d934.js\",\"2cvOU\",\"NoProductAccess.a65d0283.svg\",\"jrCdz\",\"Controller.2cac89da.js\",\"k55bj\",\"Controller.adb0b6a9.js\",\"dHurt\",\"Controller.96427a11.js\",\"dVLeP\",\"Controller.143afe78.js\",\"7KC2Z\",\"person-remove.140bea2f.js\",\"fuHAZ\",\"Controller.a094ac88.js\",\"a7O4E\",\"cs.cacd6d46.js\",\"kN8W3\",\"da.42fa98f7.js\",\"jsrqT\",\"de.62805676.js\",\"3VD9N\",\"en-GB.8ea78c91.js\",\"6rxzi\",\"en-US.ce0e2eef.js\",\"gXHED\",\"en-XA.e493cd62.js\",\"2Dxuh\",\"en-XB.38fe5d84.js\",\"dPidX\",\"en-ZZ.49d314ac.js\",\"dfcvH\",\"es.f61b313c.js\",\"7Y59F\",\"et.270b107d.js\",\"50tPJ\",\"fi.ab519a42.js\",\"9oubr\",\"fr.c506cfa1.js\",\"djRvH\",\"hr.0006b0d2.js\",\"bO0hF\",\"hu.16dbf31e.js\",\"7URpa\",\"it.f442c7e1.js\",\"eDUok\",\"ja.4b705807.js\",\"cvBaM\",\"ko.bbdf9f8d.js\",\"2wtqZ\",\"nb.9112598a.js\",\"gXynX\",\"nl.9989e61a.js\",\"7bhv3\",\"pl.be273148.js\",\"lfEaQ\",\"pt-BR.a9b559eb.js\",\"k9PEt\",\"ro.7a963cd2.js\",\"bQHVt\",\"ru.3eed05c4.js\",\"3Qge6\",\"sl.088e4f31.js\",\"kRDD2\",\"sr-RS.6889204e.js\",\"4yt96\",\"sr-YR.035ee279.js\",\"klTnj\",\"sr.e0362078.js\",\"1OMwg\",\"sv.b7a0e4d3.js\",\"5G5Ud\",\"th.ac715a36.js\",\"52niQ\",\"tr.a3d21f82.js\",\"5etrF\",\"uk.75217b70.js\",\"3T81s\",\"vi.06dbd6c9.js\",\"b7qqi\",\"zh-CN.38c38275.js\",\"iSnvi\",\"zh-TW.696d1ec3.js\",\"36rXN\",\"MovePageDialog.3187cdc6.js\",\"PNyg1\",\"InlineRename.9cb5c705.js\",\"5zDuS\",\"NativeCollabComponent.76baa946.js\",\"4mgLr\",\"node.a3f57a67.js\",\"ajkt7\",\"MovePageDialog.b77bd328.js\",\"3L1uC\",\"PageTreeErrorComponent.423edfa6.js\",\"ewwba\",\"PageTreeEmptyComponent.848e20ca.js\",\"dhqJV\",\"FooterCreateButtons.381873cd.js\",\"67Pvd\",\"ContentTreeOnboarding.e5632e43.js\",\"e19Zv\",\"LiveDocsIconTile.75c4b65c.js\",\"d1QkY\",\"TreeBottomCreateButton.ca941f10.js\",\"f9QHk\",\"TreeMonitor.8c51de24.js\",\"fnoJZ\",\"HomepageIcon.f41b8d55.js\",\"6gau7\",\"DraftLozenge.af187a33.js\",\"aoGyu\",\"MovePageDialog.fdb1b5f1.js\",\"6FaFk\",\"ContentTreeSearchStates.0dcd3908.js\",\"7ZHrh\",\"SearchNoResultLight.8777776b.svg\",\"gaG2b\",\"SearchNoResultDark.50b7a17f.svg\",\"e4XZ1\",\"MovePageDialog.21cd0c5f.js\",\"cUtrS\",\"WatchDialogWrapper.1ca1f411.js\",\"bCr24\",\"main.75f3b1eb.js\",\"lp0cK\",\"both-splash.465c87c4.svg\",\"bo7LK\",\"teams-splash.36cc0781.svg\",\"8XHrw\",\"slack-splash.73e116f6.svg\",\"aoUod\",\"MoveBlogModal.0120f040.js\",\"bg5OF\",\"shortcut.6dd1c4df.js\",\"fLZBc\",\"QuickActionsContent.5da0df3d.js\",\"kyxdN\",\"EditSpaceLogo.6c416045.js\",\"gRwHT\",\"EditSpaceLogoComponent.cf5b8b5c.js\",\"7t2Ec\",\"EditSpaceLogoGallery.bd37ba87.js\",\"860dT\",\"SpaceHeaderExCoOnboarding.2ec15f25.js\",\"9H1r6\",\"GraphBarIcon.8122a900.js\",\"19Ali\",\"GridIcon.bf4f9a0b.js\",\"hI11K\",\"AutomationNavigation.62d6a989.js\",\"4skpM\",\"AutomationChangeBoarding.966c38bc.js\",\"8xPy6\",\"SmartButtonIllustration.b4b7c8dc.png\",\"fbDZw\",\"QuestionsNavigation.863101a9.js\",\"c0OU0\",\"QuestionsIcon.2b9be2c0.js\",\"7Qxu7\",\"TeamCalendarNavigation.83e7b6ba.js\",\"aZ9pO\",\"CalendarIcon.852bd13f.js\",\"5DqrE\",\"BulkToolsNavigation.c7d80b3c.js\",\"hHrTM\",\"edit-bulk.40121784.js\",\"klGUa\",\"ErrorView.d88e1c1f.js\",\"j0beU\",\"EyeStrike.801ddb27.svg\",\"eWlhh\",\"Nav3SpaceApps.14c4a0bd.js\",\"hs6o8\",\"SpaceAppsConfiguration.c2dc6461.js\",\"19XET\",\"render.b7830416.js\",\"j4CTh\",\"tasks.4e573bd1.js\",\"5MlWi\",\"PageLayout.f6a28796.js\",\"iTImB\",\"heart.91f6fb22.svg\",\"bl22g\",\"notes.c9738615.png\",\"dAcu4\",\"ai-notes-icon.f866806e.svg\",\"lguNj\",\"chrome-icon.40414d4b.svg\",\"c4pCE\",\"rovo-icon.a638efdd.svg\",\"l5cKN\",\"twc-app-tiles.b4f04c82.svg\",\"bn3MP\",\"cs.446d71e8.js\",\"bCRQO\",\"da.f2632b81.js\",\"icPOh\",\"de.7e7ce723.js\",\"irb4K\",\"en_GB.0d8fd3bc.js\",\"3o6Po\",\"en_ZZ.91c327a7.js\",\"4LsSr\",\"es.c1c50af3.js\",\"3lxf3\",\"fi.483cf707.js\",\"2zz6F\",\"fr.8075ddc8.js\",\"37w4x\",\"hr.e280a499.js\",\"i6dLm\",\"hu.2eb734ac.js\",\"iz3iW\",\"it.6d7a2c86.js\",\"f6tHd\",\"ja.5862774c.js\",\"k6MzV\",\"ko.1faf92eb.js\",\"hcgQv\",\"nb.eb03083a.js\",\"22xh6\",\"nl.4682d2ea.js\",\"7h480\",\"pl.08d4553a.js\",\"h7DsC\",\"pt_BR.bae8b4d9.js\",\"aNE6d\",\"ru.7654c15a.js\",\"jVJD9\",\"sl.9936fba6.js\",\"4gQ48\",\"sr_RS.3808d319.js\",\"hQ8Od\",\"sr_YR.edec99aa.js\",\"lB1mG\",\"sv.9e71d2f9.js\",\"2XVrh\",\"th.c07fd198.js\",\"hZfMu\",\"tr.ff682f6d.js\",\"36gUn\",\"uk.b930fd95.js\",\"2nhsY\",\"vi.bbb670fb.js\",\"2rLcj\",\"zh.9781761d.js\",\"hja5d\",\"zh_TW.f5c7f917.js\",\"cgRYU\",\"rovo-icon.999e8c7b.png\",\"26fZM\",\"Nav3SpaceNavigationContent.b272efd6.js\",\"1NnjK\",\"ShortcutsSection.f7304b57.js\",\"aBvTF\",\"ShortcutsDragContainer.1e421bbb.js\",\"kDqHr\",\"file-icon.7c0a9b34.js\",\"4HZlX\",\"chart-bar-icon.6975ba0a.js\",\"7jSfd\",\"list-bullet-icon.339b1061.js\",\"aOY32\",\"branch.82fba7e3.js\",\"6fQco\",\"commit.b8c711d2.js\",\"1MWOL\",\"pull-request.63023f87.js\",\"9wPDc\",\"code.981331a1.js\",\"lm9Lt\",\"changes.645808de.js\",\"4S1SF\",\"incident.9e4821e1.js\",\"XZauT\",\"problem.2f02311b.js\",\"9aQIt\",\"subtask.db9635e9.js\",\"jiFtb\",\"epic.6887d63b.js\",\"4RbVd\",\"database.7bd12ec5.js\",\"bGpE6\",\"whiteboard.e754a12f.js\",\"eBRUf\",\"GoalPanel.fa092bb7.js\",\"jg5LT\",\"root-component.6e7ed5a4.js\",\"5TCys\",\"SpaceViews.a20263ab.js\",\"aCG0y\",\"SpaceViewsErrors.66ea6c83.js\",\"5qLBt\",\"SearchNoResultLight.8777776b.svg\",\"6KUsM\",\"SearchNoResultDark.50b7a17f.svg\",\"1TYNY\",\"SpaceViewsCurrentViewIndicator.4675f215.js\",\"guX1n\",\"ViewMoreButton.a28c4578.js\",\"kJLy8\",\"SpaceViewsList.1257406a.js\",\"6gmSt\",\"PagesItemActions.2d638213.js\",\"3HpiM\",\"BulkActionsChangeboardingSpotlightInner.a2329652.js\",\"3YKnT\",\"bulkActionsChangeboardingSpotlightImage.9c36fbc8.svg\",\"fC3D2\",\"SpaceViewsMenu.cf7362bb.js\",\"cWvhX\",\"PageOwnershipByLineWithContributorsDropdownContent.d015ad37.js\",\"eQlG4\",\"ContentTreeSearch.10bc1599.js\",\"cQVtz\",\"SpaceHoverPageCard.7e1e30c2.js\",\"gLGsg\",\"FullPageEditorComponent.7a381f00.js\",\"kIxwS\",\"EndOfPageRecommendation.abe0e0ce.js\",\"bPbbv\",\"EndOfPageRecommendation.runtime.9925bcc6.js\",\"bPbbv\",\"EndOfPageRecommendation.runtime.9925bcc6.js\",\"hDNUK\",\"BlogTree.9f72db16.js\",\"lnCW7\",\"ExternalCollaboratorInSpaceNotify.b3f7f319.js\",\"7Ni3R\",\"GuestOnboardingModal.0bd933cc.js\",\"WYAWv\",\"Guest-Onboarding-Light.8e788fbd.svg\",\"4rpM2\",\"Guest-Onboarding-Dark.f055cab3.svg\",\"hFtKc\",\"SpaceNavigationContent.13dcec11.js\",\"ci2h5\",\"Spaces.5611c4bd.gif\",\"gEZwe\",\"Spaces-dark.4ceec6cd.gif\",\"3XEdh\",\"Spaces-placeholder.5b3f2999.png\",\"7SqAi\",\"Spaces-placeholder-dark.1c1d1b34.png\",\"c08ou\",\"CalendarsLink.1b3b019d.js\",\"8uhuz\",\"QuestionsLink.929d4408.js\",\"kZjBp\",\"SpaceApps.57a6aaf7.js\",\"fSc0b\",\"Nav4CollapseReminderSpotlight.31b29886.js\",\"9IEev\",\"PlatformNavigationComponent.b552d615.js\",\"3WCRn\",\"NewKeyboardShortcutsDialog.a310eba3.js\",\"4AAsh\",\"AddPersonalSpaceDialog.c38abf6c.js\",\"cbb8R\",\"megaphone.ea49a10b.svg\",\"7enLt\",\"clipboard.6bbe40ee.svg\",\"irkOO\",\"nameTag.1bdcf89f.svg\",\"8H6xE\",\"EditionAwareness.72516229.js\",\"1AVLS\",\"automation-free-limit-modal.937beb06.js\",\"1Bzn5\",\"breached-icon-dark-mode.c76c5af4.svg\",\"4li5B\",\"breached-icon.604210d1.svg\",\"5Hb8k\",\"gestural-line-dark-mode.0238cd16.svg\",\"fKxeV\",\"gestural-line.c0eb7c9f.svg\",\"7REXs\",\"automation-danger-icon.9e7c0e3a.svg\",\"7NqPm\",\"automation-warning-icon.0d3ef917.svg\",\"aMOuo\",\"collection-add-payment-details-popup.ffc7578c.js\",\"9gHNl\",\"twc-popup-background-dark.0f701da2.svg\",\"2l8ah\",\"twc-popup-background-light.30b1cc68.svg\",\"99wAt\",\"collection-change-plan-popup.18746382.js\",\"4I0kP\",\"end-user-request-modal.94db9086.js\",\"bjfAh\",\"EndUserRequestUpgradeModal.589e4658.js\",\"bGfxQ\",\"error-visual-dark.a52399eb.png\",\"djGcB\",\"error-visual-light.8a0abe86.png\",\"8kpTd\",\"visual-dark.589bc948.png\",\"aPOi6\",\"visual-light.1c3bfa82.png\",\"dGvEg\",\"feature-onboarding-modal.319cb1e9.js\",\"39fCS\",\"background-dark.a3b81b65.svg\",\"hlyBg\",\"background.335ae0da.svg\",\"ltJpU\",\"blue-box.4faddac8.svg\",\"lq3Sl\",\"free-choose-your-edition-modal.9b22cd6c.js\",\"iI6Q4\",\"free-to-standard-modal.1c5d6104.js\",\"2zp5o\",\"background-dark.46d9946a.svg\",\"eGZ7X\",\"background-light.c76a8e81.svg\",\"2kbQr\",\"discovery-background-dark.73b58e40.svg\",\"8LjMq\",\"discovery-background-light.e5db6720.svg\",\"7qqQA\",\"gestural-line-dark.5fb5d96c.svg\",\"jmfnZ\",\"gestural-line.8591d4ac.svg\",\"jr06u\",\"jsw-add-people.17946c9a.svg\",\"jTG5T\",\"jsw-increased-storage-limits.b8a08bb1.svg\",\"iNU7h\",\"increased-storage-limits.a7321574.svg\",\"15Vzp\",\"unlimited-creators.3de71904.svg\",\"i0M9R\",\"help-desk-attachments-darkmode.a8bd959e.svg\",\"9zK71\",\"help-desk-attachments.138601ac.svg\",\"2hde5\",\"jsm-service-collection-add-people-darkmode.290a8179.svg\",\"j99t9\",\"jsm-service-collection-add-people.8f940b7d.svg\",\"anVlQ\",\"jsm-increased-storage-limits.21bb9c1c.svg\",\"cYQGZ\",\"unlimited-agents.743019a8.svg\",\"cHQ50\",\"location.970afe87.js\",\"aE4di\",\"phone.b88e8f90.js\",\"aKXvR\",\"payment-details-popup.b5d96101.js\",\"kwFai\",\"background.b3afa1bc.svg\",\"cDKlY\",\"plan-selection-page-modal.01e8f1ec.js\",\"4JtX7\",\"premium-add-payment-modal.1851486d.js\",\"luoSj\",\"jpd-hierarchies.c6150f5d.svg\",\"73HLv\",\"jpd-roadmap.f097129b.svg\",\"lhoQv\",\"jpd-view-restrictions.3427d350.svg\",\"ki3nq\",\"premium-popup.46d9cc6a.js\",\"czatF\",\"premiumPopupHeader-Dark.8772bafb.svg\",\"8oiny\",\"premiumPopupHeader-Light.587e53c0.svg\",\"7YE3I\",\"reverse-trial-popup.be1e0fca.js\",\"iFA9H\",\"special-offer-sixty-modal.dd6ffe9f.js\",\"3KKo2\",\"background.cfd6bca5.svg\",\"1j7i8\",\"gestural-line-signal-4.2ed74c75.svg\",\"abLmz\",\"gestural-line-star-4.7814368e.svg\",\"kyUks\",\"radio-unchecked.a80b0bc5.js\",\"3opZo\",\"radio-checked.bfe4f2a4.js\",\"eCMUX\",\"standard-add-payment-modal.14287723.js\",\"lmoGI\",\"confluence-add-people.95d7cd0c.png\",\"1JrC5\",\"confluence-guest-access.0a003025.png\",\"cfLGc\",\"confluence-page-insights.548fcd17.png\",\"3DLtA\",\"confluence-page-restrictions.6ddf91dd.png\",\"dp0gI\",\"attachments.a7321574.svg\",\"7XFVr\",\"help-desk-attachements.21bb9c1c.svg\",\"7RlGN\",\"jpd-add-people.3de71904.svg\",\"4jaDc\",\"jsm-add-people.743019a8.svg\",\"kVhCr\",\"jsw-add-people.17946c9a.svg\",\"lLln8\",\"storage-hard-limit-modal.93a94273.js\",\"aCxGF\",\"storage-limit-breached-icon-dark-mode.c76c5af4.svg\",\"9WLSk\",\"storage-limit-breached-icon.604210d1.svg\",\"7hYpO\",\"storage-limit-danger-icon.9e7c0e3a.svg\",\"60S8F\",\"PremiumTrialOnboardingSpotlight.21e8b783.js\",\"dTz74\",\"RtNeutralMessagingSuppressComponentsHoc.fce1c697.js\",\"d5wRy\",\"Spotlight-pto2-dark.d9bc480a.svg\",\"fZEhl\",\"Spotlight-pto2-light.bfab086d.svg\",\"2E7bn\",\"Spotlight-pto2-dark-295x135.339d09e4.svg\",\"d3Q4u\",\"Spotlight-pto2-light-295x135.c27a4490.svg\",\"2OWSd\",\"PremiumOnboarding.dcac9c8c.js\",\"78YgQ\",\"Illustration.bc0cbd7b.svg\",\"bKgRA\",\"Illustration.bc0cbd7b.svg\",\"3X1yw\",\"FullPageEditorComponent.d62fc75b.js\",\"kNFat\",\"ImpersonationFlag.d7bd86fc.js\",\"4xmPF\",\"sha256SimpleHasher.279f6b04.js\",\"77ceh\",\"definition-popup-content.90036e77.js\",\"3SmkN\",\"page.5c0060d7.js\",\"g9CVe\",\"mention.c0b42a29.js\",\"8A3nE\",\"UpdateComposer.12764eb6.js\",\"h9Ed7\",\"GoalPanel.a6d7843f.js\",\"lVO3w\",\"ProjectPanel.74e6f9cc.js\",\"jnkIk\",\"TeamProfileCard.09c046fe.js\",\"gWfLJ\",\"team-preview-panel.9ccbafcc.js\",\"eEyVs\",\"book-with-bookmark.f202cd02.js\",\"awWN9\",\"definition-popup-content.5b9edcc9.js\",\"6mHrv\",\"definition-popup-content.24c2b797.js\",\"iDB1L\",\"pen.ff9dabea.js\",\"dChec\",\"spotlight.8f55b856.js\",\"6jIfS\",\"EditorContentStateComponent.f1bbf3a0.js\",\"jvHRs\",\"team-preview-panel.15b743f4.js\",\"7BqcA\",\"InvalidExtension.7005f419.js\",\"7EJ3Q\",\"PageLayout.703b2f9b.js\",\"49e27\",\"PageLayout.f4809bb4.js\",\"6tsCm\",\"PageLayout.6d247b75.js\",\"b6JBs\",\"CompanyHubBreadcrumbs.47e563aa.js\",\"lpcEN\",\"ChangeHubNameDialog.4393acd3.js\",\"70fET\",\"hub-hero-image.d6790ccb.png\",\"1GyAj\",\"BreadcrumbsDropdownContent.6e2e9693.js\",\"hHYS0\",\"ModernizedBreadcrumbsIndentIcon.2b5f9d84.js\",\"2Xd3I\",\"PageLayout.604a991f.js\",\"cvXSy\",\"RightPanel.44672e4b.js\",\"aoJPa\",\"main.cf10356a.js\",\"7AIwp\",\"alert-icon.236d7fa8.svg\",\"iOFzT\",\"HelpPanel.cdcd3e8c.js\",\"b3xzh\",\"LICENSES.8f681397.js\",\"j2bbk\",\"flask.4abe7595.js\",\"1Qnbg\",\"device-mobile.e5585656.js\",\"9mBQe\",\"feed.e134a1f8.js\",\"9ijrN\",\"modal.7b6f1fce.js\",\"8VT23\",\"FullPageEditorComponent.57f944bd.js\",\"736as\",\"AISummaryFooter.df50031a.js\",\"4yXIN\",\"FullPageEditorComponent.0d69a715.js\",\"5UCxV\",\"RightPanel.9a6e57f0.js\",\"8dYdP\",\"BranchDeployLogo.bcf98801.js\",\"beF0E\",\"formatRelative.6270d915.js\",\"bkswC\",\"FeatureFlagLogo.43a88b17.js\",\"392bg\",\"flag-filled.80b1588d.js\",\"5j5Dl\",\"NotificationsContent.c481bc42.js\",\"32WMp\",\"CommentsPanelFilterMenu.a84a3126.js\",\"lCT7Q\",\"GoalPanel.f5ce9654.js\",\"gfCPM\",\"NotificationsContent.6ffe5671.js\",\"cqJPj\",\"cs.0ec988ce.js\",\"k8s3i\",\"da.c2c29131.js\",\"4wXhf\",\"de.f2b6f89c.js\",\"6tXZg\",\"es.72f7c3e6.js\",\"ktJwC\",\"fi.1e13c97a.js\",\"7mgkS\",\"fr.ddece3e0.js\",\"fWDE2\",\"hu.d4e7285c.js\",\"b2OUm\",\"it.669e6609.js\",\"9PhiM\",\"ja.412f3646.js\",\"4d3pr\",\"ko.8d2b6e06.js\",\"duoZ2\",\"nb.2aed5fd9.js\",\"7JbfU\",\"nl.f57ffbf1.js\",\"k9Hsp\",\"pl.f9df15b1.js\",\"dNbgl\",\"pt_BR.c5cdb3ec.js\",\"53dLt\",\"ru.f643c2e3.js\",\"dCa0R\",\"sv.d1d14512.js\",\"dR545\",\"tr.6766db00.js\",\"gIlXN\",\"th.cd1a5d19.js\",\"ktxue\",\"uk.7fd9f774.js\",\"db0Tb\",\"vi.b22e706a.js\",\"cknqz\",\"zh_TW.8d331f4b.js\",\"8XnIU\",\"zh.0f2a0235.js\",\"44Ne1\",\"main.5eb56ca1.js\",\"bZ7A8\",\"main.907e4a6b.js\",\"3xuDK\",\"show-more-vertical.91054f89.js\",\"5Qjce\",\"shortcut-pro-tip.92299e9c.js\",\"j5Z6Q\",\"main.9340f859.js\",\"eFvBU\",\"generic-error.74ae12d9.js\",\"19qJC\",\"avatar-group.f7644992.js\",\"brzrr\",\"main.0187f2dd.js\",\"i1up4\",\"GoalPanel.66647549.js\",\"g5HUX\",\"ProjectPanel.674599e8.js\",\"47RmW\",\"GoalPanel.96e5c27b.js\",\"kTdzk\",\"ObjectSidebarControl.cd7329e4.js\",\"8Z2Eu\",\"main.be6b99cf.js\",\"1y1ll\",\"main.870d36cb.js\",\"eYBaa\",\"main.f743869b.js\",\"fzXjm\",\"QuickReload.b9fe0e8e.js\",\"aJ5As\",\"main.34f221e9.js\",\"7Rr0f\",\"dark-mode.c2768bcf.svg\",\"3U0yP\",\"light-mode.e7c3914f.svg\",\"fQA9e\",\"match-browser.a2bb9bea.svg\",\"27Dzv\",\"dark-mode.c2768bcf.svg\",\"1gUFj\",\"light-mode.e7c3914f.svg\",\"8s2Uo\",\"match-browser.a2bb9bea.svg\",\"49f46\",\"cs.077e9f4c.js\",\"jQPB7\",\"cs_CZ.02a4f979.js\",\"88bR1\",\"da.f100d419.js\",\"bwD1u\",\"da_DK.87972b77.js\",\"85kOD\",\"de.1d9843a9.js\",\"R2BG5\",\"de_DE.c262d848.js\",\"2goda\",\"en_GB.dbcbc037.js\",\"gjxqp\",\"en_ZZ.44473633.js\",\"1S2jF\",\"es.c17cb0b0.js\",\"eERmJ\",\"fi.4fa64611.js\",\"8rk64\",\"fi_FI.3920d863.js\",\"bpktO\",\"fr.903b8e7a.js\",\"aC2ty\",\"fr_FR.55477104.js\",\"lmJBr\",\"hu.531afc04.js\",\"lVBNt\",\"hu_HU.482ed985.js\",\"lnHpS\",\"it.87f71de5.js\",\"kEBAh\",\"it_IT.6068682f.js\",\"3ZAy1\",\"ja.94bc339c.js\",\"fDXOw\",\"ja_JP.b9c5af46.js\",\"45dhs\",\"ko.1eee672d.js\",\"grGen\",\"ko_KR.2eefe595.js\",\"4iqE9\",\"nb.2f604276.js\",\"bAyJY\",\"nb_NO.0e1c1672.js\",\"51EOq\",\"nl.6cc51681.js\",\"d5GjE\",\"nl_NL.36ecf941.js\",\"4ILPZ\",\"pl.1d15f5b3.js\",\"6QVYs\",\"pl_PL.4b70058e.js\",\"7HuII\",\"pt_BR.2b035f6a.js\",\"iYxvq\",\"ru.c3f08be2.js\",\"8kHli\",\"ru_RU.b5aa2be7.js\",\"dqRWB\",\"sv.937a087d.js\",\"bYWK5\",\"sv_SE.708683d2.js\",\"k0u9s\",\"th.1046cb5c.js\",\"imObn\",\"th_TH.951654d3.js\",\"chSc4\",\"tr.c7d5b86f.js\",\"dfeY8\",\"tr_TR.38e54197.js\",\"fvaoj\",\"uk.628c902d.js\",\"lT1ej\",\"uk_UA.7f80708f.js\",\"8OH5J\",\"vi.60bec7b2.js\",\"hV9Rr\",\"vi_VN.3f64294f.js\",\"k4zbq\",\"zh.74d31329.js\",\"1cNBX\",\"zh_CN.2e8ebc6e.js\",\"ii6TT\",\"zh_TW.222165d8.js\",\"4YwES\",\"PageLayout.3d1672bf.js\",\"gM13h\",\"navBarButton.2f5dc841.js\",\"1aPQ5\",\"PageLayout.7ae75b64.js\",\"6XyGC\",\"atlassian-switcher.4ecd6dc0.js\",\"4NUCi\",\"cs.ee14a273.js\",\"cSX69\",\"da.f99cdb04.js\",\"deZYh\",\"de.34ce4e12.js\",\"kU59n\",\"en_GB.b074670e.js\",\"1L3Og\",\"en_ZZ.7b508cd0.js\",\"6HKYn\",\"en.5ecea674.js\",\"UHyLS\",\"es.f027bd40.js\",\"7jCUc\",\"et.1dd8203e.js\",\"jq5xm\",\"fi.6a581f83.js\",\"anfIJ\",\"fr.7efdc03a.js\",\"369Q4\",\"hu.6ad16244.js\",\"1vaU3\",\"is.5d4b1a56.js\",\"23Iwb\",\"it.811d50f8.js\",\"fFLzH\",\"ja.93485558.js\",\"hVd5u\",\"ko.476beecb.js\",\"lz5E6\",\"nb.8e72f4f6.js\",\"bdV9c\",\"nl.b5e615f4.js\",\"eDHUW\",\"pl.6c50ac52.js\",\"RmhvD\",\"pt_BR.a6835abd.js\",\"dAgm7\",\"pt_PT.fb4e7968.js\",\"f7XN4\",\"ro.17474067.js\",\"bA1DV\",\"ru.b724c50e.js\",\"5Zouf\",\"sk.a983b13a.js\",\"f6c6x\",\"sv.4bf1c120.js\",\"6VL5F\",\"th.98547a2d.js\",\"9zarI\",\"tr.30dfa199.js\",\"gtgoF\",\"uk.6e958f1b.js\",\"kkSDy\",\"vi.16131c0b.js\",\"fgDwh\",\"zh_TW.1a4dacc3.js\",\"j25uO\",\"zh.d1eb4738.js\",\"84LYM\",\"PageLayout.e12d000b.js\",\"2PUw9\",\"robot-error.9b710643.js\",\"htm73\",\"atlassian-switcher.a547174f.js\",\"5dGIX\",\"animation-illustration.ceb03cfe.js\",\"a3B2V\",\"jira-switcher.20567338.js\",\"9B1r0\",\"confluence-switcher.78fd0fc3.js\",\"kgItH\",\"generic-switcher.f434b8df.js\",\"g8jRY\",\"PageLayout.5b8392e0.js\",\"eEBx4\",\"render.662837f1.js\",\"6m2wP\",\"render.a7e000d7.js\",\"ctG9k\",\"render.aacc321c.js\",\"2lwAY\",\"cross-flow-modal.603af348.js\",\"heta6\",\"brand-dark.c4f3aa1f.svg\",\"jCm4e\",\"brand-light.292da6ea.svg\",\"7yHad\",\"generic-error-dark.e889fb23.svg\",\"kVcQH\",\"generic-error-light.9c5910ae.svg\",\"a1o0C\",\"product-active-dark.56baffde.svg\",\"8pRM9\",\"product-active-light.b1a13a2d.svg\",\"inuR8\",\"maintenance-mode-dark.12d602d4.svg\",\"gNGNH\",\"maintenance-mode-light.587ad76e.svg\",\"6t3QQ\",\"confirmation-background-dark.77a50306.svg\",\"88MVa\",\"confirmation-background-light.7ebef9cd.svg\",\"g419T\",\"jpd-roadmap-dark.275cba67.svg\",\"9gS1d\",\"jpd-roadmap-light.6bcfd0e5.svg\",\"hgaNA\",\"jpd-timeline-dark.6be64e27.svg\",\"2T2WG\",\"jpd-timeline-light.91978564.svg\",\"fzxKX\",\"confirmation-background-dark.77a50306.svg\",\"cP3Ey\",\"confirmation-background-light.7ebef9cd.svg\",\"ajkXQ\",\"jsm-general-service-management-medium-dark.72053e0e.svg\",\"acQBx\",\"jsm-general-service-management-medium-light.235e9cbc.svg\",\"ke1cn\",\"loom-generic.bd9e0a28.svg\",\"avfpP\",\"loom-generic.4fa464c9.svg\",\"i7d4e\",\"background-light.e4dc0004.png\",\"anrcs\",\"discover-features.f4a0b670.png\",\"6nDfv\",\"esm.56e16210.js\",\"4Jbf1\",\"sprint.69e64865.js\",\"eONDg\",\"timeline.34add4cd.js\",\"gopxm\",\"render.5e1ce517.js\",\"9N316\",\"render.ea1b3975.js\",\"603iI\",\"render.65d2a29c.js\",\"dVwBo\",\"render.6ba5c5ef.js\",\"6gEtt\",\"render.2d776295.js\",\"l37ax\",\"render.2506b060.js\",\"ntv3W\",\"render.550cdfa7.js\",\"1b5ye\",\"render.6523b959.js\",\"lXsOU\",\"render.95cecea9.js\",\"8Y9rK\",\"welcome-animation-light.91126d70.js\",\"l1BtG\",\"welcome-animation-dark.09187bd2.js\",\"eBicT\",\"twc.f376f02d.svg\",\"28fuf\",\"atlassian-ace-icon.dc463630.svg\",\"8KXnu\",\"render.b45b87d6.js\",\"dUS4r\",\"confirmationBackgroundV2.dark.7c389c39.png\",\"6bGHk\",\"confirmationBackgroundV2.light.74baa5b8.png\",\"ksf6H\",\"confirmationVisual.dark.3beace2d.svg\",\"6H1xs\",\"confirmationVisual.light.4c2dbe9e.svg\",\"f0hWS\",\"teamworkCollectionHeaderV2.dark.88afbace.png\",\"77wr8\",\"teamworkCollectionHeaderV2.light.d5af8710.png\",\"3mvx6\",\"warning.f5011eb7.png\",\"2oFev\",\"teamwork_collection_header.dark.0d6ead39.png\",\"1BVx6\",\"teamwork_collection_header.light.46f39a8e.png\",\"lOVL5\",\"app-tiles.dark.8e97838c.png\",\"cqGeb\",\"app-tiles.light.c0171e78.png\",\"fYmaw\",\"normalizeSeatBackground.dark.3ce9cef1.png\",\"26YAb\",\"normalizeSeatBackground.light.c079ea47.png\",\"3EtHp\",\"provisioning.light.12580c01.js\",\"9m8Nr\",\"provisioning.dark.548ad10c.js\",\"4E6dy\",\"icons.light.bbb50d8d.js\",\"8JoSD\",\"icons.dark.b514e288.js\",\"bAOHw\",\"cs.f4ac35ac.js\",\"h3G5z\",\"da.d522da3f.js\",\"gNA0J\",\"de.ec6b8985.js\",\"9kjAa\",\"en.d0f11a23.js\",\"vaHqY\",\"en_GB.b9ecc644.js\",\"hKKq1\",\"en_ZZ.5c77372e.js\",\"699rt\",\"es.46f10a5c.js\",\"4U6vo\",\"fi.d56dde80.js\",\"8bauW\",\"fr.71d07b39.js\",\"2XHsa\",\"hr.b07b6de3.js\",\"fQ6gV\",\"hu.c4c70b4a.js\",\"8N1M8\",\"it.a7070a93.js\",\"64SZl\",\"ja.04426d71.js\",\"l9rrS\",\"ko.356ff41e.js\",\"1K1DB\",\"nb.9a492a2d.js\",\"2IhWo\",\"nl.815847c7.js\",\"cB5tA\",\"pl.751a6cd4.js\",\"14y9P\",\"pt_BR.e16be683.js\",\"8BgQU\",\"ru.cb60c7fd.js\",\"kyH38\",\"sl.ed2408ab.js\",\"b8zkJ\",\"sr_RS.15f09478.js\",\"2Ypcl\",\"sr_YR.237e2cc9.js\",\"g5vt7\",\"sv.1422e9bb.js\",\"aUgRr\",\"th.d2d8a443.js\",\"dZlmW\",\"tr.452729f9.js\",\"dP9AS\",\"uk.0d0ae6cb.js\",\"7yahE\",\"vi.71aea8d5.js\",\"kXGHC\",\"zh.1d67221b.js\",\"aparn\",\"zh_TW.1ba8025e.js\",\"f7nCb\",\"render.35dfe2c2.js\",\"9xrtp\",\"render.79ccb094.js\",\"iFcso\",\"render.2c8a5b7c.js\",\"br5B5\",\"cs.0d4813ce.js\",\"gjHAC\",\"da.9847689c.js\",\"50jL1\",\"de.2ee49e34.js\",\"icT1H\",\"en-GB.7f03c10e.js\",\"jHACf\",\"en-US.74c2d95c.js\",\"gxykq\",\"en-XA.d9920a71.js\",\"jwi3q\",\"en-XB.c5f76386.js\",\"4vq5I\",\"en-ZZ.44357df6.js\",\"3IaOg\",\"es.b993872c.js\",\"c1t91\",\"et.96209c15.js\",\"5x1Zd\",\"fi.cabb4290.js\",\"eNry3\",\"fr.8386632f.js\",\"cmudZ\",\"hr.9eda1dd8.js\",\"qOVvt\",\"hu.ad90a636.js\",\"cLRtU\",\"it.c4f03750.js\",\"fWDs2\",\"ja.5e211822.js\",\"isQud\",\"ko.394e3512.js\",\"iX3CG\",\"nb.3d62fc61.js\",\"5GFyb\",\"nl.0393d573.js\",\"fDZox\",\"pl.d6663b00.js\",\"gYq2J\",\"pt-BR.6eab568f.js\",\"4MDcN\",\"ro.6b8de570.js\",\"djU0u\",\"ru.b0a1d17f.js\",\"gUvh2\",\"sl.adb9638d.js\",\"kb7kZ\",\"sr-RS.3b825f92.js\",\"kGHpg\",\"sr-YR.eb30ef98.js\",\"8GEyD\",\"sr.947e8003.js\",\"gSB6X\",\"sv.dd4339f1.js\",\"9s4Da\",\"th.061e58d9.js\",\"f73pl\",\"tr.f9cafb7d.js\",\"jmWj5\",\"uk.c3f28b54.js\",\"inGUf\",\"vi.8bcc9067.js\",\"9rQBn\",\"zh-CN.3ae80d8f.js\",\"4DECc\",\"zh-TW.faf09981.js\",\"9GMEV\",\"PageLayout.c0a866dd.js\",\"dJC82\",\"DeleteSpaceDialog.b506151a.js\",\"4ukY5\",\"AboutConfluenceDialog.fa58a665.js\",\"6wPv6\",\"GiveFeedbackDialog.d8e975ca.js\",\"943D1\",\"ThemePopupMenu.97fdfde7.js\",\"9HjCR\",\"theme-light-thumb.1c8784c4.svg\",\"75cX5\",\"theme-dark-thumb.996efaf5.svg\",\"fc8cx\",\"theme-system-thumb.a357a448.svg\",\"bzLZJ\",\"PageLayout.bdca003a.js\",\"4KiYL\",\"image.e5fc33c2.js\",\"5GUmv\",\"search-error-dark.43e0a164.svg\",\"14R3W\",\"search-error-light.02ef2e6f.svg\",\"5nvBH\",\"landing-dark.4ee27e71.svg\",\"kv0qb\",\"landing-light.0988f0a2.svg\",\"8yV1V\",\"no-results-dark.a00ae47b.svg\",\"3bsGr\",\"no-results-light.5ca83755.svg\",\"efZH2\",\"recent-work-client.b69afda9.js\",\"8F6ik\",\"result-provider.0c3b5249.js\",\"hHoTx\",\"error-image.3cc4cf96.js\",\"lUh9w\",\"async-select.7073926f.js\",\"fEM7I\",\"static-select-filter.6fa97146.js\",\"bBtaF\",\"multi-select-filter.c24a0a7b.js\",\"3BloW\",\"image.d4dffd0f.js\",\"9RypW\",\"image.c1dded09.js\",\"4alnS\",\"no-results-light.5ca83755.svg\",\"bE2Fu\",\"no-results-dark.a00ae47b.svg\",\"6kNSo\",\"autocorrection-renderer.caaa73ee.js\",\"eQXoP\",\"image.1b651d98.js\",\"yzZO6\",\"search-error-light.02ef2e6f.svg\",\"e84X7\",\"search-error-dark.43e0a164.svg\",\"6sXO4\",\"drop-down-links.e17363a5.js\",\"4Sse2\",\"image.e088a67d.js\",\"4KkwT\",\"prequery-empty-screen-light.0988f0a2.svg\",\"eM7lm\",\"prequery-empty-screen-dark.4ee27e71.svg\",\"5kEKD\",\"upsell-modal.cfb56b3f.js\",\"kqtzG\",\"compass-bitbucket-upsell-banner.1bbe07cf.png\",\"jjAxo\",\"smart-user-picker.f35128ab.js\",\"8XFC9\",\"ai-answer-onboarding-banner.a6bf7c51.js\",\"5QGog\",\"search-client.f534aed6.js\",\"fiCwF\",\"search-ai.7964685b.js\",\"dXz7U\",\"cs.6ac2769c.js\",\"gGEZv\",\"da.222013ff.js\",\"d3blt\",\"de.6adbea8d.js\",\"59Z93\",\"en_GB.1d2ad648.js\",\"kotjW\",\"en_ZZ.3637834b.js\",\"kK6se\",\"es.b72ae2e6.js\",\"5xf60\",\"et.7581eb28.js\",\"9VEIz\",\"fi.9db25ed3.js\",\"cjdHS\",\"fr.8f0bf0aa.js\",\"Whd6n\",\"hu.af2f8523.js\",\"jkUKZ\",\"is.a0ebfb14.js\",\"9LPlo\",\"it.78a22150.js\",\"bCZbu\",\"ja.5c6ea02b.js\",\"jUfGx\",\"ko.84af9550.js\",\"8yxgV\",\"nb.c9ca15dd.js\",\"dBE2i\",\"nl.3c0ffdcb.js\",\"6FNZU\",\"pl.f56c15cd.js\",\"ilWcC\",\"pt_BR.396aad53.js\",\"edU6Z\",\"pt_PT.94fccdb2.js\",\"atNxX\",\"ro.e8b3e3a3.js\",\"gpgvY\",\"ru.90486d02.js\",\"3IA7L\",\"sk.9ec26891.js\",\"hpq4P\",\"sv.64f386b7.js\",\"8WMbP\",\"th.6b4a37bf.js\",\"kffHA\",\"tr.081c0641.js\",\"2zh8u\",\"uk.a5713c75.js\",\"9YoTA\",\"vi.1ad21d1f.js\",\"a9qyt\",\"zh.c724084d.js\",\"04egH\",\"zh_TW.c65250a9.js\",\"1Ojgx\",\"ai-answer-prompt.48ddb74d.js\",\"eVnxm\",\"trello-body.955eccaf.js\",\"2exA8\",\"trello-popper.17b5bea6.js\",\"dvZ6G\",\"PageLayout.400d7a53.js\",\"gD9D1\",\"cs.4c7f8f8d.js\",\"lpFHz\",\"da.fc680690.js\",\"fYKge\",\"de.ce5bdffc.js\",\"4Wlui\",\"en_GB.a0322edd.js\",\"69mwC\",\"en_ZZ.8c87b228.js\",\"7rN2h\",\"es.16fc6e1d.js\",\"9Y8tZ\",\"fi.ee843f5d.js\",\"jjh1v\",\"fr.aa6f11da.js\",\"23sVT\",\"hr.1d63a13c.js\",\"eO6VH\",\"hu.bb8f0142.js\",\"8rFvt\",\"it.36952a6b.js\",\"lK8aI\",\"ja.bf8be0a3.js\",\"5j4Hn\",\"ko.9e3351fa.js\",\"2Jfx0\",\"nb.b4003b9b.js\",\"c119j\",\"nl.2a4b74b4.js\",\"lgdNv\",\"pl.36184d5f.js\",\"dKIhk\",\"pt_BR.3282ccf4.js\",\"dwqTf\",\"ru.9ebc9d36.js\",\"fbezn\",\"sl.42033abf.js\",\"3HAPT\",\"sr_RS.422de0c3.js\",\"2GH4w\",\"sr_YR.e7942081.js\",\"7Qzqz\",\"sv.be285bb7.js\",\"gt8Kd\",\"th.ce84311e.js\",\"eVDdh\",\"tr.0d0b1c21.js\",\"hLIwJ\",\"uk.e7fe8053.js\",\"wnH66\",\"vi.8f7a14c6.js\",\"5oeby\",\"zh_TW.ed0b93be.js\",\"2shw0\",\"zh.9a70772f.js\",\"ipx3Q\",\"cs.570ce7f7.js\",\"jXMUM\",\"da.f1f234d3.js\",\"idV8v\",\"de.05cc4382.js\",\"kBQ9k\",\"en.33883507.js\",\"birQa\",\"en_GB.7e18e9bb.js\",\"01Ull\",\"en_ZZ.5c0e606d.js\",\"iyrsM\",\"es.54fad23e.js\",\"hPFdF\",\"fi.76019911.js\",\"k7AqX\",\"fr.cfa1f4d6.js\",\"8sFBs\",\"hr.d80970db.js\",\"iULA4\",\"hu.d24308be.js\",\"gJ4Zj\",\"it.e57a4fe1.js\",\"fvcGb\",\"ja.7e84243e.js\",\"30u08\",\"ko.55782055.js\",\"bEohT\",\"nb.6bb9a3cf.js\",\"4TfaY\",\"nl.83a44ec0.js\",\"7TRKR\",\"pl.e2b19fb9.js\",\"gfmgP\",\"pt_BR.0e966f17.js\",\"8rjqC\",\"ru.c7bb01b9.js\",\"c1meM\",\"sl.aadb4481.js\",\"hnoAT\",\"sr_RS.0e4b5e26.js\",\"h2yiB\",\"sr_YR.68187680.js\",\"7t9jv\",\"sv.83c4d455.js\",\"02wkF\",\"th.1c3ee437.js\",\"f9I75\",\"tr.ea1c296d.js\",\"2ArFg\",\"uk.616d2f64.js\",\"a0qFU\",\"vi.efcf988a.js\",\"3aliZ\",\"zh.1d4676a7.js\",\"k4Fbc\",\"zh_TW.8fff66b3.js\",\"aMWDh\",\"cs.b4059208.js\",\"2Nhk7\",\"da.13021049.js\",\"5GgLt\",\"de.b844d70c.js\",\"aeBaj\",\"en.71456958.js\",\"icI5m\",\"en_GB.86d7eb51.js\",\"56ebG\",\"en_ZZ.ca06b3db.js\",\"bpm6H\",\"es.c1deb870.js\",\"lQBW4\",\"fi.4817897d.js\",\"d3Pby\",\"fr.c594b596.js\",\"i3KTR\",\"hr.843d5593.js\",\"jQsR5\",\"hu.26b852a0.js\",\"buYUs\",\"it.a5ebd285.js\",\"6JyvA\",\"ja.f19f19b7.js\",\"6j4E0\",\"ko.f9cb5c59.js\",\"dx2gW\",\"nb.8b1b107b.js\",\"kRxC0\",\"nl.001f1178.js\",\"6VYUF\",\"pl.6530cf65.js\",\"iTCSz\",\"pt_BR.67877b64.js\",\"9vlOp\",\"ru.b6b37224.js\",\"9fdZA\",\"sl.cdacaf33.js\",\"c1Rfq\",\"sr_RS.45930243.js\",\"b4t5O\",\"sr_YR.3cc2cd85.js\",\"lPFUB\",\"sv.811a5e2b.js\",\"cCO7Q\",\"th.d75cb241.js\",\"eGYFX\",\"tr.36415157.js\",\"e0Zpf\",\"uk.a5e08e1d.js\",\"3mO4w\",\"vi.6d6749e9.js\",\"fJV8L\",\"zh.61ee2118.js\",\"aFaOB\",\"zh_TW.11bb2fdf.js\",\"c243Q\",\"cs.2a29509b.js\",\"9pwoj\",\"da.f85ed53c.js\",\"jbmlj\",\"de.000af340.js\",\"2YMwz\",\"en.25bc58a6.js\",\"apc1e\",\"en_GB.1ba9448b.js\",\"hSszq\",\"en_ZZ.45d09de4.js\",\"hMErM\",\"es.2e10b4ed.js\",\"4mauf\",\"fi.5c92bfdd.js\",\"cV78a\",\"fr.4f71955e.js\",\"a5JUA\",\"hr.6aadb1cb.js\",\"1MwbL\",\"hu.b6c6c45d.js\",\"4ep0R\",\"it.81e14be5.js\",\"6cdZj\",\"ja.7f372aa4.js\",\"aUGH0\",\"ko.fdf6c576.js\",\"bc9H8\",\"nb.a8e755f8.js\",\"jiPaz\",\"nl.3cc37fce.js\",\"7LXV4\",\"pl.9a4146f6.js\",\"dIeeW\",\"pt_BR.7128e5ea.js\",\"1NSIC\",\"ru.13459690.js\",\"iNY4f\",\"sl.263dec8c.js\",\"isQJH\",\"sr_RS.fd766dd2.js\",\"a60ql\",\"sr_YR.a4bc7a03.js\",\"4V1qv\",\"sv.638f613c.js\",\"8vbSC\",\"th.578e548f.js\",\"iwJOJ\",\"tr.81d297c9.js\",\"dlPIZ\",\"uk.56194425.js\",\"4Gbtc\",\"vi.adb49c2e.js\",\"eqiYF\",\"zh.0fe9e57a.js\",\"43BOc\",\"zh_TW.e1739f8d.js\",\"bvkZd\",\"no-results-dark.a00ae47b.svg\",\"cV42Q\",\"no-results-light.5ca83755.svg\",\"4wwg7\",\"PageLayout.a06b9aa4.js\",\"gPjUw\",\"PageLayout.778e4bca.js\",\"3Kg3S\",\"CreateComponent.d65a623d.js\",\"fYFVU\",\"UpflowV2ExperimentErrorBoundary.d7f96885.js\",\"eRrWU\",\"EndUserRequestUpgradeModal.a5a91f42.js\",\"bZz7X\",\"CommentsPanelFilterMenu.f184c42a.js\",\"8Ovry\",\"CommentEditor.bf2b9251.js\",\"fwuXj\",\"cardWithMediaClient.255c2357.js\",\"8Ozg8\",\"inlinePlayer.a9802d9a.js\",\"1oAGT\",\"shrink-diagonal.f22f633c.js\",\"kmmAT\",\"archive.3ae8ddb7.js\",\"8Ned5\",\"volume-high.22037e26.js\",\"c52tG\",\"video-skip-forward-ten.dfbb1d54.js\",\"fZ3WI\",\"video-skip-backward-ten.ce7698a0.js\",\"kFpjX\",\"video.50bd70c3.js\",\"cKkZK\",\"media-viewer-error-boundary.b0f83266.js\",\"bHwQq\",\"archive.1d277fcb.js\",\"2OhRQ\",\"codeViewerRenderer.b9269d67.js\",\"3wpjh\",\"image.d36de887.js\",\"869mA\",\"video.bf4d5d35.js\",\"j7Vtd\",\"audio.d86204bf.js\",\"f33Ay\",\"doc.fbe96761.js\",\"2JEgu\",\"codeViewer.3a53165d.js\",\"d3gsT\",\"codeViewer.c25f2630.js\",\"gTkiI\",\"codeViewer.fd65e68f.js\",\"aNesG\",\"dist.32d9fb42.js\",\"6v3DV\",\"dist.a4d87025.js\",\"FOgP0\",\"dist.1a1badb3.js\",\"laaZq\",\"dist.360031dc.js\",\"9ifQI\",\"dist.e418e7da.js\",\"dvdqq\",\"dist.27efad2d.js\",\"3CazT\",\"dist.b4af5be2.js\",\"gp06T\",\"dist.04df0ad8.js\",\"iXAeq\",\"dist.b54657cc.js\",\"1V58T\",\"dist.f02f9ba4.js\",\"bHvNW\",\"dist.9501f054.js\",\"ieE4C\",\"dist.81b1e5c1.js\",\"9CydI\",\"dist.5dd14922.js\",\"l0PXq\",\"dist.77dd9f1f.js\",\"bvFMP\",\"dist.6b9c7912.js\",\"hvnNT\",\"dist.548dd5e9.js\",\"jLuU0\",\"dist.d535090d.js\",\"exQrq\",\"dist.0edadf19.js\",\"fZOXw\",\"dist.1a9d9397.js\",\"edtrc\",\"dist.04d7d074.js\",\"fVBZH\",\"apl.7a0eb069.js\",\"ghj6h\",\"asciiarmor.c3b5105b.js\",\"g7DY3\",\"asn1.8960d6da.js\",\"69vjS\",\"asterisk.d216fca0.js\",\"qoDPM\",\"brainfuck.3493e766.js\",\"dCh4X\",\"cobol.19c1be5b.js\",\"69TDb\",\"clike.f4176504.js\",\"fTBPG\",\"clojure.13ae4d64.js\",\"7Nyzk\",\"css.df682f1f.js\",\"6Ww1h\",\"cmake.0d0ce1c4.js\",\"bX6oi\",\"coffeescript.f91dd720.js\",\"l0OtY\",\"commonlisp.ad5033b0.js\",\"j0Tov\",\"cypher.19076135.js\",\"dl0Ry\",\"python.c92392ae.js\",\"3jKkl\",\"crystal.dd910bbe.js\",\"5wWnH\",\"d.8b487736.js\",\"3pvGJ\",\"diff.86aeb138.js\",\"bL2K4\",\"dockerfile.6f5e2e2b.js\",\"3LCRx\",\"dtd.db73daa5.js\",\"imNro\",\"dylan.cd7e2cf8.js\",\"lnl9v\",\"ebnf.4a8cf82f.js\",\"jpYxQ\",\"ecl.96e6a496.js\",\"6YQ2N\",\"eiffel.093b27e1.js\",\"7nIe6\",\"elm.6327bd0e.js\",\"hHQRT\",\"erlang.1cdf5bfe.js\",\"hI20A\",\"sql.d9a93ca4.js\",\"lYlYq\",\"factor.4748b963.js\",\"9P7rU\",\"fcl.9474db5c.js\",\"fITeb\",\"forth.d7f3437f.js\",\"bxbTo\",\"fortran.f41c4883.js\",\"23Jq0\",\"mllike.56dc8cf4.js\",\"ajaZe\",\"gas.848679b9.js\",\"kL6oy\",\"gherkin.5552aa51.js\",\"lqGPZ\",\"groovy.8d056831.js\",\"kII2G\",\"haskell.c91e59d1.js\",\"i36zl\",\"haxe.3be11ce5.js\",\"hq2h4\",\"http.3dd37293.js\",\"1TSMN\",\"idl.7ee7a0ec.js\",\"bAZRe\",\"javascript.27f89868.js\",\"b3hNt\",\"jinja2.845f1627.js\",\"6UcU4\",\"julia.c06141f1.js\",\"iZo2Z\",\"livescript.a2a33b86.js\",\"bqYCz\",\"lua.7e3ce73c.js\",\"5dMhR\",\"mirc.11257b0a.js\",\"crYBi\",\"mathematica.e41b91c5.js\",\"2y1ZL\",\"modelica.121f8c84.js\",\"l2uCu\",\"mumps.06395c1b.js\",\"2Z5ZZ\",\"mbox.16659a61.js\",\"5DcAY\",\"nginx.9e06cde4.js\",\"is1HI\",\"nsis.10267711.js\",\"5diCl\",\"ntriples.496fd211.js\",\"3mnLX\",\"octave.0e1e65c3.js\",\"gXFxX\",\"oz.552c344a.js\",\"7RkzV\",\"pascal.04e79766.js\",\"hQW1J\",\"perl.8475d2a2.js\",\"kx6bO\",\"pig.d7f881f5.js\",\"khjYE\",\"powershell.c3bb0b31.js\",\"4LQtS\",\"properties.37ef214c.js\",\"fgry6\",\"protobuf.6099d0a8.js\",\"2D49w\",\"pug.2f2c8a16.js\",\"2iIvT\",\"puppet.d209abb9.js\",\"56vmr\",\"q.b2d2fe9a.js\",\"6M8mj\",\"r.77865540.js\",\"Bj9yK\",\"rpm.789cf7b7.js\",\"lsZih\",\"ruby.f62c0123.js\",\"9Rzyi\",\"sas.eabdba61.js\",\"14feQ\",\"scheme.f98cb495.js\",\"4a1CS\",\"shell.6f613319.js\",\"cS0Tl\",\"sieve.effa51d7.js\",\"fE1yG\",\"smalltalk.691a0573.js\",\"2RJND\",\"solr.3f1f1057.js\",\"dKpKN\",\"sparql.347b53c2.js\",\"hPyi8\",\"spreadsheet.86a982eb.js\",\"1MXZk\",\"stylus.8f67db3e.js\",\"gJn4m\",\"swift.da79331d.js\",\"i69ce\",\"stex.a172baf8.js\",\"cu9I0\",\"verilog.4309e460.js\",\"8AFLP\",\"tcl.185f046a.js\",\"cZ5wm\",\"textile.cfb1d1d7.js\",\"gjd1k\",\"tiddlywiki.582848a6.js\",\"hMQ12\",\"tiki.9c218db9.js\",\"2Lc7X\",\"toml.46d4fb02.js\",\"l6fIN\",\"troff.00dc7fd8.js\",\"hhZ9f\",\"ttcn.65ef0643.js\",\"imJrF\",\"ttcn-cfg.e713276f.js\",\"5e8eb\",\"turtle.8949abe4.js\",\"gOg0N\",\"webidl.39a3456f.js\",\"a0rhU\",\"vb.5f71d4fc.js\",\"2WM1v\",\"vbscript.4da55b21.js\",\"3EdpF\",\"velocity.ad754a83.js\",\"5EwPv\",\"vhdl.4b814e68.js\",\"3zaLm\",\"xquery.cb43bd9a.js\",\"ca7JM\",\"yacas.fc812212.js\",\"do9n8\",\"z80.d5f1a109.js\",\"hZQJQ\",\"mscgen.9da3d272.js\",\"dm0BU\",\"dist.8f7dcff2.js\",\"ijrLT\",\"dist.4421bcb4.js\",\"gQYJt\",\"svg.f7aab7a5.js\",\"azCDs\",\"zoom-out.14174f4b.js\",\"llcfA\",\"zoom-in.e40ea4e9.js\",\"hXu5I\",\"plussquare.3225068e.js\",\"a0oMZ\",\"ui.14f82886.js\",\"iaptT\",\"Page.c08133c2.js\",\"kG8pF\",\"ViewPage.8c417107.js\",\"4YF8c\",\"EditPage.0d3b2aae.js\",\"ja1FH\",\"inline-create-one-step.30560aa1.js\",\"3XbzG\",\"browser-extension.23c865dd.js\",\"k4PhO\",\"global-opt-in-default-image-banner.cf053e66.svg\",\"014Eq\",\"pageHeaderSpotlightImage.b1e98e59.png\",\"bNbqy\",\"CommentsPanelFilterMenu.b00971ff.js\",\"klllM\",\"media.d9e2cc7c.js\",\"jFwZc\",\"CommentEditor.5ef8474d.js\",\"dnE79\",\"editor-ai-opt-in-banner.523b2454.svg\",\"dHQ6a\",\"AiInEditorModal.54a58b05.js\",\"f9Aq7\",\"AnimationContainerLight.5ba1bf64.svg\",\"kDDwa\",\"AnimationContainerDark.542af7ab.svg\",\"cv1Me\",\"CommentEditor.916c4cbe.js\",\"a0vOD\",\"CommentsPanelFilterMenu.465480b1.js\",\"7XAsz\",\"FullPageEditorComponent.c85f637e.js\",\"6z3SN\",\"BrowseRovoAgentsModal.c08785cc.js\",\"lCOAy\",\"CommentsPanelFilterMenu.8fbae50e.js\",\"ePbFO\",\"CommentEditor.9aa2c999.js\",\"5S8LV\",\"CommentEditor.a90c287f.js\",\"7S1t7\",\"FullPageEditorComponent.9183a896.js\",\"1kMwS\",\"FullPageEditorComponent.runtime.780dd19f.js\",\"gbKmf\",\"FullPageEditorComponent.f9a6e93d.js\",\"lE7kL\",\"FullPageEditorComponent.runtime.f36f7592.js\",\"dpE2f\",\"CommentsPanelFilterMenu.51feca81.js\",\"dFj2L\",\"FullPageEditorComponent.73469be1.js\",\"iBsCz\",\"FullPageEditorComponent.runtime.31caf624.js\",\"jwWp5\",\"CommentsPanelFilterMenu.a341700c.js\",\"k5nno\",\"FullPageEditorComponent.0b4791b7.js\",\"dmT4z\",\"FullPageEditorComponent.runtime.840382b7.js\",\"dmT4z\",\"FullPageEditorComponent.runtime.840382b7.js\",\"1kMwS\",\"FullPageEditorComponent.runtime.780dd19f.js\",\"lE7kL\",\"FullPageEditorComponent.runtime.f36f7592.js\",\"iBsCz\",\"FullPageEditorComponent.runtime.31caf624.js\",\"9fiFD\",\"getMonitoringClient.78ecb96c.js\",\"fH5Zm\",\"Attribution.01c00187.js\",\"bUC6C\",\"FeedbackCollector.baf885be.js\",\"jjWia\",\"TableOfContents.92d9c9e5.js\",\"3ioZJ\",\"DateComponent.0d538ab5.js\",\"iTmpz\",\"EmojiComponent.ae8ea80d.js\",\"8OJBc\",\"MentionComponent.8f6e825d.js\",\"fDwDZ\",\"StatusComponent.011f3720.js\",\"4amFq\",\"TableOfContents.df7b13fb.js\",\"cqNU4\",\"CommentWarningDialog.e4931d50.js\",\"7aOpi\",\"CommentsPanelFilterMenu.c2d16cbf.js\",\"iEvs6\",\"json-schema-validation.12c711fd.js\",\"1C6qR\",\"Reactions.74cb4a30.js\",\"8tLTz\",\"CommentsPanelFilterMenu.ff520148.js\",\"918Xb\",\"CommentsPanelFilterMenu.3399eafb.js\",\"b6EsR\",\"CommentsPanelFilterMenu.4a27a90c.js\",\"dOpG1\",\"FullPageEditorComponent.748cd99d.js\",\"7KVRH\",\"CommentsPanelFilterMenu.56f4ef5e.js\",\"2KeLI\",\"CommentsPanelFilterMenu.4c3e000f.js\",\"edaDG\",\"CommentsPanelFilterMenu.c4a8a864.js\",\"i8hiG\",\"UnreadIndicator.c9f9b434.js\",\"3fgvt\",\"LazyTrigger.511b43b3.js\",\"3VpLA\",\"initLoomSDK.6160549d.js\",\"2NjlT\",\"loom.8ebbd718.js\",\"e1fGs\",\"utils.4c418040.js\",\"ixLhb\",\"PopupContent.b65396ba.js\",\"VZLsm\",\"PopupContent.e7849e62.js\",\"eZu0L\",\"goal.fa597430.js\",\"l8LQp\",\"data-number.9bfeb2b4.js\",\"5ettc\",\"ProfileCard.4f8a6d61.js\",\"jiK0X\",\"GoalPanel.ef9b8977.js\",\"9ZnhG\",\"th.71647b0c.js\",\"4Tiff\",\"uk.918f46f0.js\",\"iz8ME\",\"vi.6f47ac80.js\",\"1Pok1\",\"key-result.3e2e8c95.js\",\"jtcRz\",\"objective.9e034c80.js\",\"g55vn\",\"team.0503738f.js\",\"hjuEj\",\"project.96220d0d.js\",\"28VDA\",\"ProjectLinkerGoal.09157250.js\",\"m7vj2\",\"provider.29331aed.js\",\"gdS1N\",\"provider.0c84dc4d.js\",\"cs0k1\",\"th.bc465272.js\",\"gce4m\",\"uk.ff4881ca.js\",\"eFwGF\",\"vi.52b3bee6.js\",\"hLVzM\",\"suggested-edit.9edafd06.js\",\"k97iL\",\"focus-area.6dcaf5d4.js\",\"5BMnr\",\"calendar-plus.435c4b76.js\",\"a7NC3\",\"LazyTrigger.c88521fe.js\",\"4XOEX\",\"cs.e0a70b47.js\",\"gqmha\",\"da.48cfbab1.js\",\"cweX3\",\"de.c8767744.js\",\"bai9u\",\"en_GB.2df39ad9.js\",\"9t1Ib\",\"en_ZZ.3d0895e5.js\",\"eHlQ9\",\"es.5d6eee32.js\",\"6abco\",\"fi.e8345104.js\",\"fvLDA\",\"fr.677c98af.js\",\"jYjnT\",\"hu.9ea72c86.js\",\"6chG6\",\"it.7d94cfcb.js\",\"bXBzb\",\"ja.74e96883.js\",\"fMgo4\",\"ko.f48b8bc8.js\",\"1HBhy\",\"nb.8f124772.js\",\"9YSn1\",\"nl.75d7c0f6.js\",\"40Jja\",\"pl.097351e1.js\",\"ibJOL\",\"pt_BR.71273029.js\",\"ipGTo\",\"ru.1c3aa9c4.js\",\"1dEiK\",\"sv.b0049c52.js\",\"bNIzh\",\"th.bf4e4f62.js\",\"bjl5Z\",\"tr.48095000.js\",\"7A6MW\",\"uk.d4d28cfc.js\",\"gu0nB\",\"vi.a8ee96b8.js\",\"2xhtF\",\"zh_TW.6ac6eb68.js\",\"iwPoV\",\"zh.92106a7f.js\",\"4XUbE\",\"universal-create.eb6a2f31.js\",\"jBwbI\",\"LoomMigrationModalManager.12e833af.js\",\"3jZMP\",\"loomMigrationModalImage.fa8ef03b.svg\",\"1wrZ9\",\"vector.07efb279.svg\",\"b8oHe\",\"EngagementInlineDialogWrapper.154d7754.js\",\"a6eof\",\"PageLayout.50b30fd4.js\",\"jfTrX\",\"AppNavigation.9663b4da.js\",\"hesl9\",\"RecentPages.d8ede11c.js\",\"8q7U9\",\"Collaboration.a011f6bd.svg\",\"eJwDQ\",\"SearchError.ab7cb722.svg\",\"lPQcc\",\"team-preview-panel.b877b0ca.js\",\"6JvQz\",\"PeopleItemWrapper.6f5209a6.js\",\"bf0yj\",\"modal-dialog.4ea336eb.js\",\"6SYnx\",\"teamCreateDialog.e870f063.js\",\"40B2u\",\"MenuContent.62b07cbe.js\",\"bZtF0\",\"th.2e84f7a8.js\",\"9pBxJ\",\"uk.020682a9.js\",\"bM16t\",\"vi.2c973112.js\",\"2ZapG\",\"AppsContent.2caf0cbd.js\",\"emP1M\",\"blocks.348a3d50.svg\",\"1Zku8\",\"DiscoverSection.2a37e1ca.js\",\"bVqnE\",\"CustomHomepageItem.241b4b04.js\",\"F2Q4u\",\"AppSwitcherComponentWrapper.133c8e29.js\",\"5GXmr\",\"AppSwitcherContent.00607ed4.js\",\"df12q\",\"NotificationsComponent.51a559ff.js\",\"heZTL\",\"SettingsComponent.4ec0e93d.js\",\"6YgN9\",\"MenuComponent.d97ece90.js\",\"eXOVv\",\"HelpComponent.9ec8441a.js\",\"01qRE\",\"SearchComponent.cf8a2643.js\",\"4L1zw\",\"work-item.ec0552af.js\",\"cMlHc\",\"24.d456f48f.js\",\"1wZEW\",\"cards-extension.cf20134d.js\",\"eHw9Y\",\"ProfileComponent.a13c7c2e.js\",\"9IyPY\",\"ProfileMenu.3390e62b.js\",\"9PQXU\",\"AppNavigation.8d875c2b.js\",\"jmmCO\",\"RightSidebar.da67128d.js\",\"aWd5V\",\"PageLayout.de0dbcf4.js\",\"lgm1i\",\"StandaloneRestrictedPageOrSpace.27173cc2.js\",\"kUiwW\",\"RestrictedPage.152e9248.js\",\"5WZOQ\",\"CantViewLight.81544b8c.svg\",\"dHMTU\",\"CantViewDark.ef25ef94.svg\",\"cOpg6\",\"CantEditLight.0ee7f232.svg\",\"37OHY\",\"CantEditDark.190a22b1.svg\",\"2OcM6\",\"RestrictedSpace.a09a6d96.js\",\"6f3t8\",\"AdminKeyUpSell.4d009e71.js\",\"euA5f\",\"SuperAdminEntryPoint.a53fd48a.js\",\"55AxV\",\"RestrictedContentIcon-Dark.bc90ae31.svg\",\"L0tFv\",\"RestrictedContentIcon-Light.e0fef1fb.svg\",\"7DDw1\",\"ConfluenceLogo.37570e84.svg\",\"gEi5K\",\"NotFound.eb9c49e6.js\",\"QfEJc\",\"NotFoundIcon.ab9d1086.svg\",\"k0WnS\",\"ExternalPageNotFoundV2.0bb41914.js\",\"4J5D7\",\"not-found-v2.ab9d1086.svg\",\"lwfE5\",\"ArchiveSpacePortal.c81e1bf6.js\",\"j06N4\",\"ArchiveSpacePanel.52dc7e65.js\",\"d7sp9\",\"DeleteSpacePortal.64e9d334.js\",\"ei0Jg\",\"SpaceSettingsForgeExtensionPortal.1f78b62e.js\",\"bGzhS\",\"ByLineForgeApp.aa02937a.js\",\"eMbal\",\"loading-button.90d63bac.js\",\"cjJTJ\",\"section-message.547b3afe.js\",\"jeyta\",\"no-results.603cf20f.svg\",\"kF2EK\",\"FullPageEditorComponent.a1737058.js\",\"ei4Kz\",\"FullPageEditorComponent.runtime.f59382b4.js\",\"lMdi0\",\"ByLineForgeApp.a87df9ea.js\",\"jigcs\",\"LabelsSelect.7af14b99.js\",\"718G0\",\"LabelsSelectErrors.6ba11745.js\",\"4LmEY\",\"ViewPageLabels.c10bbadf.js\",\"djzzD\",\"PageLabelsAutomationDiscovery.25bb6bbc.js\",\"ei4Kz\",\"FullPageEditorComponent.runtime.f59382b4.js\",\"bdzih\",\"ContentActionForgeApp.adf3cb9a.js\",\"cwpVK\",\"ContextMenuForgeApp.c4f867ca.js\",\"68RC4\",\"FullPageForgeApp.28bb525e.js\",\"87cDu\",\"GlobalPageForgeApp.7c333e83.js\",\"iXr0W\",\"GlobalSettingsForgeApp.3aaabcce.js\",\"ccJug\",\"HomepageFeedForgeApp.cad72689.js\",\"irYLY\",\"SpaceSettingsForgeApp.a1064f6e.js\",\"ldtPf\",\"SpacePageForgeApp.cd9e8c8b.js\",\"6wcNV\",\"CustomContentForgeApp.e2f43881.js\",\"i9jMB\",\"BackgroundScriptForgeApp.7a2ba870.js\",\"aFNXd\",\"PageBannerForgeApp.b785de0a.js\",\"hhf8b\",\"SpaceTrashPortal.3897b499.js\",\"an2zh\",\"SiteSettingsHelpPanelLink.48fe27c8.js\",\"gJRFC\",\"BackupManagerButton.576a1571.js\",\"2gTex\",\"dashboard-spa-container-jquery3.f7859dc2.js\",\"fQqwz\",\"dashboard-spa-container-jquery3.runtime.f0b4ae2f.js\",\"aZinD\",\"vendors.bbe3333a.js\",\"eiF7i\",\"stable_vendors.71f5c84d.js\"]"));
 }, ["7EorR","2gTex","fQqwz","aZinD","eiF7i","hhss7","ffEVr","1yVM6","1qlDN","5pvpJ","6XCf4","cEqm7","6wr18"]);
$parcel$global.rwr("3pblT", () => { 
var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $5QpZa = parcelRequire("5QpZa");


var $hp2SH = parcelRequire("hp2SH");


var $iC5L0 = parcelRequire("iC5L0");


var $aXEzU = parcelRequire("aXEzU");





var $3WLLD = parcelRequire("3WLLD");


var $bj5fB = parcelRequire("bj5fB");





var $7J5Uc = parcelRequire("7J5Uc");

const $14d55bbfca2abbc5$export$7a88623f52f1b79 = (initialTheme)=>{
    const [{ isInitialized: isInitialized }, { initializeTheme: initializeTheme }] = (0, $7J5Uc.useThemingState)();
    (0, $42omo.useEffect)(()=>{
        initializeTheme(initialTheme);
    // Only execute upon initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return isInitialized;
};


const $e6baa9171970034d$export$11eb671888ed6e7d = ({ children: children })=>{
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const initialTheme = isMobileApp ? (0, $3WLLD.mobileAppTheme) : undefined;
    const isInitialized = (0, $14d55bbfca2abbc5$export$7a88623f52f1b79)(initialTheme);
    if (!isInitialized) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};



var $7zgzO = parcelRequire("7zgzO");


var $awd1Q = parcelRequire("awd1Q");


var $9j59h = parcelRequire("9j59h");


var $xwvlW = parcelRequire("xwvlW");


var $8PKGr = parcelRequire("8PKGr");


var $68uaC = parcelRequire("68uaC");


var $9wGTI = parcelRequire("9wGTI");


var $gznk3 = parcelRequire("gznk3");


var $17wUi = parcelRequire("17wUi");


var $gnYQc = parcelRequire("gnYQc");


var $2DVQX = parcelRequire("2DVQX");


var $7LuKf = parcelRequire("7LuKf");





var $6g1oe = parcelRequire("6g1oe");


var $4xcIM = parcelRequire("4xcIM");


var $2FNjD = parcelRequire("2FNjD");


var $ge2sX = parcelRequire("ge2sX");


var $f7i8j = parcelRequire("f7i8j");


var $cryCi = parcelRequire("cryCi");


var $dBmJE = parcelRequire("dBmJE");








var $kFqI2 = parcelRequire("kFqI2");


var $T1bCI = parcelRequire("T1bCI");


var $lonEO = parcelRequire("lonEO");


var $iJELi = parcelRequire("iJELi");


var $d5ap9 = parcelRequire("d5ap9");


var $hmRc4 = parcelRequire("hmRc4");


var $fcF01 = parcelRequire("fcF01");


var $iJiK8 = parcelRequire("iJiK8");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $25MM7 = parcelRequire("25MM7");





var $jVK0t = parcelRequire("jVK0t");


var $64KID = parcelRequire("64KID");


var $kZDrw = parcelRequire("kZDrw");


var $8n9tL = parcelRequire("8n9tL");


var $1ytiN = parcelRequire("1ytiN");


var $a5txT = parcelRequire("a5txT");


var $97W74 = parcelRequire("97W74");

class $7db816b9e13721ff$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    render() {
        const { store: store } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Provider), {
            inject: [
                (0, $a5txT.getStandalonePageTreeStateUpdater)()
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lonEO.GraphqlProvider), {
            client: (0, $hp2SH.getApolloClient)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kFqI2.Provider), {
            store: store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1ytiN.SPAViewContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1kHsc.ExperienceTrackerContext).Provider, {
            value: (0, $fGzMp.getExperienceTracker)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jVK0t.I18nProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d5ap9.ConfluenceAnalyticsListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZDrw.NavdexListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $97W74.EngagementProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dBmJE.ConnectedRouter), {
            history: this.browserHistory,
            context: (0, $kFqI2.ReactReduxContext)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fcF01.UpFlowProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $25MM7.Flags), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJELi.ConnectSupport), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8n9tL.RouteManager), {
            namedRoutes: (0, $64KID.namedRoutes)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJiK8.Dialogs), null), this.props.children))))))))))));
    }
    constructor(...args){
        super(...args);
        this.browserHistory = (0, $hmRc4.getBrowserHistory)();
    }
}
$7db816b9e13721ff$export$2e2bcd8739ae039.propTypes = {
    /**
   * Global store
   */ store: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    /**
   * Children Component
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).any,
    /**
   * Indicates if the component is rendered as Root
   */ renderAsRoot: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};



var $3Tw8v = parcelRequire("3Tw8v");


var $9F7Qb = parcelRequire("9F7Qb");

const $d4f95b5cede9219f$var$store = (0, $3Tw8v.default)({
    isServerRenderedPage: true
});
(0, $9F7Qb.subscribe)($d4f95b5cede9219f$var$store);
/**
 * Method for rendering React/Redux component
 * Usage:
 * import renderComponent from './renderComponentIntoDOM';
 * renderComponent(<YourComponent />, 'your-component-section-id');
 * OR renderComponent(<YourComponent />, DOMComponent);
 *
 * @param children
 * @param container DOM node or id string
 */ const $d4f95b5cede9219f$var$renderComponentIntoDOM = (children, container, renderAsRoot = false)=>{
    if (typeof container === 'string') container = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.getElementById(container);
    const Component = ({ sessionData: sessionData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7i8j.SessionDataContext).Provider, {
            value: sessionData
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cryCi.Provider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7db816b9e13721ff$export$2e2bcd8739ae039), {
            store: $d4f95b5cede9219f$var$store,
            renderAsRoot: renderAsRoot
        }, children)));
    Component.propTypes = {
        sessionData: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired
    };
    (0, $ge2sX.getSessionData)().then((sessionData)=>{
        const concurrentComponentWrapper = (0, $2FNjD.createRoot)(container);
        concurrentComponentWrapper.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            sessionData: sessionData
        }));
    });
};
var $d4f95b5cede9219f$export$2e2bcd8739ae039 = $d4f95b5cede9219f$var$renderComponentIntoDOM;



var $7RVQB = parcelRequire("7RVQB");




/**
 * These helper functions should be used to minimize the impact the standalone sidebar causes to the ui (jump, flip, flash, jank);
 */ const $8bee1fe38b9eef04$var$mainSectionsSelectors = [
    '#main',
    '#admin-content',
    '#custom-content-container',
    '.ap-servlet-placeholder'
];
const $8bee1fe38b9eef04$export$ed04e7f6ba662aee = ()=>{
    const head = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.head || (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.querySelector('head');
    const style = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.createElement('style');
    const css = `${$8bee1fe38b9eef04$var$mainSectionsSelectors.join(',')} { opacity: 0 };`;
    style.type = 'text/css';
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.createTextNode(css));
    if (head) head.appendChild(style);
};
const $8bee1fe38b9eef04$export$4011f4c5a8044281 = (runs = 0)=>{
    const mainContainers = $8bee1fe38b9eef04$var$mainSectionsSelectors.map((selector)=>(0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.querySelector(selector)).filter((ele)=>ele !== null);
    if (mainContainers.length) mainContainers.forEach((container)=>{
        if (container) {
            container.style.transition = 'opacity .15s ease-in';
            container.style.opacity = '1';
        }
    });
    else // accounting for any race condition that could delay the parsing of the content
    if (runs < 5) {
        console.warn('Legacy pages: trying to fix jank behaviour on legacy pages but content container is not found yet');
        setTimeout(()=>$8bee1fe38b9eef04$export$4011f4c5a8044281(runs + 1), 100);
    } else console.error('Legacy pages: content container was not found');
};






var $iyEDi = parcelRequire("iyEDi");


var $gnnzK = parcelRequire("gnnzK");


var $1NBp8 = parcelRequire("1NBp8");

/* StandaloneConfluenceNavigation.js generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");





var $eXODy = parcelRequire("eXODy");


var $iV00x = parcelRequire("iV00x");


var $3pfAb = parcelRequire("3pfAb");


var $NAPtM = parcelRequire("NAPtM");


var $3u0dr = parcelRequire("3u0dr");





var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $bQm3c = parcelRequire("bQm3c");











var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $gmMgo = parcelRequire("gmMgo");


var $30qWc = parcelRequire("30qWc");





var $gqqjz = parcelRequire("gqqjz");








var $b1HmN = parcelRequire("b1HmN");


var $eSUdr = parcelRequire("eSUdr");

const $13bb14eac5ea00fc$export$bae28e68d0aa638c = (0, $eSUdr.default)`mutation ClearRestrictionsForFreeMutation($contentId:ID!){clearRestrictionsForFree(contentId:$contentId){restrictionsHash}}`;


const $e5314625536bb69f$export$8a37b2ec23f0faea = 'confluence-change-edition-remove-restrictions-button';
const $e5314625536bb69f$export$9f92e67dea336ca7 = 'confluence-change-edition-notification-dialog';
const $e5314625536bb69f$var$i18n = (0, $cgtv4.defineMessages)({
    removeRestrictionButton: {
        id: "change-edition.notification.dialog.general.button.remove-restrictions",
        defaultMessage: "Remove restrictions"
    },
    removeRestrictionTitle: {
        id: "change-edition.notification.dialog.general.title.remove-restrictions-2",
        defaultMessage: "Remove restrictions?"
    },
    removeRestrictionTextSpaceLevel: {
        id: "change-edition.notification.dialog.space.text.remove-restrictions",
        defaultMessage: "You\u2019re on the free plan, so you can only <b>remove all restrictions</b> from <b>{contentTitle}</b>. <b>This can\u2019t be undone.</b> You won\u2019t be able to reset the restrictions later."
    },
    removeRestrictionConfirmationSuccessTitle: {
        id: "change-edition.notification.dialog.confirmation.success.title",
        defaultMessage: "Restrictions removed"
    },
    removeRestrictionConfirmationSuccessDesc: {
        id: "change-edition.notification.dialog.confirmation.success.desc",
        defaultMessage: "Anyone who\u2019s logged in can now view and edit {contentTitle}."
    },
    removeRestrictionConfirmationFailedTitle: {
        id: "change-edition.notification.dialog.confirmation.failed.title",
        defaultMessage: "Page restrictions not removed"
    },
    removeRestrictionConfirmationFailedDesc: {
        id: "change-edition.notification.dialog.confirmation.failed.desc",
        defaultMessage: "We couldn\u2019t remove restrictions from {contentTitle}. Try again."
    }
});
const $e5314625536bb69f$var$DEFAULT_COMPONENT_STATE = {
    isNotificationOpen: false,
    isMutationInProcess: false,
    contentId: null,
    contentTitle: null
};
//TODO: remove dep on shared i18n.
const $e5314625536bb69f$var$changeEditionPageRestrictionsLegacyCoordinatorI18n = (0, $cgtv4.defineMessages)({
    // Notification Dialog --------------------
    cancelButton: {
        id: "change-edition.general.button.cancel",
        defaultMessage: "Cancel"
    }
});
class $e5314625536bb69f$var$ChangeEditionPageRestrictionsLegacyCoordinatorComponent extends (0, $42omo.PureComponent) {
    componentDidMount() {
        Array.prototype.forEach.call(this.allRemoveRestrictionsElements, (el)=>{
            el.addEventListener('click', this.openNotificationDialog);
        });
    }
    componentWillUnmount() {
        Array.prototype.forEach.call(this.allRemoveRestrictionsElements, (el)=>{
            el.removeEventListener('click', this.openNotificationDialog);
        });
    }
    render() {
        const { intl: intl } = this.props;
        const { isNotificationOpen: isNotificationOpen, isMutationInProcess: isMutationInProcess, contentTitle: contentTitle, contentId: contentId } = this.state;
        if (!this.placeholderEl) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ location: location, matchRoute: matchRoute })=>{
            const route = matchRoute(location.pathname);
            // Skip rendering for other then "Space Setting / Restricted Page" page
            if (!route || route.name != (0, $1NBp8.SPACE_RESTRICTED_PAGES).name) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $30qWc.MutationInterop), {
                    mutation: (0, $13bb14eac5ea00fc$export$bae28e68d0aa638c),
                    variables: {
                        contentId: contentId
                    },
                    onCompleted: this.handleMutationComplete(flags),
                    onError: this.handleMutationError(flags)
                }, (clearRestrictionsForFreeMutation)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1HmN.LoadableChangeEditionNotificationDialog), {
                        isOpen: isNotificationOpen,
                        isProcessing: isMutationInProcess,
                        cancelAction: {
                            text: intl.formatMessage($e5314625536bb69f$var$changeEditionPageRestrictionsLegacyCoordinatorI18n.cancelButton),
                            onClick: this.closeNotificationDialog
                        },
                        applyAction: {
                            text: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionButton),
                            onClick: this.applyChanges(clearRestrictionsForFreeMutation)
                        },
                        heading: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionTitle),
                        source: "individualSpaceRestrictedPages",
                        grandfathered: true
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                        ...$e5314625536bb69f$var$i18n.removeRestrictionTextSpaceLevel,
                        values: {
                            contentTitle: contentTitle,
                            b: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
                        }
                    })))), this.placeholderEl);
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            ...$e5314625536bb69f$var$DEFAULT_COMPONENT_STATE
        };
        this.allRemoveRestrictionsElements = window.document.getElementsByClassName($e5314625536bb69f$export$8a37b2ec23f0faea) || [];
        this.placeholderEl = window.document.getElementById($e5314625536bb69f$export$9f92e67dea336ca7);
        this.openNotificationDialog = (event)=>{
            this.setState({
                isNotificationOpen: true,
                contentId: event.target.getAttribute('data-page-id'),
                contentTitle: event.target.getAttribute('data-page-title')
            });
        };
        this.closeNotificationDialog = ()=>{
            this.setState($e5314625536bb69f$var$DEFAULT_COMPONENT_STATE);
        };
        this.applyChanges = (mutationFunction)=>()=>{
                this.setState({
                    isMutationInProcess: true
                });
                mutationFunction();
            };
        this.handleMutationComplete = (flags)=>()=>{
                const { intl: intl } = this.props;
                const { contentTitle: contentTitle } = this.state;
                flags.showSuccessFlag({
                    title: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationSuccessTitle),
                    description: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationSuccessDesc, {
                        contentTitle: contentTitle
                    })
                });
                this.closeNotificationDialog();
                window.setTimeout(()=>{
                    // refresh the page to see the changes
                    window.location.reload();
                }, 500);
            };
        this.handleMutationError = (flags)=>()=>{
                const { intl: intl } = this.props;
                const { contentTitle: contentTitle } = this.state;
                flags.showErrorFlag({
                    title: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationFailedTitle),
                    description: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationFailedDesc, {
                        contentTitle: contentTitle
                    })
                });
                this.closeNotificationDialog();
            };
    }
}
$e5314625536bb69f$var$ChangeEditionPageRestrictionsLegacyCoordinatorComponent.propTypes = {
    intl: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object
};
const $e5314625536bb69f$export$5b44234181f42094 = (0, $gmMgo.default)($e5314625536bb69f$var$ChangeEditionPageRestrictionsLegacyCoordinatorComponent);


















var $frIzR = parcelRequire("frIzR");







var $8C5kA = parcelRequire("8C5kA");





var $4WmbV = parcelRequire("4WmbV");

const $4c2daaa3bc0c282d$var$i18n = (0, $cgtv4.defineMessages)({
    siteAdminAuditLogsTitle: {
        id: "change-edition.section.message.site-admin.audit-logs.title",
        defaultMessage: "Upgrade for Audit logs"
    },
    nonSiteAdminAuditLogsTitle: {
        id: "change-edition.section.message.non-site-admin.audit-logs.title",
        defaultMessage: "Audit logs are only available on paid plans"
    },
    siteAdminAuditLogsBody: {
        id: "change-edition.section.message.site-admin-audit-logs.body",
        defaultMessage: "You\u2019re on the free plan, so you can\u2019t view and track changes made across your site in the audit logs. To access the audit logs, upgrade your plan."
    },
    nonSiteAdminAuditLogsBody: {
        id: "change-edition.section.message.non-site-admin-audit-logs.body",
        defaultMessage: "You\u2019re on the free plan, so you can\u2019t view and track changes made across your site in the audit logs."
    }
});
const $4c2daaa3bc0c282d$export$cb2ba78fe55aff74 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(9);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const title = isSiteAdmin ? $4c2daaa3bc0c282d$var$i18n.siteAdminAuditLogsTitle : $4c2daaa3bc0c282d$var$i18n.nonSiteAdminAuditLogsTitle;
    const body = isSiteAdmin ? $4c2daaa3bc0c282d$var$i18n.siteAdminAuditLogsBody : $4c2daaa3bc0c282d$var$i18n.nonSiteAdminAuditLogsBody;
    let t0;
    if ($[0] !== formatMessage || $[1] !== title) {
        t0 = formatMessage(title);
        $[0] = formatMessage;
        $[1] = title;
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] !== body || $[4] !== formatMessage) {
        t1 = formatMessage(body);
        $[3] = body;
        $[4] = formatMessage;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== t0 || $[7] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
            title: t0,
            body: t1,
            source: "auditLogs"
        });
        $[6] = t0;
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const title = isSiteAdmin ? $4c2daaa3bc0c282d$var$i18n.siteAdminAuditLogsTitle : $4c2daaa3bc0c282d$var$i18n.nonSiteAdminAuditLogsTitle;
    const body = isSiteAdmin ? $4c2daaa3bc0c282d$var$i18n.siteAdminAuditLogsBody : $4c2daaa3bc0c282d$var$i18n.nonSiteAdminAuditLogsBody;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        title: formatMessage(title),
        body: formatMessage(body),
        source: "auditLogs"
    });
};




















var $f7Bnv = parcelRequire("f7Bnv");




const $ee74963fbde2c4ed$var$i18n = (0, $cgtv4.defineMessages)({
    siteAdminContentRestrictionsTitle: {
        id: "change-edition.section.message.site-admin.content-restrictions.title",
        defaultMessage: "Upgrade for content-level restrictions"
    },
    nonSiteAdminContentRestrictionsTitle: {
        id: "change-edition.section.message.non-site-admin.content-restrictions.title",
        defaultMessage: "Content-level restrictions are only available on paid plans"
    },
    spaceRestrictedPagesText: {
        id: "change-edition.section.message.space-restricted-pages.text",
        defaultMessage: "You\u2019re on the free plan, so you can only remove all restrictions from content by clicking the lock icon below. To set restrictions, upgrade your plan."
    },
    nonSiteAdminGrandfatheredRestrictedPagesBody: {
        id: "change-edition.section.message.non-admin.grandfathered.space-restricted-pages.body",
        defaultMessage: "You\u2019re on the free plan, so you can only remove all restrictions from content by clicking the lock icon below."
    },
    siteAdminRestrictedPagesBody: {
        id: "change-edition.section.message.site-admin.space-restricted-pages.body",
        defaultMessage: "You\u2019re on the free plan, so anyone who\u2019s logged in can view and edit everything. To set restrictions, upgrade your plan."
    },
    nonSiteAdminRestrictedPagesBody: {
        id: "change-edition.section.message.non-admin.space-restricted-pages.body",
        defaultMessage: "You\u2019re on the free plan, so anyone who\u2019s logged in can view and edit everything."
    }
});
function $ee74963fbde2c4ed$var$getBody(isSiteAdmin, grandfathered) {
    if (grandfathered) {
        if (isSiteAdmin) return $ee74963fbde2c4ed$var$i18n.spaceRestrictedPagesText;
        else return $ee74963fbde2c4ed$var$i18n.nonSiteAdminGrandfatheredRestrictedPagesBody;
    } else {
        if (isSiteAdmin) return $ee74963fbde2c4ed$var$i18n.siteAdminRestrictedPagesBody;
        else return $ee74963fbde2c4ed$var$i18n.nonSiteAdminRestrictedPagesBody;
    }
}
const $ee74963fbde2c4ed$var$ChangeEditionSectionMessageSpaceContentComponent = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { grandfathered: grandfathered, isSiteAdmin: isSiteAdmin } = t0;
    const intl = (0, $8C5kA.default)();
    let T0;
    let t1;
    let t2;
    if ($[0] !== grandfathered || $[1] !== intl || $[2] !== isSiteAdmin) {
        const bodyText = $ee74963fbde2c4ed$var$getBody(isSiteAdmin, grandfathered);
        const title = isSiteAdmin ? $ee74963fbde2c4ed$var$i18n.siteAdminContentRestrictionsTitle : $ee74963fbde2c4ed$var$i18n.nonSiteAdminContentRestrictionsTitle;
        T0 = (0, $4WmbV.ChangeEditionSectionMessage);
        if ($[6] !== intl || $[7] !== title) {
            t1 = intl.formatMessage(title);
            $[6] = intl;
            $[7] = title;
            $[8] = t1;
        } else t1 = $[8];
        t2 = intl.formatMessage(bodyText);
        $[0] = grandfathered;
        $[1] = intl;
        $[2] = isSiteAdmin;
        $[3] = T0;
        $[4] = t1;
        $[5] = t2;
    } else {
        T0 = $[3];
        t1 = $[4];
        t2 = $[5];
    }
    let t3;
    if ($[9] !== T0 || $[10] !== t1 || $[11] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            title: t1,
            body: t2,
            source: "individualSpaceRestrictedPages"
        });
        $[9] = T0;
        $[10] = t1;
        $[11] = t2;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
} : ({ grandfathered: grandfathered, isSiteAdmin: isSiteAdmin })=>{
    const intl = (0, $8C5kA.default)();
    const bodyText = $ee74963fbde2c4ed$var$getBody(isSiteAdmin, grandfathered);
    const title = isSiteAdmin ? $ee74963fbde2c4ed$var$i18n.siteAdminContentRestrictionsTitle : $ee74963fbde2c4ed$var$i18n.nonSiteAdminContentRestrictionsTitle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        title: intl.formatMessage(title),
        body: intl.formatMessage(bodyText),
        source: "individualSpaceRestrictedPages"
    });
};
$ee74963fbde2c4ed$var$ChangeEditionSectionMessageSpaceContentComponent.propTypes = {
    grandfathered: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired,
    isSiteAdmin: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};
const $ee74963fbde2c4ed$export$51350d82d36f7e43 = (0, $f7Bnv.withIsSiteAdmin)($ee74963fbde2c4ed$var$ChangeEditionSectionMessageSpaceContentComponent);


const $63cbc74b40cb8d33$export$4a53029580aac53e = 'confluence-change-edition-section-message';
class $63cbc74b40cb8d33$export$b9f1eac8c818cdb0 extends (0, $42omo.Component) {
    isSectionMessageNeeded(routeName) {
        return routeName && Boolean(this.ROUTE_NAME2COMPONENT[routeName.name]);
    }
    getComponentParams(routeName) {
        if (routeName === (0, $1NBp8.SPACE_RESTRICTED_PAGES).name) return {
            grandfathered: this.el.getAttribute('data-grandfathered') === 'true'
        };
        return {};
    }
    render() {
        if (!this.el) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ location: location, matchRoute: matchRoute })=>{
            const routeName = matchRoute(location.pathname + location.search);
            if (!this.isSectionMessageNeeded(routeName)) return null;
            const ChangEditionComponent = this.ROUTE_NAME2COMPONENT[routeName.name];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ChangEditionComponent, this.getComponentParams(routeName.name)), this.el);
        });
    }
    constructor(...args){
        super(...args);
        this.el = window.document.getElementById($63cbc74b40cb8d33$export$4a53029580aac53e);
        this.ROUTE_NAME2COMPONENT = {
            [(0, $1NBp8.SPACE_RESTRICTED_PAGES).name]: (0, $ee74963fbde2c4ed$export$51350d82d36f7e43),
            [(0, $1NBp8.ADMIN_AUDIT_LOG).name]: (0, $4c2daaa3bc0c282d$export$cb2ba78fe55aff74)
        };
    }
}


const $f60f9bb0af41c642$export$ddc928ad192d2b94 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $bQm3c.useSessionData)().edition === "FREE" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63cbc74b40cb8d33$export$b9f1eac8c818cdb0), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5314625536bb69f$export$5b44234181f42094), null))) : null;
} : ()=>(0, $bQm3c.useSessionData)().edition === 'FREE' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63cbc74b40cb8d33$export$b9f1eac8c818cdb0), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5314625536bb69f$export$5b44234181f42094), null))) : null;






var $4PPzL = parcelRequire("4PPzL");


var $04e9M = parcelRequire("04e9M");


var $56QzY = parcelRequire("56QzY");


var $1dnxO = parcelRequire("1dnxO");


var $aeSHO = parcelRequire("aeSHO");


var $iJ8K8 = parcelRequire("iJ8K8");


var $4l6Wo = parcelRequire("4l6Wo");


var $hDG7z = parcelRequire("hDG7z");


var $eWwvy = parcelRequire("eWwvy");


var $39rFu = parcelRequire("39rFu");





var $cBuRD = parcelRequire("cBuRD");





var $eIKcA = parcelRequire("eIKcA");





var $ezLwY = parcelRequire("ezLwY");

/**
 * shortcutContext('global') or shortcutContext(['global', 'viewcontent'])
 * @param context
 * @returns {Function}
 */ function $089e60b6c1a73ffc$var$shortcutContext(context) {
    return (BaseComponent)=>{
        class ShortcutContextComponent extends (0, $42omo.Component) {
            componentDidMount() {
                (0, $ezLwY.enableContext)(context);
            }
            componentWillUnmount() {
                (0, $ezLwY.disableContext)(context);
            }
            render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BaseComponent, this.props);
            }
        }
        ShortcutContextComponent.displayName = `ShortcutContextComponent(${BaseComponent.displayName || BaseComponent.name})`;
        return ShortcutContextComponent;
    };
}
var $089e60b6c1a73ffc$export$2e2bcd8739ae039 = $089e60b6c1a73ffc$var$shortcutContext;



var $jmjWc = parcelRequire("jmjWc");


const $f05a18473f890654$export$ffff49ea750347f8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "3CTAv",
    name: "StandaloneRestrictedPageOrSpace",
    loader: async ()=>(await (parcelRequire("fmuCC"))).StandaloneRestrictedPageOrSpace
});



var $jwv1p = parcelRequire("jwv1p");


var $arkw6 = parcelRequire("arkw6");


var $3j0Cc = parcelRequire("3j0Cc");


var $4QflW = parcelRequire("4QflW");





var $ba9cbe60fdf9141e$exports = {};

var $bCMS0 = parcelRequire("bCMS0");


var $daAKm = parcelRequire("daAKm");


var $ehlgT = parcelRequire("ehlgT");


var $fPVB6 = parcelRequire("fPVB6");

/**
 * Checks if `string` ends with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=string.length] The position to search up to.
 * @returns {boolean} Returns `true` if `string` ends with `target`,
 *  else `false`.
 * @example
 *
 * _.endsWith('abc', 'c');
 * // => true
 *
 * _.endsWith('abc', 'b');
 * // => false
 *
 * _.endsWith('abc', 'b', 2);
 * // => true
 */ function $ba9cbe60fdf9141e$var$endsWith(string, target, position) {
    string = $fPVB6(string);
    target = $daAKm(target);
    var length = string.length;
    position = position === undefined ? length : $bCMS0($ehlgT(position), 0, length);
    var end = position;
    position -= target.length;
    return position >= 0 && string.slice(position, end) == target;
}
$ba9cbe60fdf9141e$exports = $ba9cbe60fdf9141e$var$endsWith;



var $jzEl8 = parcelRequire("jzEl8");

const $9117dce6b863f439$var$LINKS_TO_BE_REMOVED = [
    '#action-page-permissions-link'
];
const $9117dce6b863f439$var$LINKS_TO_BE_REMOVED_ON_PAGE_INFORMATION = [
    '#page-favourite',
    '#action-menu-link'
];
const $9117dce6b863f439$var$replacedPlaceholder = {
    elementName: 'span',
    attributes: {
        style: `display: none`
    }
};
function $9117dce6b863f439$export$9e2c81a475b5d1b8() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jzEl8.LegacyDOMBridge), {
        selectors: $9117dce6b863f439$var$LINKS_TO_BE_REMOVED,
        attempts: 100,
        retryDelay: 500,
        portalNode: null,
        replacePlaceholderWith: $9117dce6b863f439$var$replacedPlaceholder
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ba9cbe60fdf9141e$exports)))(window.location.pathname, '/pages/viewinfo.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jzEl8.LegacyDOMBridge), {
        selectors: $9117dce6b863f439$var$LINKS_TO_BE_REMOVED_ON_PAGE_INFORMATION,
        attempts: 100,
        retryDelay: 500,
        replacePlaceholderWith: $9117dce6b863f439$var$replacedPlaceholder,
        portalNode: null
    }));
}














var $inPa6 = parcelRequire("inPa6");








const $b82761c2a95901d5$export$18a8a22069631f81 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "kdP2C",
    loader: async ()=>(await (parcelRequire("5qwh1"))).ArchiveSpacePortal,
    name: 'ArchiveSpacePortal'
});






const $e87d969ba20a20a0$export$854f67824ef9311 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "P3ji1",
    loader: async ()=>(await (parcelRequire("2NJWg"))).DeleteSpacePortal,
    name: 'DeleteSpacePortal'
});






const $a6c6b76f924ecb80$export$b4b583c595949768 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BlJ6r",
    name: "LazySpaceSettingsForgeExtensionPortal",
    loader: async ()=>(await (parcelRequire("cq0jI"))).SpaceSettingsForgeExtensionPortal
});
$a6c6b76f924ecb80$export$b4b583c595949768.displayName = 'LazySpaceSettingsForgeExtensionPortal';



var $7QM6o = parcelRequire("7QM6o");


var $feuG2 = parcelRequire("feuG2");





const $b270d87888ab1caf$export$cca256d7c562dc07 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "mTzRP",
    loader: async ()=>(await (parcelRequire("7nmkU"))).SpaceTrashPortal,
    name: 'SpaceTrashPortal'
});






const $d2b3f21ec8a84bb2$export$2c12a08ca2f15d0e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wu877",
    name: "SiteSettingsHelpPanelLink",
    loader: async ()=>(await (parcelRequire("ax8Zf"))).SiteSettingsHelpPanelLink
});






const $406f60e313bf3a3f$export$b52880da76836cd4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "h3QZB",
    name: "BackupManagerButton",
    loader: async ()=>(await (parcelRequire("d1Pi6"))).BackupManagerButton
});



var $14QAi = parcelRequire("14QAi");


var $ep3mz = parcelRequire("ep3mz");

/* PdfBannerPortal.tsx generated by @compiled/babel-plugin v0.36.1 */ 











var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");





var $6mKj3 = parcelRequire("6mKj3");

const $530cf45a0f14746c$var$PDF_BANNER_PORTAL_ID = 'pdf-export-banner-root';
const $530cf45a0f14746c$var$i18n = (0, $cgtv4.defineMessages)({
    bannerMessage: {
        id: "pdf-export.banner.message",
        defaultMessage: "We've received your print request. To maintain your page's format, we're exporting it to a PDF for you to download and print."
    }
});
const $530cf45a0f14746c$var$styles = {
    bannerStyles: "_1yt4pxbi _bfhk1aqn _1bto1l2s _o5721q9c"
};
const $530cf45a0f14746c$var$PdfBanner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $530cf45a0f14746c$var$styles.bannerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.inverse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $530cf45a0f14746c$var$i18n.bannerMessage)));
const $530cf45a0f14746c$export$57cc11a378563774 = ()=>{
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    if (!(0, $6mKj3.expValEquals)('afm-enable-command-p-reroute', 'isEnabled', true)) return null;
     // only inject if ?showPdfBanner=true
    if (queryParams.showPdfBanner !== 'true') return null;
    let targetElement = document.getElementById($530cf45a0f14746c$var$PDF_BANNER_PORTAL_ID); // if the target doesn't exist, create and insert it before <main>
    if (!targetElement) {
        const main = document.querySelector('main#main');
        if (main && main.parentElement) {
            targetElement = document.createElement('div');
            targetElement.id = $530cf45a0f14746c$var$PDF_BANNER_PORTAL_ID;
            main.parentElement.insertBefore(targetElement, main);
        }
    } // if no anchor could be found, bail
    if (!targetElement) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($530cf45a0f14746c$var$PdfBanner, null), targetElement);
};


const $76c1a3880217c32d$var$i18n = (0, $cgtv4.defineMessages)({
    importingTemplates: {
        id: "standalone-navigation.importing.templates",
        defaultMessage: "More about importing templates"
    }
});
const $76c1a3880217c32d$export$fc287ab47b11c4ec = ({ spaceKey: spaceKey, isSpaceSettingsScreen: isSpaceSettingsScreen })=>{
    const { location: { pathname: pathname } } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const spaceId = (0, $7QM6o.useSpaceId)(spaceKey);
    (0, $42omo.useEffect)(()=>{
        const { section: section, screen: screen } = (0, $14QAi.getRouteData)(pathname);
        // We only want analytics for IPH specific routes for now
        if (screen !== 'notTracked') createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: screen,
                attributes: {
                    section: section
                }
            }
        }).fire();
    }, [
        pathname,
        createAnalyticsEvent,
        spaceId
    ]);
    return pathname && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, isSpaceSettingsScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ep3mz.PageStateContainer), {
        spaceKey: spaceKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $feuG2.SpaceSettingsNavigationV2Portal), {
        spaceKey: spaceKey
    })) : null, pathname.includes('/spaces/archivespace.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b82761c2a95901d5$export$18a8a22069631f81), {
        spaceKey: spaceKey,
        pathname: pathname
    }), pathname.includes('/spaces/removespace.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e87d969ba20a20a0$export$854f67824ef9311), {
        spaceKey: spaceKey,
        pathname: pathname
    }), pathname.includes('/pages/viewtrash.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b270d87888ab1caf$export$cca256d7c562dc07), {
        spaceKey: spaceKey
    }), pathname.includes('/templatePackage/configurePlugin.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d2b3f21ec8a84bb2$export$2c12a08ca2f15d0e), {
        articleId: "7p0QTJJI0VkoU49M4GzKH2",
        articleTopic: "admin-import-templates",
        portalTargetId: "site-settings-import",
        buttonContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $76c1a3880217c32d$var$i18n.importingTemplates),
        pathname: pathname,
        routeGroup: "site-settings",
        routeName: "undefined"
    }), pathname.includes('/plugins/servlet/ondemandbackupmanager') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $406f60e313bf3a3f$export$b52880da76836cd4), {
        pathname: pathname
    }), pathname.includes('spaces/flyingpdf/pdfpageexport.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $530cf45a0f14746c$export$57cc11a378563774), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6c6b76f924ecb80$export$b4b583c595949768), {
        spaceKey: spaceKey
    }));
};
// needed for react-proptypes warning
$76c1a3880217c32d$export$fc287ab47b11c4ec.propTypes = {
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    isSpaceSettingsScreen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};


var $7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation;
function $7c0ba11073bcb5f1$var$_defineProperty(e, r, t) {
    return (r = $7c0ba11073bcb5f1$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $7c0ba11073bcb5f1$var$_toPropertyKey(t) {
    var i = $7c0ba11073bcb5f1$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $7c0ba11073bcb5f1$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $7c0ba11073bcb5f1$var$TopNavSpacer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1ule _1bsb1osq _4t3iymf6",
            __cmplp.className
        ])
    });
});
var $7c0ba11073bcb5f1$export$2e2bcd8739ae039 = (0, $089e60b6c1a73ffc$export$2e2bcd8739ae039)('global')(($7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation = class StandaloneConfluenceNavigation extends (0, $42omo.PureComponent) {
    componentDidMount() {
        const { isAdminScreen: isAdminScreen } = this.props; // if admin screen, show content as we mount
        if (isAdminScreen) (0, $8bee1fe38b9eef04$export$4011f4c5a8044281)();
        else setTimeout((0, $8bee1fe38b9eef04$export$4011f4c5a8044281), 300);
        (0, $ge2sX.getSessionData)();
    }
    render() {
        const { isAdminScreen: isAdminScreen, isSpaceSettingsScreen: isSpaceSettingsScreen, isSpaceScreen: isSpaceScreen, route: route, spaceKey: spaceKey } = this.props;
        let navView;
        if ((0, $1dnxO.getIsNav4Enabled)() && isSpaceSettingsScreen) navView = (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID);
        else if (isSpaceSettingsScreen || isSpaceScreen) navView = (0, $4l6Wo.CONTAINER_HOME_ID);
        else if (isAdminScreen) navView = (0, $4l6Wo.ADMIN_HOME_ID);
        else if (route?.name !== (0, $1NBp8.EXTERNAL_SHARE).name) // XXX EXTERNAL_SHARE does not have the typical navigation.
        navView = (0, $4l6Wo.PRODUCT_HOME_ID);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f05a18473f890654$export$ffff49ea750347f8), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $76c1a3880217c32d$export$fc287ab47b11c4ec), {
            spaceKey: spaceKey,
            isSpaceSettingsScreen: isSpaceSettingsScreen
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aeSHO.CopySpacePermissionsForLegacyNewSpace), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3pfAb.default), {
            client: (0, $04e9M.getAnalyticsWebClient)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $39rFu.EditPageLoadingContextProvider), {
            nativeEditorComponentsPreloader: (0, $eXODy.nativeEditorComponentsPreloader),
            livePageComponentsPreloader: (0, $jwv1p.preloadLivePagesComponents)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).DISCO
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iV00x.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJ8K8.Screen), {
            screenEvent: {
                name: 'serverRenderedScreen',
                attributes: {
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            },
            pageState: {
                spaceKey: spaceKey,
                contentId: (0, $iJ8K8.SPACE_OVERVIEW)
            }
        }, navView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hDG7z.PageLayout), {
            view: navView,
            isSpaceSettingsScreen: isSpaceSettingsScreen,
            standalone: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $NAPtM.CreateDialogContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $arkw6.LazyCreateDialogQueryRenderer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3j0Cc.LazyCreateDialogBlueprintWizardRenderer), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4QflW.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eIKcA.default), null), isSpaceSettingsScreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eWwvy.EditSpaceLogo), {
            spaceKey: spaceKey
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9117dce6b863f439$export$9e2c81a475b5d1b8), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cBuRD.NotificationLandedEvent), null)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f60f9bb0af41c642$export$ddc928ad192d2b94), null));
    }
    constructor(...args){
        super(...args);
        $7c0ba11073bcb5f1$var$_defineProperty(this, "spacer", ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7c0ba11073bcb5f1$var$TopNavSpacer, {
                "data-test-id": "top-nav-spacer"
            }));
    }
}, $7c0ba11073bcb5f1$var$_defineProperty($7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation, "displayName", 'StandaloneConfluenceNavigation'), $7c0ba11073bcb5f1$var$_defineProperty($7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation, "propTypes", {
    isAdminScreen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isSpaceScreen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isSpaceSettingsScreen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    route: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string
}), $7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation));


const $fe485fa379bdff14$var$getSpaceKey = (state)=>{
    const routeParams = (0, $iyEDi.getRouteParams)(state);
    return (0, $iyEDi.routerStateExists)(state) && routeParams && routeParams.spaceKey || state.meta.get('space-alias') || state.meta.get('space-key');
};
const $fe485fa379bdff14$var$mapStateToProps = (state, props)=>{
    const { location: location, matchRoute: matchRoute } = props;
    const isSpaceScreen = state.meta.get('is-space-page') === 'true' || (0, $gnnzK.isContentTypeOf)('page', state) || (0, $gnnzK.isContentTypeOf)('blogpost', state);
    //On the DELETE_SPACE_LEGACY path the space is already deleted but certain queries
    //use the spaceKey. Set spaceKey to null if on this path
    const route = matchRoute(`${location.pathname}${location.search}${location.hash}`);
    const spaceKey = route?.name === (0, $1NBp8.DELETE_SPACE_LEGACY).name ? null : $fe485fa379bdff14$var$getSpaceKey(state);
    return {
        isAdminScreen: state.meta.get('is-admin-page') === 'true',
        isSpaceScreen: isSpaceScreen,
        isSpaceSettingsScreen: state.meta.get('is-space-tool-page') === 'true',
        route: route,
        spaceKey: spaceKey
    };
};
var $fe485fa379bdff14$export$2e2bcd8739ae039 = (0, $kFqI2.connect)($fe485fa379bdff14$var$mapStateToProps)((0, $7c0ba11073bcb5f1$export$2e2bcd8739ae039));


/**
 * setupUFOGlobalErrorHandler MUST be the first thing executed before any rendering operations.
 * This ensures we catch and track any errors that occur during the app's initialization,
 * including async operations and React rendering. Moving this call later would risk missing
 * early errors.
 * it provides ufo:errors:globalCount is the count of all errors which occurred on the client all up
 */ (0, $5QpZa.default)();
const $f5e2aff200456a49$var$sessionDataPromise = (async ()=>{
    (0, $hp2SH.getApolloClient)();
    try {
        const sessionData = await (0, $aXEzU.getSessionDataAndInitializeStatsig)();
        // Initialize browser storage controls after Statsig is ready (for proper feature gate evaluation)
        // This must happen before initializeStorageManager
        if ((0, $9wGTI.fg)('confluence_browser_storage_init')) {
            if ((0, $9wGTI.fg)('platform_add_fields_to_bsc_global_state')) await (0, $gznk3.initializeBrowserStorageControls)({
                userId: sessionData.userId,
                cloudId: sessionData.cloudId
            });
            else await (0, $gznk3.initializeBrowserStorageControls)({});
        } else await (0, $68uaC.Cookies).initialize();
        const { userId: userId, isLicensed: isLicensed, monolithRegion: monolithRegion } = sessionData;
        (0, $8PKGr.initializeAggRegionSteeringHint)(monolithRegion);
        (0, $xwvlW.initializePreloaderFnContext)(sessionData);
        await (0, $17wUi.initializeStorageManager)({
            userId: userId,
            isLicensed: isLicensed
        });
        (0, $gnYQc.applyPersistedStatsigOverrides)();
        return sessionData;
    } catch  {
        // For the same reasons as in the non-standalone case documented in the
        // counterpart of this file which is
        // confluence/packages/confluence-frontend-server/src/index.js at the moment
        return (0, $iC5L0.getEmptySessionData)();
    }
})();
const $f5e2aff200456a49$var$translationPromise = (0, $awd1Q.loadTranslation)((0, $7RVQB.lazyLanguage));
Promise.all([
    $f5e2aff200456a49$var$sessionDataPromise,
    $f5e2aff200456a49$var$translationPromise
]).then(([sessionData])=>{
    const browserNotSupportedCheck = (0, $2DVQX.coreBrowserNotSupported)();
    // the only requirement for BrowserNotSupported to render is the translationPromise
    if (browserNotSupportedCheck) {
        // the monolith attaches this id to the body here: confluence-core/confluence-webapp/src/main/webapp/decorators/main.vmd:62
        const documentBody = document.getElementById('com-atlassian-confluence');
        // eslint-disable-next-line react/no-deprecated
        return void (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9j59h.BrowserNotSupportedLoader), null), documentBody);
    }
    (0, $7LuKf.initialization)(sessionData);
    (0, $8bee1fe38b9eef04$export$ed04e7f6ba662aee)();
    (0, $d4f95b5cede9219f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6baa9171970034d$export$11eb671888ed6e7d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ location: location, matchRoute: matchRoute })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fe485fa379bdff14$export$2e2bcd8739ae039), {
            apolloClient: (0, $hp2SH.getApolloClient)(),
            location: location,
            matchRoute: matchRoute
        }))), 'ui-global-sidebar-section', true);
});
 }, ["7EorR","2gTex","fQqwz","aZinD","eiF7i","hhss7","ffEVr","1yVM6","1qlDN","5pvpJ","6XCf4","cEqm7","6wr18"]);

$parcel$global.rlb("3pblT")
//# sourceMappingURL=standalone-navigation-jquery3.6b09e814.js.map
